// "ResearchData.js"

export const artigosSelecionados  = [
  {
    title: "Development of a standardized methodology for transfer learning with QSAR models: a purely data-driven approach for source task selection",
    authors: "Melo, L., Scotti, L., & Scotti, M. T.",
    reference: "SAR and QSAR in Environmental Research, 35(3), 183–198, 2024.",
    doi: "https://doi.org/10.1080/1062936X.2024.2311693",
  },
  {
    title: "MuDRA-Based Virtual Screening of Terpenes for Anti-Leishmania Infantum Activity: In Vitro Validation and Mechanistic Insights from Molecular Docking",
    authors: "Barros de Menezes RP, Ferreira de Sousa N, Herrera-Acevedo C, Santos Aquino de Araújo R, Durand Trigueiro Lira N, Fechine Tavares J, Jorge Kato M, Alex da Rocha Coelho F, Sousa Dos Santos AL, Antonio da Franca Rodrigues K, Bezerra Mendonça-Júnior FJ, Scotti L, Tullius Scotti M.",
    reference: "ChemMedChem, 2024 Oct 30:e202400743.",
    doi: "https://doi.org/10.1002/cmdc.202400743",
  },
  {
    title: "MolPredictX: Online Biological Activity Predictions by Machine Learning Models",
    authors: "Tullius Scotti, Marcus; Herrera'acevedo, Chonny ; Barros De Menezes, Renata Priscila ; Martin, Holli'joi ; Muratov, Eugene N. ; Ítalo De Souza Silva, Ávilla ; Faustino Albuquerque, Emmanuella ; Ferreira Calado, Lucas ; Coy'barrera, Ericsson ; Scotti., Luciana",
    reference: "Molecular Informatics, v. 41, p. 2200133, 2022.",
    doi: "https://doi.org/10.1002/minf.202200133",
  },
  {
    title: "The SistematX Web Portal of Natural Products: An Update",
    authors: "Costa, Renan P. O. ; Lucena, Lucas F. ; Silva, Lorena Mara A. ; Zocolo, Guilherme Julião ; Herrera-Acevedo, Chonny ; Scotti, Luciana ; Da-Costa, Fernando Batista ; Ionov, Nikita ; Poroikov, Vladimir ; Muratov, Eugene N. ; Scotti, Marcus T.",
    reference: "Journal Of Chemical Information And Modeling (ONLINE), v. 61, p. 2516-2522, 2021.",
    doi: "https://doi.org/10.1021/acs.jcim.1c00083",
  },
  {
    title: "AmIActive (AIA): A Large-scale QSAR Based Target Fishing and Polypharmacology Predictive Web Tool",
    authors: "de Morais Melo, Luis Felipe;  de Oliveira Filho, Luciano Pereira; de Assis Ferreira, Uilames; Pessoa Alves, Eduardo Henrique; Oliveira Costa, Renan Paiva; Scotti, Luciana; Scotti, Marcus T.",
    reference: "Journal of Molecular Biology, 169090, 2025.",
    doi: "https://doi.org/10.1016/j.jmb.2025.169090",
  },
  {
    title: "Machine learning models to select potential inhibitors of acetylcholinesterase activity from SistematX: a natural products database",
    authors: "Herrera-Acevedo, Chonny ; Perdomo-Madrigal, Camilo ; Herrera-Acevedo, Kenyi ; Coy-Barrera, Ericsson ; Scotti, L. ; Scotti, Marcus Tullius",
    reference: "Molecular Diversity, v. 2021, p. 1553-1568, 2021.",
    doi: "https://doi.org/10.1007/s11030-021-10245-z",
  },
];
  
  export const livrosPublicados  = [
    {
      title: "Drug Target Selection and Validation",
      authors: "SCOTTI, MT; BELLERA, C. L. (Org.)",
      reference: "Cham: Springer, 2022. v. 1. 257p",
      doi: "http://dx.doi.org/10.1007/978-3-030-95895-4",
    },
    {
      title: "Pharmaceuticals for Targeting Coronaviruses",
      authors: "SCOTTI, LUCIANA; Scotti, Marcus T. (Org.)",
      reference: "Bentham Science Publisher: NY, 2022. v. 1. 195p",
      doi: "http://dx.doi.org/10.2174/97898150513081220101",
    },
  ];
  
  export const chapters = [
    {
      title: "Drug Discovery Paradigms: Target-Based Drug Discovery",
      authors: "HERRERA-ACEVEDO, CHONNY ALEXANDER ; PERDOMO-MADRIGAL, CAMILO ; ... ; SCOTTI, MT",
      reference: `In: Marcus Tullius Scotti; Carolina L. Bellera. (Org.). Drug Target Selection and Validation. 1ed.Cham: Springer, 2022, v. 1, p. 4-24.`,
      doi: "http://dx.doi.org/10.1007/978-3-030-95895-4_1",
    },
    {
      title: "Infections Caused by SARS: Main Characteristics, Targets and Inhibitors",
      authors: "DE MEDEIROS, HERBERT IGOR RODRIGUES ; SOARES RODRIGUES, GABRIELA CRISTINA ; ... ; Scotti, L.",
      reference: `In: Luciana Scotti; Marcus Tullius Scotti. (Org.). Pharmaceuticals for Targeting Coronaviruses. 1ed.New York: Bentham Science Publisher, 2022, v. 1, p. 95-137.`,
      doi: "http://dx.doi.org/10.2174/9789815051308122010005",
    },
    {
      title: "The Use and Evolution of Web Tools for Aquatic Toxicology Studies",
      authors: "BARROS, RENATA PRISCILA COSTA ; Sousa, Natália F. ; ... ; SCOTTI, M. T.",
      reference: `In: Kunal Roy. (Org.). Chemometrics and Cheminformatics in Aquatic Toxicology. 1ed.Hoboken: Wiley, 2021, v. 1, p. 473-492.`,
      doi: "http://dx.doi.org/10.1002/9781119681397.ch24",
    },
    {
      title: "Use of Machine Learning and Classical QSAR Methods in Computational Ecotoxicology",
      authors: "BARROS, RENATA P. C. ; Sousa, Natália F. ; SCOTTI, LUCIANA ; Scotti, Marcus T.",
      reference: `In: Kunal Roy. (Org.). Methods in Pharmacology and Toxicology. 1ed.New York: Springer US, 2020, v. , p. 151-175.`,
      doi: "http://dx.doi.org/10.1007/978-1-0716-0150-1_7",
    },
    {
      title: "In Silico Studies Applied to Natural Products with Potential Activity Against Alzheimer’s Disease",
      authors: "SCOTTI, LUCIANA; Scotti, Marcus T.",
      reference: `In: Kunal Roy. (Org.). Neuromethods. 1ed.New York: Springer New York, 2018, v. 132, p. 513-531.`,
      doi: "http://dx.doi.org/10.1007/978-1-4939-7404-7_18",
    },
    {
      title: "Molecular Docking Studies in Multitarget Antitubercular Drug Discovery. Methods in Pharmacology and Toxicology",
      authors: "de Oliveira Viana, Jéssika ; Scotti, Marcus T. ; SCOTTI, LUCIANA",
      reference: `Methods in Pharmacology and Toxicology. 1ed.: Springer New York, 2018, v. , p. 107-154.`,
      doi: "http://dx.doi.org/10.1007/7653_2018_28",
    },
  ];
  
  export const allPublications = [
    {
      year: 2025,
      list: [
        {
          title: "Computer-Aided Drug Design Studies in Association with in vitro Antileishmanial Tests for New Chalcones.",
          authors: "DA SILVA, GLEICE ; SANTOS, FRANCISNAIRA ; LEITE, FERNANDO ; ACEVEDO, CHONNY ; DE SOUSA, NATÁLIA ; GRIMALDI, GABRIELA ; SOARES, MILENA ; GUIMARÃES, ELISALVA ; SCOTTI, Marcus Tullius ; Rodrigues, Luis Cezar ; MENDONÇA JÚNIOR, FRANCISCO ; CAMPANA, ELOÍSA ; BARBOSA-FILHO, J.M. ; GUIMARÃES, HEMERSON ; GUERRA, FELIPE",
          reference: "JOURNAL OF THE BRAZILIAN CHEMICAL SOCIETY (ONLINE), p. e-20240135, 2025",
          doi: "http://dx.doi.org/10.21577/0103-5053.20240135"
        },
        {
          title: "3D-QSAR, Pharmacophore Modeling, ADMET and DFT Studies of Halogenated Conjugated Dienones as Potent MAO-B Inhibitors.",
          authors: "MATHEW, GITHA ELIZABETH ; HERRERA-ACEVEDO, CHONNY ; SCOTTI, Marcus Tullius ; KUMAR, SUNIL ; BERISHA, AVNI ; KAYA, SAVA' ; ALFARRAJ, SALEH ; ANSARI, MOHAMMAD JAVED ; DHYANI, ARCHANA ; SUDEVAN, SACHITHRA THAZHATHUVEEDU ; KUMAR, MOHAN ; MATHEW, BIJO",
          reference: "Current Computer-Aided Drug Design, v. 21, p. 179-193, 2025",
          doi: "http://dx.doi.org/10.2174/0115734099307062240801053329"
        }
      ]
    },
    {
      year: 2024,
      list: [
        {
          title: "In silico Studies on Natural Products and Derivatives against DifferentTypes of Cancer.",
          authors: "SCOTTI, L. ; MESSIAS MONTEIRO, ALEX FRANCE ; DA SILVA, FÁBIA MARTINS ; LUSTOZA RODRIGUES, TERESA CAROLLINY MOREIRA ; RAMOS, CLÉCIO SOUSA ; SCOTTI, Marcus Tullius",
          reference: "CURRENT MEDICINAL CHEMISTRY, v. 31, p. 825-847, 2024",
          doi: "http://dx.doi.org/10.2174/0929867330666230614153430"
        },
        {
          title: "Mechanisms Involved in the Therapeutic Effect of CannabinoidCompounds on Gliomas: A Review with Experimental Approach.",
          authors: "PIRES, HUGO FERNANDES OLIVEIRA ; DA SILVA, PABLO RAYFF ; DIAS, ARTHUR LINS ; DE SOUSA GOMES, CLEYTON ; DE SOUSA, NATÁLIA FERREIRA ; DOS SANTOS, ALINE MATILDE FERREIRA ; SOUZA, LÍVIA ROBERTA PIMENTA ; DE FIGUEIREDO LIMA, JAISLÂNIA LUCENA ; OLIVEIRA, MAYARA CECILE NASCIMENTO ; FELIPE, CÍCERO FRANCISCO BEZERRA ; DE ALMEIDA, REINALDO NÓBREGA ; DE CASTRO, RICARDO DIAS ; DA SILVA STIEBBE SALVADORI, MIRIAN GRACIELA ; SCOTTI, Marcus Tullius ; SCOTTI, L.",
          reference: "CURRENT PROTEIN & PEPTIDE SCIENCE, v. 25, p. 27-43, 2024",
          doi: "http://dx.doi.org/10.2174/1389203724666230830125423"
        },
        {
          title: "Multitargeted molecular docking and dynamics simulation studies of flavonoids and volatile components from the peel of L. (Osbeck) against specific tumor protein markers.",
          authors: "RAJIV GANDHI, GOPALSAMY ; SHARANYA, CHELANKARA SURESH ; JAYANANDAN, ABHITHAJ ; HARIDAS, MADATHILKOVILAKATH ; EDWIN HILLARY, VARGHESE ; RAJIV GANDHI, SATHIYABAMA ; SRIDHARAN, GURUNAGARAJAN ; SIVASUBRAMANIAN, RENGARAJU ; SILVA VASCONCELOS, ALAN BRUNO ; MONTALVÃO, MONALISA MARTINS ; ANTONY CEASAR, STANISLAUS ; SOUSA, NATÁLIA FERREIRA DE ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS ; GURGEL, RICARDO QUEIROZ ; QUINTANS-JÚNIOR, LUCINDO JOSÉ",
          reference: "JOURNAL OF BIOMOLECULAR STRUCTURE & DYNAMICS, v. 42, p. 3051-3080, 2024",
          doi: "http://dx.doi.org/10.1080/07391102.2023.2212062"
        },
        {
          title: "Synergistic effect of new pyrimidine derivative with oxacilin against methicillin-resistantStaphylococcus aureus.",
          authors: "DE OLIVEIRA SILVA, BRUNA KELLY ; DO MONTE, ZENAIDE SEVERINA ; SANTOS COSTA, ERICK CAIQUE ; SILVA, RICARDO OLIVEIRA ; SOUZA, NATÁLIA FERREIRA ; BARROS, R. P. C. ; SCOTTI, Marcus Tullius ; SCOTTI, LUCIANA ; DE SOUZA LIMA, GLÁUCIA MANOELLA ; DE MELO, SEBASTIÃO JOSÉ",
          reference: "Future Medicinal Chemistry, v. 16, p. 1839-1852, 2024",
          doi: "http://dx.doi.org/10.1080/17568919.2024.2385887"
        },
        {
          title: "AMTAC-19, a Spiro-Acridine Compound, Induces In Vitro Antitumor Effect via the ROS-ERK/JNK Signaling Pathway.",
          authors: "SOUSA, VALGRÍCIA MATIAS DE ; DUARTE, SÂMIA SOUSA ; FERREIRA, RAFAEL CARLOS ; SOUSA, NATÁLIA FERREIRA DE ; SCOTTI, Marcus Tullius ; SCOTTI, L. ; Silva, Marcelo Sobral da ; TAVARES, JOSEAN FECHINE ; MOURA, RICARDO OLÍMPIO DE ; GONÇALVES, JUAN CARLOS RAMOS ; SOBRAL, MARIANNA VIEIRA",
          reference: "MOLECULES, v. 29, p. 5344, 2024",
          doi: "http://dx.doi.org/10.3390/molecules29225344"
        },
        {
          title: "Compounds Multi-targets against Neglected Diseases.",
          authors: "SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "CURRENT DRUG TARGETS, v. 25, p. 575-576, 2024",
          doi: "http://dx.doi.org/10.2174/138945012509240724145557"
        },
        {
          title: "In vitroandin silicoevaluation of the anti-leishmania activity of synthetic chalcones.",
          authors: "LEITE, FERNANDO FERREIRA ; RODRIGUES, LUIS CEZAR ; OLIVEIRA, BRUNO HANRRY MELO DE ; DUARTE, GABRIELLY DINIZ ; LEITE FERREIRA, MARIA DENISE ; SOUSA, NATÁLIA FERREIRA DE ; VANDERLEY, SHAYENNE EDUARDA RAMOS ; CARDOSO, LEONARDO LIMA ; KEESEN, TATJANA SOUZA LIMA ; ARAÚJO, RODRIGO SANTOS AQUINO DE ; SCOTTI, L. ; SCOTTI, Marcus Tullius ; MENDONÇA-JUNIOR, FRANCISCO JAIME BEZERRA",
          reference: "NATURAL PRODUCTS RESEARCH, p. 1-12, 2024",
          doi: "http://dx.doi.org/10.1080/14786419.2024.2401499"
        },
        {
          title: "In Silico and In Vitro Evaluation of the Antifungal Activity of a New Chromone Derivative against Candida spp..",
          authors: "ARAÚJO, GLEYCYELLY RODRIGUES ; COSTA, PALLOMA CHRISTINE QUEIROGA GOMES DA ; NOGUEIRA, PAULA LIMA ; ALVES, DANIELLE DA NÓBREGA ; FERREIRA, ALANA RODRIGUES ; DA SILVA, PABLO R. DA ; DE ANDRADE, JÉSSICA CABRAL DE ; DE SOUSA, NATÁLIA F. DE ; LOUREIRO, PAULO BRUNO ARAUJO ; SOBRAL, MARIANNA VIEIRA ; SOUSA, DAMIÃO P. ; SCOTTI, Marcus Tullius ; DE CASTRO, RICARDO DIAS DE ; SCOTTI, L.",
          reference: "Biotech, v. 13, p. 16, 2024",
          doi: "http://dx.doi.org/10.3390/biotech13020016"
        },
        {
          title: "In Silico and In Vitro Studies of Terpenes from the Fabaceae Family Using the Phenotypic Screening Model against the SARS-CoV-2 Virus.",
          authors: "DE SOUSA, NATÁLIA FERREIRA ; DUARTE, GABRIELLY DINIZ ; MORAES, CAROLINA BORSOI ; BARBOSA, CECÍLIA GOMES ; MARTIN, HOLLI-JOI ; MURATOV, NAIL N. ; NASCIMENTO, YURI MANGUEIRA DO ; SCOTTI, L. ; DE FREITAS-JÚNIOR, LÚCIO HOLANDA GONDIM ; FILHO, JOSÉ MARIA BARBOSA ; SCOTTI, Marcus Tullius",
          reference: "PHARMACEUTICS, v. 16, p. 912, 2024",
          doi: "http://dx.doi.org/10.3390/pharmaceutics16070912"
        },
        {
          title: "Multi-target Phenylpropanoids Against Epilepsy.",
          authors: "RODRIGUES, TERESA CAROLLINY MOREIRA LUSTOZA ; DIAS, ARTHUR LINS ; DOS SANTOS, ALINE MATILDE FERREIRA ; MONTEIRO, ALEX FRANCE MESSIAS ; OLIVEIRA, MAYARA CECILE NASCIMENTO ; PIRES, HUGO FERNANDES OLIVEIRA ; DE SOUSA, NATÁLIA FERREIRA ; SALVADORI, MIRIAN GRACIELA DA SILVA STIEBBE ; SCOTTI, Marcus Tullius ; SCOTTI, L.",
          reference: "Current Neuropharmacology, v. 22, p. 2168-2190, 2024",
          doi: "http://dx.doi.org/10.2174/1570159x22666240524160126"
        },
        {
          title: "Recent Medicinal Chemistry Studies on Neglected Diseases.",
          authors: "SCOTTI, Marcus Tullius; SCOTTI, L.",
          reference: "COMBINATORIAL CHEMISTRY & HIGH THROUGHPUT SCREENING, v. 27, p. 2463-2463, 2024",
          doi: "http://dx.doi.org/10.2174/138620732717240703150929"
        },
        {
          title: "Inhibitory Effects of Mangifera indica Secondary Metabolites and Their Synthetic Derivatives against SARS-CoV-2 M pro and NS2B/NS3 (ZIKV and DENV-2).",
          authors: "B. SOUZA, GABRIELLA ; M. PONTES, CARIME L. ; DE O. COSTA, GEOVANNA ; F. DE SOUSA, NATÁLIA ; TIZZIANI, TIAGO ; E. POLLO, LUIZ ANTONIO ; DAMBRÓS, BIBIANA P. ; Scotti, Marcus T. ; STEINDEL, MARIO ; BRAGA, ANTONIO L. ; SCHIRMEISTER, TANJA ; F. DE ASSIS, FRANCISCO ; SANDJO, LOUIS P.",
          reference: "ACS Omega, v. 9, p. 44624-44638, 2024",
          doi: "http://dx.doi.org/10.1021/acsomega.4c07148"
        },
        {
          title: "Jatropha Diterpenes: An Updated Review Concerning Their Structural Diversity, Therapeutic Performance, and Future Pharmaceutical Applications.",
          authors: "SOUZA, THALISSON A. DE ; PEREIRA, LUIZ H. A. ; ALVES, ALAN F. ; DOURADO, DOUGLAS ; LINS, JOCIANO DA S. ; Scotti, Marcus T. ; Scotti, Luciana ; ABREU, LUCAS S. ; Tavares, Josean F. ; SILVA, MARCELO S.",
          reference: "PHARMACEUTICALS, v. 17, p. 1399, 2024",
          doi: "http://dx.doi.org/10.3390/ph17101399"
        },
        {
          title: "The Multitarget Action of Vitamins in the Ischemic Stroke.",
          authors: "SCOTTI, LUCIANA; DA SILVA, PABLO RAYFF ; MONTEIRO, ALEX FRANCE M. ; DE ARAÚJO, RODRIGO SANTOS AQUINO ; DO NASCIMENTO, VANESSA LIMA ; MONTEIRO, KADJA LUANA CHAGAS ; DE AQUINO, THIAGO MENDONÇA ; DOS SANTOS SILVA, WADJA FEITOSA ; DA SILVA JUNIOR, EDEILDO FERREIRA ; SCOTTI, MARCUS T. ; MENDONÇA JUNIOR, FRANCISCO JAIME BEZERRA",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 24, p. 2465-2488, 2024",
          doi: "http://dx.doi.org/10.2174/0115680266316939240909070627"
        },
        {
          title: "Synthesis, in vitro and in silico evaluation of gallamide and selenogallamide derivatives as inhibitors of the SARS-CoV-2 main protease.",
          authors: "CARVALHO, MARYELLE A. G. DE ; SOUZA, GABRIELLA B. ; TIZZIANI, TIAGO ; PONTES, CARIME L. M. ; DAMBRÓS, BIBIANA P. ; SOUSA, NATÁLIA F. DE ; Scotti, Marcus T. ; STEINDEL, MARIO ; BRAGA, ANTONIO L. ; SANDJO, LOUIS P. ; ASSIS, FRANCISCO F. DE",
          reference: "ARCHIV DER PHARMAZIE, v. 357, p. e2400253, 2024",
          doi: "http://dx.doi.org/10.1002/ardp.202400253"
        },
        {
          title: "Computational and ADMET Predictions of Novel Compounds as Dual Inhibitors of BuChE and GSK-3β to Combat Alzheimer?s Disease.",
          authors: "LONDHE, SAURABH G. ; WALHEKAR, VINAYAK ; SHENOY, MANGALA ; KINI, SUVARNA G. ; Scotti, Marcus T. ; Scotti, Luciana ; KUMAR, DILEEP",
          reference: "PHARMACEUTICS, v. 16, p. 991, 2024",
          doi: "http://dx.doi.org/10.3390/pharmaceutics16080991"
        },
        {
          title: "Antihyperalgesic effect of γ-terpinene complexed in β-cyclodextrin on neuropathic pain model induced by tumor cells.",
          authors: "PINA, LÍCIA T.S. ; RABELO, THALLITA K. ; BORGES, LYSANDRO P. ; S. S. GONÇALVES, VITÓRIA ; SILVA, AKLEYTON S. ; OLIVEIRA, MARLANGE A. ; S. S. QUINTANS, JULLYANA ; QUINTANS JÚNIOR, LUCINDO J. ; SCOTTI, LUCIANA ; SCOTTI, MARCUS T. ; DA SILVA JÚNIOR, EVANDRO G. ; DOUGLAS MELO COUTINHO, HENRIQUE ; GUIMARÃES, ADRIANA G.",
          reference: "INTERNATIONAL JOURNAL OF PHARMACEUTICS, v. 662, p. 124538, 2024",
          doi: "http://dx.doi.org/10.1016/j.ijpharm.2024.124538"
        },
        {
          title: "Multitarget Compounds for Neglected Diseases: A Review.",
          authors: "DE SOUSA, NATÁLIA FERREIRA ; DE SOUSA, GABRIELA RIBEIRO ; DE LIMA, NATANAEL TELES RAMOS ; DE ASSIS, EDILEUZA BEZERRA ; ARAGÃO, MARIANA COSTA ; DE MOURA, ÉRIKA PAIVA ; GOPALSAMY, RAJIV GANDHI ; SCOTTI, Marcus Tullius ; Scotti, Luciana",
          reference: "CURRENT DRUG TARGETS, v. 25, p. 577-601, 2024",
          doi: "http://dx.doi.org/10.2174/0113894501298864240627060247"
        },
        {
          title: "Anticonvulsant activity of Tetrahydrolinalool: behavioral, electrophysiological, and molecular docking approaches.",
          authors: "FONSÊCA, DIOGO V. ; DA SILVA, PABLO R. ; PIRES, HUGO F. O. ; ROCHA, JULIANA S. ; DE OLIVEIRA, LEANDRA EUGÊNIA G. ; REIS, FLAVIA M. S. ; CAVALHO, ERIKA B. M. ; PAZOS, NATALIA D. N. ; DE SOUSA, NATÁLIA F. ; GUEDES, ERIKA C. ; RIBEIRO, LEANDRO R. ; DE CASSIA S. SÁ, RITA ; SALVADORI, MIRIAN G. S. S. ; SOUSA, DAMIÃO P. ; Scotti, Marcus T. ; FELIPE, CICERO F. B. ; DE ALMEIDA, REINALDO N. ; Scotti, Luciana",
          reference: "CHEMMEDCHEM (INTERNET), v. 19, p. e202400135, 2024",
          doi: "http://dx.doi.org/10.1002/cmdc.202400135"
        },
        {
          title: "Abietane Diterpenes from Medusantha martiusii and Their Anti-Neuroinflammatory Activity.",
          authors: "ASSIS, EDILEUZA B. DE ; ANDRADE, RODRIGO S. DE ; SILVA, JOANDA P. R. E ; MARTORANO, LUCAS H. ; AMORIM, GERALDO M. W. ; LOUREIRO, PAULO B. A. ; ABREU, LUCAS S. ; SOBRAL, MARIANNA V. ; Scotti, Marcus T. ; SANTOS JUNIOR, FERNANDO M. DOS ; AGRA, Maria de Fátima ; Tavares, Josean F. ; SILVA, MARCELO S. DA",
          reference: "MOLECULES, v. 29, p. 2723, 2024",
          doi: "http://dx.doi.org/10.3390/molecules29122723"
        },
        {
          title: "Inhibition of the morphological transition of Candida spp. by riparins I-IV.",
          authors: "QUEIROZ DA SILVA, MARIA LUCILENE ; FERREIRA DE SOUSA, NATÁLIA ; DOS SANTOS, ANTONIA THASSYA LUCAS ; DE SOUSA, GABRIELA RIBEIRO ; FONSECA, VICTOR JUNO ALENCAR ; DOUGLAS MELO COUTINHO, HENRIQUE ; BARBOSA FILHO, JOSÉ MARIA ; DE SOUZA FERRARI, JAILTON ; SCOTTI, Marcus Tullius ; RIBEIRO'FILHO, JAIME ; MARTINS DE LIMA, JOÃO PAULO ; DA ROCHA, JOÃO BATISTA TEIXEIRA ; BEZERRA MORAIS'BRAGA, MARIA FLAVIANA",
          reference: "FUNDAMENTAL & CLINICAL PHARMACOLOGY, v. 38, p. 946-957, 2024",
          doi: "http://dx.doi.org/10.1111/fcp.13007"
        },
        {
          title: "In vitro inhibitory activity of Riparins against Candida spp. strains and in silico interaction with multi-drug-resistance proteins.",
          authors: "DA SILVA, MARIA LUCILENE QUEIROZ ; DE SOUSA, GABRIELA RIBEIRO ; DE SOUSA, NATÁLIA FERREIRA ; DOS SANTOS, ANTONIA THASSYA LUCAS ; COUTINHO, HENRIQUE DOUGLAS MELO ; FILHO, JOSÉ MARIA BARBOSA ; DE SOUZA FERRARI, JAILTON ; SCOTTI, Marcus Tullius ; DA ROCHA, JOÃO BATISTA TEIXEIRA ; MORAIS-BRAGA, MARIA FLAVIANA BEZERRA",
          reference: "PROCESS BIOCHEMISTRY, v. 142, p. 46-61, 2024",
          doi: "http://dx.doi.org/10.1016/j.procbio.2024.04.005"
        },
        {
          title: "Myrtucommulones and Related Acylphloroglucinols from Myrtaceae as a Promising Source of Multitarget SARS-CoV-2 Cycle Inhibitors.",
          authors: "MENDONÇA, SIMONY CARVALHO ; GOMES, BRENDO ARAUJO ; CAMPOS, MARIANA FREIRE ; DA FONSECA, THAMIRYS SILVA ; ESTEVES, MARIA EDUARDA ALVES ; ANDRIOLO, BRUCE VEIGA ; CHEOHEN, CAIO FELIPE DE ARAUJO RIBAS ; CONSTANT, LARISSA ESTEVES CARVALHO ; DA SILVA COSTA, STEPHANY ; CALIL, PEDRO TELLES ; TUCCI, AMANDA RESENDE ; OLIVEIRA, THAMARA KELCYA FONSECA DE ; ROSA, ALICE DOS SANTOS ; FERREIRA, VIVIAN NEUZA DOS SANTOS ; LIMA, JULIA NILO HENRIQUE ; MIRANDA, MILENE DIAS ; DA COSTA, LUCIANA JESUS ; DA SILVA, MANUELA LEAL ; SCOTTI, Marcus Tullius ; ALLONSO, DIEGO ; et.al",
          reference: "PHARMACEUTICALS, v. 17, p. 436, 2024",
          doi: "http://dx.doi.org/10.3390/ph17040436"
        },
        {
          title: "Asclepiadoideae subfamily (Apocynaceae): ethnopharmacology, biological activities and chemophenetics based on pregnane glycosides.",
          authors: "DE SOUZA, THALISSON AMORIM ; LINS, FRANCISCA SABRINA VIEIRA ; DA SILVA LINS, JOCIANO ; ALVES, ALAN FERREIRA ; CIBULSKI, SAMUEL PAULO ; BRITO, THIAGO DE ARAÚJO MEDEIROS ; ABREU, LUCAS SILVA ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS ; DA SILVA, MARCELO SOBRAL ; Tavares, Josean Fechine",
          reference: "Phytochemistry Reviews, v. 23, p. 1027-1063, 2024",
          doi: "http://dx.doi.org/10.1007/s11101-024-09914-2"
        },
        {
          title: "Multitarget anti-parasitic activities of isoquinoline alkaloids isolated from Hippeastrum aulicum (Amaryllidaceae).",
          authors: "BESSA, CARLIANI DAL PIERO BETZEL ; FEU, AMANDA EIRIZ ; DE MENEZES, RENATA PRISCILA BARROS ; SCOTTI, Marcus Tullius ; LIMA, JULIA MARIA GODOI ; LIMA, MARTA LOPES ; TEMPONE, ANDRE GUSTAVO ; DE ANDRADE, JEAN PAULO ; BASTIDA, JAUME ; BORGES, WARLEY DE SOUZA",
          reference: "PHYTOMEDICINE, v. 128, p. 155414, 2024",
          doi: "http://dx.doi.org/10.1016/j.phymed.2024.155414"
        },
        {
          title: "APRENDIZADO DE MÁQUINA APLICADO A QSAR.",
          authors: "DE MENEZES, RENATA ; SCOTTI, LUCIANA ; SCOTTI, MARCUS",
          reference: "QUÍMICA NOVA (ONLINE), v. 47, p. e-20240024, 2024",
          doi: "http://dx.doi.org/10.21577/0100-4042.20240024"
        },
        {
          title: "Natural Phenolic Compounds with Antithrombotic and AntiplateletEffects: A Drug-likeness Approach.",
          authors: "FERNANDES, DIÉGINA ARAÚJO ; GOMES, AYALA NARA PEREIRA ; DA SILVA, CAMILA MACAUBAS ; DE MEDEIROS HENRIQUES, ISABELLY SOARES ; DE MENEZES, RENATA PRISCILA BARROS ; SCOTTI, Marcus Tullius ; TELES, YANNA CAROLINA FERREIRA ; EDRADA-EBEL, RUANGELIE ; DE FATIMA VANDERLEI DE SOUZA, MARIA",
          reference: "CURRENT MEDICINAL CHEMISTRY, v. 31, p. 4138-4159, 2024",
          doi: "http://dx.doi.org/10.2174/0109298673268452231108061008"
        },
        {
          title: "First Description of Marinoquinoline Derivatives? Activity against Toxoplasma gondii.",
          authors: "DIETHELM, LUIZA TAMIE HIRATA ; RAMOS, AMANDA BRUNO DA SILVA BELLINI ; DE LORENA, GIOVANNA BRAGA ; TRAJANO, BRUNA INÁCIO ; DO ESPÍRITO SANTO, RAFAEL DIAS ; DE MENEZES, RENATA PRISCILA BARROS ; SCOTTI, Marcus Tullius ; COLOMBO, FABIO ANTONIO ; MARQUES, MARCOS JOSÉ ; CORREIA, CARLOS ROQUE DUARTE ; REIMÃO, JULIANA QUERO",
          reference: "PHARMACEUTICS, v. 16, p. 262, 2024",
          doi: "http://dx.doi.org/10.3390/pharmaceutics16020262"
        },
        {
          title: "Inhibitory effects against SARSCoV-2 main protease (Mpro) of biflavonoids and benzophenones from the fruit of Platonia insignis.",
          authors: "MOREIRA COSTA, MONALISA A. ; DE SOUSA, NATÁLIA F. ; MANSUR PONTES, CARIME L. ; Scotti, Marcus T. ; DE ASSIS, FRANCISCO F. ; BRAGA, ANTONIO L. ; SANDJO, LOUIS P.",
          reference: "FITOTERAPIA, v. 173, p. 105784, 2024",
          doi: "http://dx.doi.org/10.1016/j.fitote.2023.105784"
        },
        {
          title: "An In Silico Approach to Exploring the Antinociceptive BiologicalActivities of Linalool and its Metabolites.",
          authors: "DA SILVA, PABLO RAYFF ; NUNES PAZOS, NATALIA DINIZ ; DE ANDRADE, JÉSSICA CABRAL ; DE SOUSA, NATÁLIA FERREIRA ; OLIVEIRA PIRES, HUGO FERNANDES ; DE FIGUEIREDO LIMA, JAISLÂNIA LUCENA ; DIAS, ARTHUR LINS ; DA SILVA STIEBBE SALVADORI, MIRIAN GRACIELA ; DE OLIVEIRA GOLZIO, ADRIANA MARIA FERNANDES ; DE CASTRO, RICARDO DIAS ; Scotti, Marcus T. ; PATIL, VAISHALI M. ; BEZERRA FELIPE, CÍCERO FRANCISCO ; DE ALMEIDA, REINALDO NÓBREGA ; Scotti, Luciana",
          reference: "MINI-REVIEWS IN MEDICINAL CHEMISTRY, v. 24, p. 1556-1574, 2024",
          doi: "http://dx.doi.org/10.2174/0113895575261945231122062659"
        },
        {
          title: "Machine-Learning- and Structure-Based Virtual Screening for Selecting Cinnamic Acid Derivatives as Leishmania major DHFR-TS Inhibitors.",
          authors: "MUÑOZ-VEGA, MARIA CAMILA ; LÓPEZ-HERNÁNDEZ, SOFÍA ; SIERRA-CHAVARRO, ADRIÁN ; SCOTTI, Marcus Tullius ; Scotti, Luciana ; COY-BARRERA, ERICSSON ; HERRERA-ACEVEDO, CHONNY",
          reference: "MOLECULES, v. 29, p. 179, 2024",
          doi: "http://dx.doi.org/10.3390/molecules29010179"
        },
        {
          title: "Enzymatic Targets in the Anticancer Drug Discovery.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
          reference: "CURRENT PROTEIN & PEPTIDE SCIENCE, v. 25, p. 3-3, 2024",
          doi: "http://dx.doi.org/10.2174/138920372501240109145132"
        },
        {
          title: "Challenges of Natural Anticancer and Anti-inflammatory Agents.",
          authors: "Scotti, Marcus T.; Scotti, Luciana",
          reference: "CURRENT MEDICINAL CHEMISTRY, v. 31, p. 796-798, 2024",
          doi: "http://dx.doi.org/10.2174/092986733107230918161453"
        },
        {
          title: "ALCALOIDES SESQUITERPÊNICOS ISOLADOS DE Maytenus distichophylla (CELASTRACEAE).",
          authors: "DE FIGUEIREDO, PEDRO THIAGO ; DUARTE, MARCELO ; CORDEIRO, LAÍSA ; MENEZES, RENATA ; LIMA, EDELTRUDES ; SCOTTI, MARCUS ; TAVARES, JOSEAN ; COSTA, VICENTE ; DA SILVA, MARCELO",
          reference: "QUÍMICA NOVA (ONLINE), v. 47, p. e-20230123, 2024",
          doi: "http://dx.doi.org/10.21577/0100-4042.20230123"
        }
      ]
    },
    {
      year: 2023,
      list: [
        {
          title: "Virtual Screening Based on Ligand and Structure with in vitro Assessment of Neolignans against Trypanosoma cruzi.",
          authors: "MAIA, MAYARA ; ANDRADE, RODRIGO ; SOUSA, JULYANNE ; SOUSA, NATÁLIA ; RODRIGUES, GABRIELA ; MENEZES, RENATA ; SILVA, MARCELO ; TAVARES, JOSEAN ; RODRIGUES, KLINGER ; SCOTTI, LUCIANA ; SCOTTI, MARCUS",
          reference: "JOURNAL OF THE BRAZILIAN CHEMICAL SOCIETY, v. 34, p. 346-365, 2023",
          doi: "http://dx.doi.org/10.21577/0103-5053.20220113"
        },
        {
          title: "Computer-Aided drug design of new 2-amino-thiophene derivatives as anti-leishmanial agents.",
          authors: "LUNA, ISADORA SILVA ; SOUZA, THALISSON AMORIM DE ; DA SILVA, MARCELO SOBRAL ; FRANCA RODRIGUES, KLINGER ANTONIO DA ; SCOTTI, L. ; SCOTTI, Marcus Tullius ; MENDONÇA-JUNIOR, FRANCISCO JAIME BEZERRA",
          reference: "EUROPEAN JOURNAL OF MEDICINAL CHEMISTRY, v. 250, p. 115223, 2023",
          doi: "http://dx.doi.org/10.1016/j.ejmech.2023.115223"
        },
        {
          title: "Larvicidal activity and docking study of Ramalina complanata and Cladonia verticillaris extracts and secondary metabolites against Aedes aegypti.",
          authors: "DA SILVA, ANDRÉ SEVERINO ; DE OLIVEIRA FARIAS DE AGUIAR, JÚLIO CÉSAR RIBEIRO ; DA SILVA NASCIMENTO, JÉSSICA ; COSTA, ERICK CAÍQUE SANTOS ; DOS SANTOS, FÁBIO HENRIQUE GALDINO ; ANDRADE DE ARAÚJO, HALLYSSON DOUGLAS ; DA SILVA, NICÁCIO HENRIQUE ; PEREIRA, EUGÊNIA CRISTINA ; MARTINS, MÔNICA CRISTINA ; FALCÃO, EMERSON PETER SILVA ; SCOTTI, L. ; SCOTTI, Marcus Tullius ; DO AMARAL FERRAZ NAVARRO, DANIELA MARIA",
          reference: "INDUSTRIAL CROPS AND PRODUCTS, v. 195, p. 116425, 2023",
          doi: "http://dx.doi.org/10.1016/j.indcrop.2023.116425"
        },
        {
          title: "Discovery of novel acetylcholinesterase inhibitors through integration of machine learning with genetic algorithm based in silico screening approaches.",
          authors: "KHAN, MOHD IMRAN ; TAEHWAN, PARK ; CHO, YUNSEONG ; SCOTTI, Marcus Tullius ; BARROS, R. P. C. ; HUSAIN, FOHAD MABOOD ; ALOMAR, SULIMAN YOUSEF ; BAIG, MOHAMMAD HASSAN ; DONG, JAE-JUNE",
          reference: "Frontiers in Neuroscience, v. 16, p. fnins.2022.1007, 2023",
          doi: "http://dx.doi.org/10.3389/fnins.2022.1007389"
        },
        {
          title: "Selene-Ethylenelacticamides and N-Aryl-Propanamides as Broad-Spectrum Leishmanicidal Agents.",
          authors: "DE SOUSA, NATÁLIA FERREIRA ; DA SILVA SOUZA, HELIVALDO DIÓGENES ; BARROS, R. P. C. ; DA SILVA ALVES, FRANCINARA ; ACEVEDO, CHONNY ALEXANDER HERRERA ; DE LIMA NUNES, THAÍS AMANDA ; SESSIONS, ZOE L. ; SCOTTI, LUCIANA ; MURATOV, EUGENE N. ; MENDONÇA-JUNIOR, FRANCISCO JAIME BEZERRA ; DA FRANCA RODRIGUES, KLINGER ANTÔNIO ; DE ATHAYDE FILHO, PETRÔNIO FILGUEIRAS ; SCOTTI, Marcus Tullius",
          reference: "PATHOGENS, v. 12, p. 136, 2023",
          doi: "http://dx.doi.org/10.3390/pathogens12010136"
        },
        {
          title: "Four diterpenes identified in silico were isolated from Hyptidinae and demonstrated in vitro activity against Mycobacterium tuberculosis.",
          authors: "CAVALCANTI, ANDREZA BARBOSA SILVA ; MAIA, MAYARA DOS SANTOS ; FIGUEIREDO, PEDRO THIAGO RAMALHO DE ; MENEZES, RENATA PRISCILA BARROS DE ; MONTEIRO, ALEX FRANCE MESSIAS ; MEIRELES, ROSEANA ARAÚJO RAMOS ; RODRIGUES, GABRIELA CRISTINA SOARES ; RODRIGUES DE ALMEIDA SILVA, ANA RITA ; LINS, JOCIANO DA SILVA ; CORDEIRO, LAÍSA VILAR ; JUNIOR, VALNÊS S. RODRIGUES ; CASTELO BRANCO, ANA PAULA O. T. ; AGRA, Maria de Fátima ; SESSIONS, ZOE L. ; MURATOV, EUGENE N. ; Scotti, Luciana ; SILVA, M. S. ; COSTA, VICENTE CARLOS DE OLIVEIRA ; Tavares, Josean Fechine ; SCOTTI, Marcus Tullius ; et.al",
          reference: "NATURAL PRODUCT RESEARCH, v. 37, p. 903-911, 2023",
          doi: "http://dx.doi.org/10.1080/14786419.2022.2096604"
        },
        {
          title: "Anticancer Activity of Chalcones and Its Derivatives: Review and In Silico Studies.",
          authors: "LEITE, FERNANDO FERREIRA ; DE SOUSA, NATÁLIA FERREIRA ; DE OLIVEIRA, BRUNO HANRRY MELO ; DUARTE, GABRIELLY DINIZ ; FERREIRA, MARIA DENISE LEITE ; SCOTTI, Marcus Tullius ; FILHO, JOSÉ MARIA BARBOSA ; RODRIGUES, LUÍS CEZAR ; DE MOURA, RICARDO OLÍMPIO ; MENDONÇA-JUNIOR, FRANCISCO JAIME BEZERRA ; SCOTTI, L.",
          reference: "MOLECULES, v. 28, p. 4009, 2023",
          doi: "http://dx.doi.org/10.3390/molecules28104009"
        },
        {
          title: "Antimicrobial Potential of Betulinic Acid and Investigation of the Mechanism of Action against Nuclear and Metabolic Enzymes with Molecular Modeling.",
          authors: "RODRIGUES, GABRIELA CRISTINA SOARES ; DOS SANTOS MAIA, MAYARA ; DE SOUZA, THALISSON AMORIM ; DE OLIVEIRA LIMA, EDELTRUDES ; DOS SANTOS, LUIZ EDUARDO CARNEIRO GOMES ; SILVA, SHELLYGTON LIMA ; DA SILVA, MARCELO SOBRAL ; FILHO, JOSÉ MARIA BARBOSA ; DA SILVA RODRIGUES JUNIOR, VALNÊS ; SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "PATHOGENS, v. 12, p. 449, 2023",
          doi: "http://dx.doi.org/10.3390/pathogens12030449"
        },
        {
          title: "Kaurane-Type Diterpenoids as Potential Inhibitors of Dihydrofolate Reductase-Thymidylate Synthase in New World Leishmania Species.",
          authors: "HERRERA-ACEVEDO, CHONNY ; DE MENEZES, RENATA PRISCILA BARROS ; DE SOUSA, NATÁLIA FERREIRA ; SCOTTI, L. ; SCOTTI, Marcus Tullius ; COY-BARRERA, ERICSSON",
          reference: "ANTIBIOTICS-BASEL, v. 12, p. 663, 2023",
          doi: "http://dx.doi.org/10.3390/antibiotics12040663"
        },
        {
          title: "Mass Spectrometry-Based Investigation of Sugarcane Exposed to Five Different Pesticides.",
          authors: "DE SOUZA, THALISSON A. ; RODRIGUES, GABRIELA C. S. ; DE SOUZA, PEDRO H. N. ; ABREU, LUCAS S. ; PEREIRA, LAIANE C. O. ; DA SILVA, MARCELO S. ; TAVARES, JOSEAN F. ; SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "Life-Basel, v. 13, p. 1034, 2023",
          doi: "http://dx.doi.org/10.3390/life13041034"
        },
        {
          title: "Virtual Screening of Different Subclasses of Lignans with Anticancer Potential and Based on Genetic Profile.",
          authors: "MAIA, MAYARA DOS SANTOS ; MENDONCA JUNIOR, FJB ; RODRIGUES, GABRIELA CRISTINA SOARES ; SILVA, P. R. ; FELIPE, C. F. B. ; NAYARISSERI, ANURAJ ; SCOTTI, Marcus Tullius ; SCOTTI, L.",
          reference: "MOLECULES, v. 28, p. 6011, 2023",
          doi: "http://dx.doi.org/10.3390/molecules28166011"
        },
        {
          title: "The Essential Oil from Conyza bonariensis (L.) Cronquist (Asteraceae) Exerts an In Vitro Antimelanoma Effect by Inducing Apoptosis and Modulating the MAPKs, NF-κB, and PKB/AKT Signaling Pathways.",
          authors: "FERREIRA, RAFAEL CARLOS ; DUARTE, SÂMIA SOUSA ; DE SOUSA, VALGRÍCIA MATIAS ; DE SOUZA, RAMON RAMOS MARQUES ; MARQUES, KARINNE KELLY GADELHA ; DE ABRANTES, RENATA ALBUQUERQUE ; DO NASCIMENTO, YURI MANGUEIRA ; DE SOUSA, NATÁLIA FERREIRA ; SCOTTI, Marcus Tullius ; SCOTTI, L. ; TAVARES, JOSEAN FECHINE ; GONÇALVES, JUAN CARLOS RAMOS ; DA SILVA, MARCELO SOBRAL ; SOBRAL, MARIANNA VIEIRA",
          reference: "PHARMACEUTICALS, v. 16, p. 1553, 2023",
          doi: "http://dx.doi.org/10.3390/ph16111553"
        },
        {
          title: "Cleomin Exerts Acute Antinociceptive Effects in Mice via GABAB and Muscarinic Receptors.",
          authors: "OPRETZKA, LUÍZA CAROLINA FRANÇA ; VIANA, MAX DENISSON MAURÍCIO ; DE LIMA, ALYNE ALMEIDA ; DE SOUZA, THALISSON AMORIM ; SCOTTI, Marcus Tullius ; Tavares, Josean Fechine ; SILVA, M. S. ; SOARES, MILENA BOTELHO PEREIRA ; VILLARREAL, CRISTIANE FLORA",
          reference: "PHARMACEUTICALS, v. 16, p. 1547, 2023",
          doi: "http://dx.doi.org/10.3390/ph16111547"
        },
        {
          title: "Anti- Toxoplasma gondii screening of MMV Pandemic Response Box and evaluation of RWJ-67657 efficacy in chronically infected mice.",
          authors: "DOS SANTOS, BRUNA RAMOS ; RAMOS, AMANDA BRUNO DA SILVA BELLINI ; BARROS, R. P. C. ; SCOTTI, Marcus Tullius ; COLOMBO, FÁBIO ANTÔNIO ; MARQUES, MARCOS JOSÉ ; REIMÃO, JULIANA QUERO",
          reference: "PARASITOLOGY, v. 00, p. 1-29, 2023",
          doi: "http://dx.doi.org/10.1017/s0031182023000999"
        },
        {
          title: "Methyleugenol Has an Antidepressant Effect in a Neuroendocrine Model: In Silico and In Vivo Evidence.",
          authors: "OLIVEIRA, MAYARA CECILE NASCIMENTO ; CAVALCANTE, IKLA LIMA ; DE ARAÚJO, ALANA NATALÍCIA ; FERREIRA DOS SANTOS, ALINE MATILDE ; BARROS, R. P. C. ; HERRERA-ACEVEDO, CHONNY ; FERREIRA DE SOUSA, NATÁLIA ; DE SOUSA AQUINO, JAILANE ; BARBOSA-FILHO, JOSÉ MARIA ; DE CASTRO, RICARDO DIAS ; ALMEIDA, REINALDO NÓBREGA ; SCOTTI, LUCIANA ; SCOTTI, Marcus Tullius ; DA SILVA STIEBBE SALVADORI, MIRIAN GRACIELA",
          reference: "PHARMACEUTICALS, v. 16, p. 1408, 2023",
          doi: "http://dx.doi.org/10.3390/ph16101408"
        },
        {
          title: "Oxazolidines from Neocalyptrocalyx longifolium Inhibit MsrA Protein in Methicillin Resistant Staphylococcus aureus.",
          authors: "DE SOUZA, THALISSON AMORIM ; SILVA, JOANDA PAOLA RAIMUNDO ; RODRIGUES, DAMARA FREITAS ; HERRERA-ACEVEDO, CHONNY ; BARROS, R. P. C. ; BORGES, NATHALIE HELLEN ; DE MELO, JOSÉ IRANILDO MIRANDA ; DE SIQUEIRA-JÚNIOR, JOSÉ PINTO ; SCOTTI, Marcus Tullius ; ABREU, LUCAS SILVA ; TAVARES, JOSEAN FECHINE ; DA SILVA, MARCELO SOBRAL",
          reference: "BRAZILIAN JOURNAL OF PHARMACOGNOSY, v. 33, p. 1084-1088, 2023",
          doi: "http://dx.doi.org/10.1007/s43450-023-00422-6"
        },
        {
          title: "Repurposing the Medicines for Malaria Venture’s COVID Box to discover potent inhibitors of Toxoplasma gondii, and in vivo efficacy evaluation of almitrine bismesylate (MMV1804175) in chronically infected mice.",
          authors: "DOS SANTOS, BRUNA RAMOS ; RAMOS, AMANDA BRUNO DA SILVA BELLINI ; BARROS, R. P. C. ; SCOTTI, Marcus Tullius ; COLOMBO, FÁBIO ANTÔNIO ; MARQUES, MARCOS JOSÉ ; REIMÃO, JULIANA QUERO",
          reference: "PLoS One, v. 18, p. e0288335, 2023",
          doi: "http://dx.doi.org/10.1371/journal.pone.0288335"
        },
        {
          title: "Synthesis of 2-amino-4H-chromenes catalyst-free via sequential Knoevenagel-Michael reaction and evaluation of biological activity in tumor cells.",
          authors: "DE ABRANTES, POLIANA GOMES ; DE ABRANTES, PALOMA GOMES ; DOS SANTOS SILVA, DAMIÃO ALVES ; MAGALHÃES, RENATA RODRIGUES ; DA SILVA, PAULO BRUNO NORBERTO ; MILITÃO, GARDENIA CARMEN GADELHA ; BARROS, R. P. C. ; SCOTTI, LUCIANA ; SCOTTI, Marcus Tullius ; VALE, JULIANA ALVES",
          reference: "Medicinal Chemistry Research, v. 32, p. 2234-2244, 2023",
          doi: "http://dx.doi.org/10.1007/s00044-023-03131-w"
        },
        {
          title: "Assessment of Cytotoxic/Antitumour Potential and in silico Study of Salazinic Acid Isolated from Parmotrema concurrens.",
          authors: "DE LIRA, MARIA APARECIDA DA CONCEIÇÃO ; DA SILVA, MARLLYN MARQUES ; ALVES ROCHA, TAMIRIS ; FEIJÓ DE MOURA, DANIELLE ; SANTOS COSTA, ERICK CAIQUE ; DOS SANTOS MAIA, MAYARA ; SCOTTI, L. ; SCOTTI, Marcus Tullius ; LACERDA BURIL, MARIA DE LOURDES ; PEREIRA, EUGÊNIA C. ; DE AGUIAR JÚNIOR, FRANCISCO CARLOS AMANAJÁS ; DE BRITTO LIRA NOGUEIRA, MARIANE CAJUBÁ ; DA SILVA SANTOS, NOEMIA PEREIRA ; DA SILVA FALCÃO, EMERSON PETER ; DE MELO, SEBASTIÃO JOSÉ",
          reference: "Anti-Cancer Agents in Medicinal Chemistry, v. 23, p. 1469-1481, 2023",
          doi: "http://dx.doi.org/10.2174/1871520623666230407105219"
        },
        {
          title: "Derivative of 7-hydroxycoumarin has antifungal potential against Candida species and low cytotoxicity against human cells: In silico studies and biological evaluation.",
          authors: "NOGUEIRA, PAULA LIMA ; DA NÓBREGA ALVES, DANIELLE ; QUEIROGA GOMES DA COSTA, PALLOMA CHRISTINE ; ARAUJO, GLEYCYELLY RODRIGUES ; FERREIRA, ALANA RODRIGUES ; GOMES MOURA FARIAS, ANA PAULA ; FERREIRA DE SOUSA, NATÁLIA ; SOBRAL, MARIANNA VIEIRA ; PERGENTINO DE SOUSA, DAMIÃO ; SCOTTI, Marcus Tullius ; SCOTTI, L. ; DIAS DE CASTRO, RICARDO",
          reference: "Fungal Biology, v. 127, p. 1451-1465, 2023",
          doi: "http://dx.doi.org/10.1016/j.funbio.2023.10.007"
        },
        {
          title: "Structure-based design, optimization of lead, synthesis, and biological evaluation of compounds active against Trypanosoma cruzi.",
          authors: "DE ALMEIDA, GLEYBSON CORREIA ; DE OLIVEIRA, GERLINY BEZERRA ; DA SILVA MONTE, ZENAIDE ; COSTA, ÉRICK CAIQUE SANTOS ; DA SILVA FALCÃO, EMERSON PETER ; SCOTTI, L. ; SCOTTI, Marcus Tullius ; DE OLIVEIRA SILVA, RICARDO ; PEREIRA, VALÉRIA RÊGO ALVES ; DA SILVA, ELIS DIONISIO ; JUNIOR, POLICARPO ADEMAR SALES ; DE ANDRADE CAVALCANTE, MARTON KAIQUE ; DE MELO, SEBASTIÃO JOSÉ",
          reference: "Chemical Biology & Drug Design, p. 843-856, 2023",
          doi: "http://dx.doi.org/10.1111/cbdd.14294"
        },
        {
          title: "Epileptic Targets and Drugs: A Mini-Review.",
          authors: "RODRIGUES, T. C. M. L. ; MOURA, J. P. ; LOPES, S. M. ; SCOTTI, Marcus Tullius ; SCOTTI, L.",
          reference: "CURRENT DRUG TARGETS, v. 24, p. 212-224, 2023",
          doi: "http://dx.doi.org/10.2174/1389450123666220927103715"
        },
        {
          title: "Inhibitory effects of 190 compounds against SARS-CoV-2 M pr o protein: Molecular docking interactions.",
          authors: "SANDJO, L. P. ; SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "ARCHIV DER PHARMAZIE, v. 356, p. 2300207, 2023",
          doi: "http://dx.doi.org/10.1002/ardp.202300207"
        },
        {
          title: "Targets Involved in Skin Aging and Photoaging and their Possible Inhibitors: A Mini-review.",
          authors: "SCOTTI, L. ; DE MOURA, JÉSSICA PAIVA ; DE MOURA FERNANDES, ÉRIKA PAIVA ; LUSTOZA RODRIGUES, TERESA CAROLLINY MOREIRA ; MESSIAS MONTEIRO, ALEX FRANCE ; DE SOUSA, NATÁLIA FERREIRA ; FERREIRA DOS SANTOS, ALINE MATILDE ; SCOTTI, Marcus Tullius",
          reference: "CURRENT DRUG TARGETS, v. 24, p. 797-815, 2023",
          doi: "http://dx.doi.org/10.2174/1389450124666230719105849"
        },
        {
          title: "The potential of Acmella oleracea as a nutraceutical source for the symptomatic treatment of Burning Mouth Syndrome.",
          authors: "PAOLLA RAIMUNDO E SILVA, JOANILDA ; RAIMUNDO E SILVA, JOANDA PAOLLA ; SILVA VASCONCELOS, PRISCILLA GUIMARÃES ; TARGINO CAMPOS, LETÍCIA ; DE MEDEIROS GOMES, JULIANA ; TOLENTINO LEITE FILHO, MANOEL ; MENEZES, RENATA PRISCILA BARROS DE ; SCOTTI, Marcus Tullius ; Tavares, Josean Fechine ; CRISTINA BARBOSA SILVA, ANDRÉA ; COSTA, EDJA MARIA MELO DE BRITO",
          reference: "NATURAL PRODUCT RESEARCH, v. 2023, p. 1-7, 2023",
          doi: "http://dx.doi.org/10.1080/14786419.2023.2253974"
        },
        {
          title: "Convergent QSAR Models for the Prediction of Cruzain Inhibitors.",
          authors: "GONÇALVES, RAFAEL BELLO ; FERRAZ, WITOR RIBEIRO ; CALIL, RAISA LUDMILA ; SCOTTI, Marcus Tullius ; TROSSINI, GUSTAVO HENRIQUE GOULART",
          reference: "ACS Omega, v. 8, p. 38961-38982, 2023",
          doi: "http://dx.doi.org/10.1021/acsomega.3c03376"
        },
        {
          title: "Praemonitus praemunitus : can we forecast and prepare for future viral disease outbreaks?",
          authors: "SESSIONS, ZOE ; BOBROWSKI, TESIA ; MARTIN, HOLLI-JOI ; BEASLEY, JON-MICHAEL T ; KOTHARI, ANERI ; PHARES, TREVOR ; LI, MICHAEL ; ALVES, VINICIUS M ; SCOTTI, Marcus T ; MOORMAN, NATHANIEL J ; BARIC, RALPH ; TROPSHA, ALEXANDER ; MURATOV, EUGENE N",
          reference: "FEMS Microbiology Reviews, v. 47, p. fuad048, 2023",
          doi: "http://dx.doi.org/10.1093/femsre/fuad048"
        },
        {
          title: "Pharmacological Potential of Pyrmidine Derivatives: A Review With Emphasis on Antiviral Effects and Virtual Screening Against Sars-Cov-2 Molecular Targets.",
          authors: "CAIQUE SANTOS COSTA, ÉRICK ; MONTE, ZENAIDE S. ; FALCÃO, EMERSON P. S. ; DOS SANTOS MAIA, MAYARA ; PRISCILA BARROS DE MENEZES, RENATA ; SCOTTI, LUCIANA ; TULLIUS SCOTTI, MARCUS ; JOSÉ DE MELO, SEBASTIÃO",
          reference: "ChemistrySelect, v. 8, p. 10.1002/slct.20, 2023",
          doi: "http://dx.doi.org/10.1002/slct.202300132"
        },
        {
          title: "Editorial: Hot trends in computer-aided drug design techniques.",
          authors: "SCOTTI, LUCIANA; PATEL, JAGDISH SURESH ; HASSANZADEH, MALIHE ; SCOTTI, MARCUS T.",
          reference: "Frontiers in Cellular and Infection Microbiology, v. 13, p. 1149994, 2023",
          doi: "http://dx.doi.org/10.3389/fcimb.2023.1149994"
        },
        {
          title: "Elucidating the molecular mechanisms of essential oils' insecticidal action using a novel cheminformatics protocol.",
          authors: "CORRÊA, EDUARDO JOSÉ AZEVEDO ; CARVALHO, FREDERICO CHAVES ; DE CASTRO OLIVEIRA, JÚLIA ASSUNÇÃO ; BERTOLUCCI, SUZAN KELLY VILELA ; SCOTTI, Marcus Tullius ; SILVEIRA, CARLOS HENRIQUE ; GUEDES, FABIANA COSTA ; MELO, JÚLIO ONÉSIO FERREIRA ; DE MELO-MINARDI, RAQUEL CARDOSO ; DE LIMA, LEONARDO HENRIQUE FRANÇA",
          reference: "Scientific Reports, v. 13, p. 4598, 2023",
          doi: "http://dx.doi.org/10.1038/s41598-023-29981-3"
        },
        {
          title: "Studies of Cytotoxicity Effects, SARS-CoV-2 Main Protease Inhibition, and in Silico Interactions of Synthetic Chalcones.",
          authors: "GUTERRES FERNANDES, OCTAVIO L. ; TIZZIANI, TIAGO ; DAMBRÓS, BIBIANA P. ; FERREIRA DE SOUSA, NATÁLIA ; MANSUR PONTES, CARIME L. ; DA SILVA, LAYZON A. L. ; ESCORTEGANHA POLLO, LUIZ A. ; DE ASSIS, FRANCISCO F. ; SCOTTI, Marcus T. ; SCOTTI, Luciana ; BRAGA, ANTONIO L. ; STEINDEL, MARIO ; SANDJO, LOUIS P.",
          reference: "CHEMISTRY & BIODIVERSITY, v. 20, p. e202201151, 2023",
          doi: "http://dx.doi.org/10.1002/cbdv.202201151"
        },
        {
          title: "Semisynthetic Sesquiterpene Lactones Generated by the Sensibility of Glaucolide B to Lewis and Brønsted-Lowry Acids and Bases: Cytotoxicity and Anti-Inflammatory Activities.",
          authors: "DA SILVA, LAYZON A. LEMOS ; SANDJO, LOUIS P. ; ASSUNÇÃO, LAURA S. ; PRIGOL, ANNE N. ; DE SIQUEIRA, CAROLINA D. ; CRECZYNSKI-PASA, TÂNIA B. ; SCOTTI, Marcus T. ; SCOTTI, Luciana ; FILIPPIN-MONTEIRO, FABÍOLA B. ; BIAVATTI, MAIQUE W.",
          reference: "MOLECULES, v. 28, p. 1243, 2023",
          doi: "http://dx.doi.org/10.3390/molecules28031243"
        },
        {
          title: "Computational Studies Applied to Linalool and Citronellal Derivatives Against Alzheimer's and Parkinson's Disorders: A Review with Experimental Approach.",
          authors: "DA SILVA, PABLO RAYFF ; DE ANDRADE, JÉSSICA CABRAL ; DE SOUSA, NATÁLIA FERREIRA ; RIBEIRO PORTELA, ANNE CAROLINE ; OLIVEIRA PIRES, HUGO FERNANDES ; BEZERRA REMÍGIO, MARIA CAROLINE RODRIGUES ; ALVES, DANIELLE DA NÓBREGA ; DE ANDRADE, HUMBERTO HUGO NUNES ; DIAS, ARTHUR LINS ; DA SILVA STIEBBE SALVADORI, MIRIAN GRACIELA ; DE OLIVEIRA GOLZIO, ADRIANA MARIA FERNANDES ; DE CASTRO, RICARDO DIAS ; SCOTTI, Marcus T. ; BEZERRA FELIPE, CÍCERO FRANCISCO ; DE ALMEIDA, REINALDO NÓBREGA ; SCOTTI, Luciana",
          reference: "Current Neuropharmacology, v. 21, p. 842-866, 2023",
          doi: "http://dx.doi.org/10.2174/1570159x21666230221123059"
        },
        {
          title: "Challenges and Discoveries in Polypharmacology of Neurodegenerative Diseases.",
          authors: "SCOTTI, LUCIANA; LUSTOZA RODRIGUES, TERESA CAROLLINY MOREIRA ; DE SOUSA, NATÁLIA FERREIRA ; DOS SANTOS, ALINE MATILDE FERREIRA ; AIRES GUIMARÃES, RENAN DANTAS ; SCOTTI, MARCUS TULLIUS",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 23, p. 349-370, 2023",
          doi: "http://dx.doi.org/10.2174/1568026623666230126112628"
        },
        {
          title: "Challenges, Consequences and Possible Treatments of Anticancer Drug Discovery.",
          authors: "Scotti, Marcus T.; Scotti, Luciana",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 23, p. 2805-2806, 2023",
          doi: "http://dx.doi.org/10.2174/156802662330231130162134"
        },
        {
          title: "Proposition of In silico Pharmacophore Models for Malaria: A Review.",
          authors: "FERREIRA, NATÁLIA ; DE ARAÚJO, IGOR ; LUSTOSA, TERESA ; DA SILVA, PABLO RAYFF ; PAIVA, JÉSSICA ; SCOTTI, Marcus Tullius ; Scotti, Luciana",
          reference: "COMBINATORIAL CHEMISTRY & HIGH THROUGHPUT SCREENING, v. 26, p. 2525-2543, 2023",
          doi: "http://dx.doi.org/10.2174/0113862073247691230925062440"
        }
      ],
    },
    {
      year: 2022,
  list: [
    {
      title: "Antifungal activity of 2-chloro-N -phenylacetamide, docking and molecular dynamics studies against clinical isolates of Candida tropicalis and Candida parapsilosis.",
      authors: "SILVA, SHELLYGTON LIMA ; DE OLIVEIRA PEREIRA, FILLIPE ; CORDEIRO, LAISA VILAR ; DINIZ NETO, HERMES ; DOS SANTOS MAIA, MAYARA ; DA SILVA SOUZA, HELIVADO DIOGENES ; DE ATHAYDE'FILHO, PETRÔNIO F. ; SCOTTI, Marcus Tullius ; SCOTTI, L. ; DE OLIVEIRA LIMA, EDELTRUDES",
      reference: "JOURNAL OF APPLIED MICROBIOLOGY, v. 132, p. 3601-3617, 2022. ",
      doi: "http://dx.doi.org/10.1111/jam.15498"
    },
    {
      title: "Computer-Assisted Discovery of Alkaloids with Schistosomicidal Activity.",
      authors: "MENEZES, RENATA PRISCILA BARROS DE ; VIANA, JÉSSIKA DE OLIVEIRA ; MURATOV, EUGENE ; SCOTTI, L. ; SCOTTI, Marcus Tullius",
      reference: "Current Issues in Molecular Biology (Online), v. 44, p. 383-408, 2022.",
      doi: "http://dx.doi.org/10.3390/cimb44010028"
    },
    {
      title: "Recent Natural Anticancer Agents.",
      authors: "SCOTTI, Marcus Tullius; SCOTTI, L.",
      reference: "CURRENT MEDICINAL CHEMISTRY, v. 29, p. 164-165, 2022.",
      doi: "http://dx.doi.org/10.2174/092986732902220103145922"
    },
    {
      title: "Machine Learning Analysis of Essential Oils from Cuban Plants: Potential Activity against Protozoa Parasites.",
      authors: "BARROS DE MENEZES, RENATA PRISCILA ; SCOTTI, L. ; SCOTTI, Marcus Tullius ; GARCÍA, JESÚS ; GONZÁLEZ, ROSALIA ; MONZOTE, LIANET ; SETZER, WILLIAM N.",
      reference: "MOLECULES, v. 27, p. 1366, 2022.",
      doi: "http://dx.doi.org/10.3390/molecules27041366"
    },
    {
      title: "Virtual Screening and Molecular Docking: Discovering Novel c-KITInhibitors.",
      authors: "TAVARES, FERNANDA MELLO ; GOMES, ANGELA CRISTINA ; ASSUNÇÃO, EDSON MARECO ; DE MEDEIROS, JOÃO LUIZ SOBRAL ; Scotti, Marcus T. ; Scotti, Luciana ; ISHIKI, HAMILTON MITSUGU",
      reference: "CURRENT MEDICINAL CHEMISTRY, v. 29, p. 166-188, 2022.",
      doi: "http://dx.doi.org/10.2174/0929867328666210915102920"
    },
    {
      title: "Curine Ameliorates Lipopolysaccharide-Induced Acute Lung Injury by Downregulating the TLR4/MD-2/NF-κB(p65) Signaling Pathway.",
      authors: "PAIVA FERREIRA, LARISSA A. M. ; PAIVA FERREIRA, LAÉRCIA K. D. ; MONTEIRO, TALISSA M. ; GADELHA, FRANCISCO A. A. F. ; DE LIMA, LOUISE M. ; DOS SANTOS MAIA, MAYARA ; SCOTTI, Marcus Tullius ; RIBEIRO-FILHO, JAIME ; DA S. DIAS, CELIDARQUE ; PIUVEZAM, MARCIA REGINA",
      reference: "BRAZILIAN JOURNAL OF PHARMACOGNOSY, v. 32, p. 111-121, 2022.",
      doi: "http://dx.doi.org/10.1007/s43450-022-00230-4"
    },
    {
      title: "Editorial: Exploration of Natural Product Leads for Multitarget-Based Treatment of Cancer-Computational to Experimental Journey.",
      authors: "SINGLA, RAJEEV K. ; Scotti, Marcus T. ; KAR, SUPRATIK",
      reference: "Frontiers in Pharmacology, v. 13, p. 580151, 2022.",
      doi: "http://dx.doi.org/10.3389/fphar.2022.850151"
    },
    {
      title: "Sidastrum paniculatum (L.) Fryxell (Malvaceae): A Promising Source of Bioactive Sulfated Flavonoids Against Aedes aegypti L.",
      authors: "MARQUES, SANY D. G. ; FERNANDES, DIÉGINA A. ; TELES, YANNA C. F. ; MENEZES, RENATA. P. B. ; MAIA, MAYARA S. ; Scotti, Marcus T. ; AGRA, MARIA F. ; SILVA, TANIA M. S. ; DE SOUZA, MARIA DE FÁTIMA VANDERLEI",
      reference: "Frontiers in Pharmacology, v. 12, p. 2021.760156, 2022.",
      doi: "http://dx.doi.org/10.3389/fphar.2021.760156"
    },
    {
      title: "Computer Aided Drug Design Methodologies with Natural Products in theDrug Research Against Alzheimer?s Disease.",
      authors: "DE SOUSA, NATÁLIA FERREIRA ; SCOTTI, L. ; DE MOURA, ÉRIKA PAIVA ; DOS SANTOS MAIA, MAYARA ; RODRIGUES, GABRIELA CRISTINA SOARES ; DE MEDEIROS, HERBERT IGOR RODRIGUES ; LOPES, SIMONE MENDES ; SCOTTI, Marcus Tullius",
      reference: "Current Neuropharmacology, v. 20, p. 857-885, 2022.",
      doi: "http://dx.doi.org/10.2174/1570159X19666211005145952"
    },
    {
      title: "Medicinal Chemistry Studies Against Neurodegenerative Diseases.",
      authors: "Scotti, L. ; SCOTTI, M. T.",
      reference: "Current Neuropharmacology, v. 20, p. 822-823, 2022.",
      doi: "http://dx.doi.org/10.2174/1570159X2005220329113736."
    },
    {
      title: "Analgesic-like activity of perillyl acetate: In vivo and in silico studies.",
      authors: "SOUSA, DAMIÃO ; BRAGA, RENAN ; ANDRADE, HUMBERTO ; CRUZ, RYLDENE ; MAIA, MAYARA ; LIMA, CAROLINA ; SANTOS, ANDERSON ; MIRANDA, ANDRÉ ; DUARTE, ALLANA ; SCOTTI, Marcus Tullius ; ALMEIDA, REINALDO",
      reference: "ASIAN PACIFIC JOURNAL OF TROPICAL BIOMEDicine, v. 12, p. 156-163, 2022.",
      doi: "http://dx.doi.org/10.4103/2221-1691.340560"
    },
    {
      title: "Natural Products with Tandem Anti-inflammatory, Immunomodulatoryand Anti-SARS-CoV/2 Effects: A Drug Discovery Perspectiveagainst SARS-CoV-2.",
      authors: "DA CUNHA, LUANA N.O. LEAL ; TIZZIANI, TIAGO ; SOUZA, GABRIELLA B. ; MOREIRA, MONALISA A. ; NETO, JOSÉ S.S. ; DOS SANTOS, CARLOS V.D. ; DE CARVALHO, MARYELLE G. ; DALMARCO, EDUARDO M. ; TURQUETI, LEONARDO B. ; SCOTTI, Marcus Tullius ; Scotti, Luciana ; DE ASSIS, FRANCISCO F. ; BRAGA, ANTONIO LUIZ ; SANDJO, LOUIS PERGAUD",
      reference: "CURRENT MEDICINAL CHEMISTRY, v. 29, p. 2530-2564, 2022.",
      doi: "http://dx.doi.org/10.2174/0929867328666210726094955"
    },
    {
      title: "Limonene, a citrus monoterpene, non-complexed and complexed with hydroxypropyl-β-cyclodextrin attenuates acute and chronic orofacial nociception in rodents: Evidence for involvement of the PKA and PKC pathway.",
      authors: "PEREIRA, ERIK W.M. ; HEIMFARTH, LUANA ; SANTOS, TIFFANY KB. ; PASSOS, FABIOLLA R.S. ; SIQUEIRA-LIMA, POLLYANA ; SCOTTI, LUCIANA ; SCOTTI, MARCUS T. ; ALMEIDA, JACKSON ROBERTO GUEDES DA SILVA ; CAMPOS, ADRIANA R. ; COUTINHO, HENRIQUE D.M. ; MARTIN, PATRICK ; QUINTANS-JÚNIOR, LUCINDO J. ; QUINTANS, JULLYANA S.S.",
      reference: "PHYTOMEDICINE, v. 96, p. 153893, 2022.",
      doi: "http://dx.doi.org/10.1016/j.phymed.2021.153893"
    },
    {
      title: "Natural products from Annonaceae as potential antichagasic agents.",
      authors: "DE MENEZES, RENATA PRISCILA BARROS ; Tavares, Josean Fechine ; KATO, MASSUO JORGE ; DA ROCHA COELHO, FRANCISCO ALEX ; DOS SANTOS, AIRTON LUCAS SOUSA ; DA FRANCA RODRIGUES, KLINGER ANTONIO ; SESSIONS, ZOE L. ; MURATOV, EUGENE N. ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS",
      reference: "ChemMedChem, v. 17, p. e202200196, 2022. Citações:1",
      doi: "http://dx.doi.org/10.1002/cmdc.202200196"
    },
    {
      title: "Review on Compounds Isolated from Eriocaulaceae Family and Evaluation of Biological Activities by Machine Learning.",
      authors: "MOREIRA, LAYSA LANES PEREIRA FERREIRA ; DE MENEZES, RENATA PRISCILA BARROS ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS ; LACERDA JÚNIOR, VALDEMAR ; BORGES, WARLEY DE SOUZA",
      reference: "MOLECULES, v. 27, p. 7186, 2022.",
      doi: "http://dx.doi.org/10.3390/molecules27217186"
    },
    {
      title: "Structure Revision of the Sesquiterpene Nordine Based on NMR Spectroscopic Analysis and X-ray Crystallography.",
      authors: "DE ANDRADE, RODRIGO SILVA ; SALES, KAIO ARAGÃO ; ABREU, LUCAS SILVA ; CAMPOS, VINÍCIUS RANGEL ; DOS SANTOS JUNIOR, FERNANDO MARTINS ; BRAZ-FILHO, RAIMUNDO ; SCOTTI, Marcus Tullius ; Tavares, Josean Fechine ; DA SILVA, MARCELO SOBRAL",
      reference: "JOURNAL OF NATURAL PRODUCTS, v. 85, p. 2480-2483, 2022.",
      doi: "http://dx.doi.org/10.1021/acs.jnatprod.2c00828"
    },
    {
      title: "Synthesis and Activity of 2-Acyl-cyclohexane-1,3-dione Congeners Derived from Peperomia Natural Products against the Plant p-Hydroxyphenylpyruvate Dioxygenase Herbicidal Molecular Target Site.",
      authors: "OOKA, JOEY K. ; CORREIA, MAURO V. ; Scotti, Marcus T. ; FOKOUE, HAROLD H. ; YAMAGUCHI, LYDIA F. ; KATO, MASSUO J. ; DAYAN, FRANCK E. ; OWENS, DANIEL K.",
      reference: "PLANTS, v. 11, p. 2269, 2022.",
      doi: "http://dx.doi.org/10.3390/plants11172269"
    },
    {
      title: "MolPredictX: Online Biological Activity Predictions by Machine Learning Models.",
      authors: "Tullius Scotti, Marcus; HERRERA'ACEVEDO, CHONNY ; BARROS DE MENEZES, RENATA PRISCILA ; MARTIN, HOLLI'JOI ; MURATOV, EUGENE N. ; ÍTALO DE SOUZA SILVA, ÁVILLA ; FAUSTINO ALBUQUERQUE, EMMANUELLA ; FERREIRA CALADO, LUCAS ; COY'BARRERA, ERICSSON ; SCOTTI., LUCIANA",
      reference: "MOLECULAR INFORMATICS, v. 41, p. 2200133, 2022.",
      doi: "http://dx.doi.org/10.1002/minf.202200133"
    },
    {
      title: "Annonaceae Terpenoids as Potential Leishmanicidal Agents.",
      authors: "DE MENEZES, RENATA PRISCILA BARROS ; Tavares, Josean Fechine ; KATO, MASSUO JORGE ; DA ROCHA COELHO, FRANCISCO ALEX ; MARTIN, HOLLI-JOI ; MURATOV, EUGENE ; DOS SANTOS, AIRTON LUCAS SOUSA ; DA FRANCA RODRIGUES, KLINGER ANTONIO ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS",
      reference: "BRAZILIAN JOURNAL OF PHARMACOGNOSY, v. 32, p. 741-748, 2022.",
      doi: "http://dx.doi.org/10.1007/s43450-022-00296-0"
    },
    {
      title: "Targeted Isolation of Anti-inflammatory Lignans from Justicia aequilabris by Molecular Networking Approach.",
      authors: "E SILVA, JOANDA P. R. ; PEREIRA, LAIANE C. O. ; ABREU, LUCAS S. ; LINS, FRANCISCA S. V. ; DE SOUZA, THALISSON A. ; DO ESPÍRITO-SANTO, RENAN F. ; BARROS, RENATA P. C. ; VILLARREAL, CRISTIANE F. ; DE MELO, JOSÉ I. M. ; Scotti, Marcus T. ; COSTA, VICENTE C. DE O. ; MARTORANO, LUCAS H. ; DOS SANTOS, FERNANDO M. ; FILHO, RAIMUNDO BRAZ ; da Silva, Marcelo S. ; Tavares, Josean F.",
      reference: "JOURNAL OF NATURAL PRODUCTS, v. 85, p. 2184-2191, 2022.",
      doi: "http://dx.doi.org/10.1021/acs.jnatprod.2c00478"
    },
    {
      title: "DITERPENOS ENT-ABIETANOS DE Euphorbia phosphorea (EUPHORBIACEAE).",
      authors: "MEIRELES, ROSEANA ; ABREU, LUCAS ; SILVA, JOANDA ; CAVALCANTI, ANDREZA ; MENEZES, RENATA ; RODRIGUES, GABRIELA ; RODRIGUES JUNIOR, VALNÊS ; MELO, JOSÉ ; KATO, MASSUO ; COSTA, VICENTE ; SCOTTI, MARCUS ; TAVARES, JOSEAN",
      reference: "QUÍMICA NOVA (ONLINE), v. 45, p. 1092-1097, 2022.",
      doi: "http://dx.doi.org/10.21577/0100-4042.20170932"
    },
    {
      title: "γ-Terpinene complexed with β-cyclodextrin attenuates spinal neuroactivity in animals with cancer pain by Ca2+ channel block.",
      authors: "PINA, LÍCIA T S ; RABELO, THALLITA K ; TRINDADE, GABRIELA G G ; ALMEIDA, IGGO K S ; OLIVEIRA, MARLANGE A ; DOS SANTOS, PRISCILA L ; SOUZA, DIEGO SANTOS ; DE MENEZES-FILHO, JOSÉ E R ; DE VASCONCELOS, CARLA MARIA LINS ; SANTOS, SANDRA L ; SCOTTI, LUCIANA ; SCOTTI, MARCUS T ; ARAÚJO, ADRIANO A S ; QUINTANS, JULLYANA S S ; QUINTANS, LUCINDO J ; GUIMARÃES, ADRIANA G",
      reference: "JOURNAL OF PHARMACY AND PHARMACOLOGY, v. 74, p. 1629-1639, 2022.",
      doi: "http://dx.doi.org/10.1093/jpp/rgac052"
    },
    {
      title: "Drug Repurposing Based on Protozoan Proteome: In Vitro Evaluation of In Silico Screened Compounds against Toxoplasma gondii.",
      authors: "CAJAZEIRO, DÉBORA CHAVES ; TOLEDO, PAULA PEREIRA MARQUES ; DE SOUSA, NATÁLIA FERREIRA ; SCOTTI, Marcus Tullius ; REIMÃO, JULIANA QUERO",
      reference: "PHARMACEUTICS, v. 14, p. 1634, 2022.",
      doi: "http://dx.doi.org/10.3390/pharmaceutics14081634"
    },
    {
      title: "Nanoencapsulated α-terpineol attenuates neuropathic pain induced by chemotherapy through calcium channel modulation.",
      authors: "GOUVEIA, DANIELE N. ; GUIMARÃES, ADRIANA G. ; OLIVEIRA, MARLANGE A. ; RABELO, THALLITA K. ; PINA, LÍCIA T. S. ; SANTOS, WAGNER B. R. ; ALVES, IGGO K. S. ; A. ANDRADE, TATIANNY ; SERAFINI, MAIRIM RUSSO ; S. LIMA, BRUNO ; ARAÚJO, ADRIANO A. S. ; MENEZES-FILHO, JOSÉ EVALDO R. ; SANTOS-MIRANDA, ARTUR ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS ; COUTINHO, HENRIQUE DOUGLAS MELO ; QUINTANS, JULLYANA S. S. ; CAPASSO, RAFFAELE ; QUINTANS-JÚNIOR, LUCINDO J.",
      reference: "POLYMER BULLETIN (BERLIN. INTERNET), v. 80, p. 2515-2532, 2022.",
      doi: "http://dx.doi.org/10.1007/s00289-022-04161-x"
    },
    {
      title: "Milonine attenuates the lipopolysaccharide-induced acute lung injury in mice by modulating the Akt/NF-κB signaling pathways.",
      authors: "BERNARDO, LARISSA R. ; FERREIRA, LAÉRCIA KARLA D.P. ; FERREIRA, LARISSA A.M.P. ; VIEIRA, COSMO ISAÍAS D. ; OLIVEIRA, JOÃO BATISTA DE ; LIMA, LOUISE M. DE ; ALVES, ADRIANO FRANCISCO ; ARAÚJO, RUBENS S. ; MAIA, MAYARA S. ; Scotti, Marcus T. ; BARBOSA FILHO, JOSÉ MARIA ; PIUVEZAM, MARCIA REGINA",
      reference: "ANAIS DA ACADEMIA BRASILEIRA DE CIÊNCIAS, v. 94, p. e20211327, 2022.",
      doi: "http://dx.doi.org/10.1590/0001-3765202220211327"
    },
    {
      title: "Anxiolytic and Antidepressant-like Effects of Monoterpene Tetrahydrolinalooland In silico Approach of new Potential Targets.",
      authors: "SCOTTI, LUCIANA; RAYFF DA SILVA, PABLO ; DINIZ NUNESPAZOS, NATALIA ; KARLA SILVA DO NASCIMENTO GONZAGA, THALLITA ; CABRAL DE ANDRADE, JÉSSICA ; BRITO MONTEIRO, ÁLEFE ; CAROLINE RIBEIRO PORTELA, ANNE ; FERNANDES OLIVEIRA PIRES, HUGO ; DOS SANTOS MAIA, MAYARA ; VILAR DA FONSÊCA, DIOGO ; T. SCOTTI, MARCUS ; MARIA BARBOSA FILHO, JOSÉ ; PERGENTINO DE SOUSA, DAMIÃO ; FRANCISCO BEZERRA FELIPE, CÍCERO ; NÓBREGA DE ALMEIDA, REINALDO",
      reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 22, p. 1530-1552, 2022.",
      doi: "http://dx.doi.org/10.2174/1568026622666220505104726"
    },
    {
      title: "Natural products against COVID-19 inflammation: a mini-review.",
      authors: "LOPES, SIMONE MENDES ; DE MEDEIROS, HERBERT IGOR RODRIGUES ; SCOTTI, Marcus Tullius ; SCOTTI, Luciana",
      reference: "COMBINATORIAL CHEMISTRY & HIGH THROUGHPUT SCREENING, v. 25, p. 2358-2369, 2022.",
      doi: "http://dx.doi.org/10.2174/1386207325666220128114547"
    },
    {
      title: "Development of 2D, 3D-QSAR and Pharmacophore Modeling of Chalcones for the Inhibition of Monoamine Oxidase B.",
      authors: "MATHEW, BIJO ; HERRERA-ACEVEDO, CHONNY ; DEV, SANAL ; RANGARAJAN, T.M. ; KURUNIYAN, MOHAMED SAHEER ; NASEEF, PUNNOTH POONKUZHI ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS",
      reference: "COMBINATORIAL CHEMISTRY & HIGH THROUGHPUT SCREENING, v. 25, p. 1731-1744, 2022.",
      doi: "http://dx.doi.org/10.2174/1386207324666210816125738"
    },
    {
      title: "Natural Products as Anti-Inflammatory Agents.",
      authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
      reference: "COMBINATORIAL CHEMISTRY & HIGH THROUGHPUT SCREENING, v. 25, p. 2315-2316, 2022.",
      doi: "http://dx.doi.org/10.2174/138620732514220908123932"
    },
    {
      title: "Natural Multi-targets: Advances and Applications.",
      authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
      reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 22, p. 1457-1459, 2022.",
      doi: "http://dx.doi.org/10.2174/156802662218220727122830"
    },
    {
      title: "Oxazolidine Compounds from Neocalytrocalyx Longifolium (Capparaceae) and Their Activity as Msra (ABC) Efflux Pump Inhibitors: An in Vitro and in Silico Approach.",
      authors: "DE SOUZA, THALISSON AMORIM ; RAIMUNDO E SILVA, JOANDA PAOLLA ; RODRIGUES, DAMARA FREITAS ; HERRERA-ACEVEDO, CHONNY ; BARROS, R. P. C. ; BORGES, NATHALIE H. P. B. ; DE MELO, JOSÉ IRANILDO MIRANDA ; DE SIQUEIRA-JÚNIOR, JOSÉ PINTO ; SCOTTI, Marcus Tullius ; ABREU, LUCAS SILVA ; TAVARES, JOSEAN FECHINE ; SOBRAL DA SILVA, MARCELO",
      reference: "SSRN Electronic Journals: The English & Commonwealth Law Abstracts Journal, v. 00, p. 1, 2022.",
      doi: "http://dx.doi.org/10.2139/ssrn.4098928"
    }
      ],
    },
    {
      year: 2021,
      list: [
        {
          title: "Natural Products as Potential Agents Against SARS-CoV and SARS-CoV-2.",
          authors: "RAIMUNDO E SILVA, JOANDA PAOLLA ; ACEVEDO, CHONNY ALEXANDER HERRERA ; DE SOUZA, THALISSON AMORIM ; DE MENEZES, RENATA PRISCILA BARROS ; SESSIONS, ZOE L. ; ABREU, LUCAS SILVA ; CIBULSKI, SAMUEL PAULO ; Scotti, Luciana ; SILVA, M. S. ; MURATOV, EUGENE N. ; SCOTTI, Marcus Tullius ; Tavares, Josean Fechine",
          reference: "CURRENT MEDICINAL CHEMISTRY, v. 28, p. 00, 2021.",
          doi: "http://dx.doi.org/10.2174/0929867328666210125113938"
        },
        {
          title: "A new labdane diterpene from the aerial segments of Leptohyptis macrostachys (L'Hérit.) Harley & J.F.B. Pastore.",
          authors: "CAVALCANTI, A. B. S. ; MONTEIRO, A. F. M. ; FECHINE, J. T. ; SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "Phytochemistry Letters, v. 43, p. 117-122, 2021.",
          doi: "http://dx.doi.org/10.1016/j.phytol.2021.03.022"
        },
        {
          title: "Identification of Kaurane-Type Diterpenes as Inhibitors of Leishmania Pteridine Reductase I.",
          authors: "ACEVEDO, CHONNY ALEXANDER HERRERA ; MENDONCA-JUNIOR, F. ; SCOTTI, L. ; SCOTTI, Marcus Tullius ; COY-BARRERA, E.",
          reference: "MOLECULES, v. 26, p. 3076, 2021.",
          doi: "http://dx.doi.org/10.3390/molecules26113076"
        },
        {
          title: "In Silico Studies of Lamiaceae Diterpenes with Bioinsecticide Potential against Aphis gossypii and Drosophila melanogaster.",
          authors: "RODRIGUES, GABRIELA CRISTINA SOARES ; DOS SANTOS MAIA, MAYARA ; CAVALCANTI, ANDREZA BARBOSA ; DE SOUSA, NATÁLIA FERREIRA ; SCOTTI, Marcus Tullius ; SCOTTI, L.",
          reference: "MOLECULES, v. 26, p. 766, 2021.",
          doi: "http://dx.doi.org/10.3390/molecules26030766"
        },
        {
          title: "Insights into the actions of angiotensin-1 receptor (AT1R) inverse agonists: Perspectives and implications in COVID-19 treatment.",
          authors: "HEIMFARTH, L. ; SANTOS, M. A. ; ARAUJO, A. A. S. ; SCOTTI, Marcus Tullius ; SCOTTI, L. ; QUINTANS JUNIOR, L.",
          reference: "EXCLI Journal, v. 20, p. 252-275, 2021.",
          doi: "http://dx.doi.org/10.17179/excli2021-3412"
        },
        {
          title: "Machine learning models to select potential inhibitors of acetylcholinesterase activity from SistematX: a natural products database.",
          authors: "HERRERA-ACEVEDO, CHONNY ; PERDOMO-MADRIGAL, CAMILO ; HERRERA-ACEVEDO, KENYI ; COY-BARRERA, ERICSSON ; SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "MOLECULAR DIVERSITY, v. 2021, p. 1553-1568, 2021.",
          doi: "http://dx.doi.org/10.1007/s11030-021-10245-z"
        },
        {
          title: "Natural Bioactive Products with Antioxidant Properties Useful in Neurodegenerative Diseases 2020.",
          authors: "MENDONÇA-JUNIOR, FRANCISCO JAIME BEZERRA ; SCOTTI, Marcus Tullius ; MURATOV, EUGENE N. ; SCOTTI, L. ; NAYARISSERI, ANURAJ",
          reference: "OXIDATIVE MEDICINE AND CELLULAR LONGEVITY (ONLINE), v. 2021, p. 1-2, 2021.",
          doi: "http://dx.doi.org/10.1155/2021/6262316"
        },
        {
          title: "Recent Medicinal Chemistry Studies for Multitarget Agents-Part II.",
          authors: "SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "CURRENT DRUG TARGETS, v. 22, p. 606-608, 2021.",
          doi: "http://dx.doi.org/10.2174/138945012206210309121827"
        },
        {
          title: "QSAR Modeling for Multi-Target Drug Discovery: Designing Simultaneous Inhibitors of Proteins in Diverse Pathogenic Parasites.",
          authors: "KLEANDROVA, VALERIA V. ; Scotti, Luciana ; MENDONCA JUNIOR, FJB ; MURATOV, EUGENE ; SCOTTI, Marcus Tullius ; SPECK-PLANCHE, ALEJANDRO",
          reference: "Frontiers in Chemistry, v. 9, p. 1-20, 2021.",
          doi: "http://dx.doi.org/10.3389/fchem.2021.634663"
        },
        {
          title: "EDITORIAL-Natural Products Databases for Drug Design.",
          authors: "SCOTTI, L. ; MURATOV, EUGENE ; SCOTTI, Marcus Tullius",
          reference: "MINI-REVIEWS IN MEDICINAL CHEMISTRY, v. 21, p. 2626-2627, 2021. Citações:1",
          doi: "http://dx.doi.org/10.2174/138955752118210824095236"
        },
        {
          title: "Chemical safety assessment of transformation products of landfill leachate formed during the Fenton process.",
          authors: "DE MORAIS E SILVA, LUANA ; ALVES, VINICIUS M. ; DANTAS, EDILMA R.B. ; SCOTTI, LUCIANA ; LOPES, WILTON SILVA ; MURATOV, EUGENE N. ; SCOTTI, Marcus Tullius",
          reference: "JOURNAL OF HAZARDOUS MATERIALS, v. 419, p. 126438, 2021.",
          doi: "http://dx.doi.org/10.1016/j.jhazmat.2021.126438"
        },
        {
          title: "Computational Drug Repurposing for Antituberculosis Therapy: Discovery of Multi-Strain Inhibitors.",
          authors: "Kleandrova, Valeria V. ; Scotti, Marcus T. ; SPECK-PLANCHE, Alejandro",
          reference: "ANTIBIOTICS-BASEL, v. 10, p. 1005, 2021.",
          doi: "http://dx.doi.org/10.3390/antibiotics10081005"
        },
        {
          title: "The SistematX Web Portal of Natural Products: An Update.",
          authors: "COSTA, RENAN P. O. ; LUCENA, LUCAS F. ; SILVA, LORENA MARA A. ; ZOCOLO, GUILHERME JULIÃO ; HERRERA-ACEVEDO, CHONNY ; SCOTTI, LUCIANA ; DA-COSTA, FERNANDO BATISTA ; IONOV, NIKITA ; POROIKOV, VLADIMIR ; MURATOV, EUGENE N. ; SCOTTI, Marcus T.",
          reference: "JOURNAL OF CHEMICAL INFORMATION AND MODELING (ONLINE), v. 61, p. 2516-2522, 2021.",
          doi: "http://dx.doi.org/10.1021/acs.jcim.1c00083"
        },
        {
          title: "Involvement of GABAA Receptors in the Anxiolytic-Like Effect of Hydroxycitronellal.",
          authors: "ANDRADE, JÉSSICA C. ; MONTEIRO, ÁLEFE B. ; ANDRADE, HUMBERTO H. N. ; GONZAGA, THALLITA K. S. N. ; SILVA, PABLO R. ; ALVES, DANIELLE N. ; CASTRO, RICARDO D. ; MAIA, MAYARA S. ; Scotti, Marcus T. ; SOUSA, DAMIÃO P. ; ALMEIDA, REINALDO N.",
          reference: "BIOMED RESEARCH INTERNATIONAL, v. 2021, p. 1-17, 2021.",
          doi: "http://dx.doi.org/10.1155/2021/9929805"
        },
        {
          title: "EDITORIAL: Cheminformatics Approaches in Drug Discovery for Neglected Tropical Diseases.",
          authors: "SCOTTI, LUCIANA; MURATOV, EUGENE ; SPECK-PLANCHE, Alejandro ; SCOTTI, Marcus T.",
          reference: "Frontiers in Chemistry, v. 9, p. 71922, 2021. Citações:2",
          doi: "http://dx.doi.org/10.3389/fchem.2021.719223"
        },
        {
          title: "Design, Synthesis and Antifungal Activity of New Schiff Bases Bearing 2-Aminothiophene Derivatives Obtained by Molecular Simplification.",
          authors: "LUNA, ISADORA ; NEVES, WENDELL ; DE LIMA-NETO, REGINALDO ; ALBUQUERQUE, AMANDA ; PITTA, MAÍRA ; RÊGO, MOACYR ; NEVES, REJANE ; SCOTTI, MARCUS ; MENDONÇA-JUNIOR, FRANCISCO",
          reference: "JOURNAL OF THE BRAZILIAN CHEMICAL SOCIETY, v. 32, p. 1017-1029, 2021.",
          doi: "http://dx.doi.org/10.21577/0103-5053.20210004"
        },
        {
          title: "Synthesis, in silico Study and Antileishmanial Evaluation of New Selenides Derived from 7-Chloro-quinoline and N-Phenylacetamides.",
          authors: "HUANG, MIN-FU ; LUIS, JOSÉ ; DA SILVA, ALISON ; ROCHA, JULIANA ; LIMA, TATJANA ; SCOTTI, Marcus ; Scotti, Luciana ; DE OLIVEIRA, RAFAEL ; SOUZA, HELIVALDO ; DE ATHAYDE-FILHO, PETRÔNIO ; BARBOSA-FILHO, JOSÉ",
          reference: "JOURNAL OF THE BRAZILIAN CHEMICAL SOCIETY (ONLINE), v. 32, p. 712-721, 2021.",
          doi: "http://dx.doi.org/10.21577/0103-5053.20200223"
        },
        {
          title: "Analytical techniques to recognize inclusion complexes formation involving monoterpenes and cyclodextrins: A study case with (-) borneol, a food ingredient.",
          authors: "SANTANA, D.V.S. ; TRINDADE, I.A.S. ; CARVALHO, Y.M.B.G. ; CARVALHO-NETO, A.G. ; SILVA, E.C.D. ; SILVA-JÚNIOR, E.F. ; LEITE, R.F.S. ; QUINTANS-JÚNIOR, L.J. ; AQUINO, T.M. ; SERAFINI, M.R. ; GUTERRES, S.S. ; SCOTTI, L. ; SCOTTI, M.T. ; ARAÚJO, A.A.S. ; FRANK, L.A. ; MENEZES, P.P.",
          reference: "FOOD CHEMISTRY, v. 339, p. 127791, 2021.",
          doi: "http://dx.doi.org/10.1016/j.foodchem.2020.127791"
        },
        {
          title: "In Silico Study Examining New Phenylpropanoids Targets with Antidepressant Activity.",
          authors: "DA SILVA CALIXTO, POLIANE ; DE ALMEIDA, REINALDO NÓBREGA ; STIEBBE SALVADORI, MIRIAN G.S. ; DOS SANTOS MAIA, MAYARA ; FILHO, JOSÉ MARIA BARBOSA ; SCOTTI, Marcus Tullius ; Scotti, Luciana",
          reference: "CURRENT DRUG TARGETS, v. 22, p. 539-554, 2021.",
          doi: "http://dx.doi.org/10.2174/1389450121666200902171838"
        },
        {
          title: "Selenium and Computational Studies.",
          authors: "DE SOUSA, NATÁLIA FERREIRA ; SCOTTI, LUCIANA ; MURATOV, EUGENE N. ; SCOTTI, MARCUS TULLIUS",
          reference: "MINI-REVIEWS IN MEDICINAL CHEMISTRY, v. 21, p. 1865-1887, 2021.",
          doi: "http://dx.doi.org/10.2174/1389557521666210112143615"
        },
        {
          title: "Multi-target Drug Discovery via PTML Modeling: Applications to the Design of Virtual Dual Inhibitors of CDK4 and HER2.",
          authors: "Kleandrova, Valeria V. ; SCOTTI, Marcus T. ; SCOTTI, Luciana ; SPECK-PLANCHE, Alejandro",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 21, p. 661-675, 2021.",
          doi: "http://dx.doi.org/10.2174/1568026621666210119112845"
        },
        {
          title: "Recent Medicinal Chemistry Studies for Multitarget Agents-Part I.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
          reference: "CURRENT DRUG TARGETS, v. 22, p. 486-487, 2021.",
          doi: "http://dx.doi.org/10.2174/138945012205210223162131"
        },
        {
          title: "Computer-assisted discovery of compounds with insecticidal activity against Musca domestica and Mythimna separata.",
          authors: "SOARES RODRIGUES, GABRIELA CRISTINA ; MAIA, MAYARA DOS SANTOS ; SILVA CAVALCANTI, ANDREZA BARBOSA ; COSTA BARROS, RENATA PRISCILA ; SCOTTI, LUCIANA ; CESPEDES-ACUÑA, CARLOS L. ; MURATOV, EUGENE N. ; SCOTTI, MARCUS TULLIUS",
          reference: "FOOD AND CHEMICAL TOXICOLOGY, v. 147, p. 111899, 2021.",
          doi: "http://dx.doi.org/10.1016/j.fct.2020.111899"
        },
        {
          title: "Secondary Metabolites Extracted from Annonaceae and Chemotaxonomy Study of Terpenoids.",
          authors: "MENEZES, RENATA ; SESSIONS, ZOE ; MURATOV, EUGENE ; SCOTTI, LUCIANA ; SCOTTI, MARCUS",
          reference: "JOURNAL OF THE BRAZILIAN CHEMICAL SOCIETY, v. 32, p. 2061-2070, 2021.",
          doi: "http://dx.doi.org/10.21577/0103-5053.20210097"
        },
        {
          title: "In Silico Drug Repurposing for Anti-Inflammatory Therapy: Virtual Search for Dual Inhibitors of Caspase-1 and TNF-Alpha.",
          authors: "SPECK-PLANCHE, Alejandro ; Kleandrova, Valeria V. ; SCOTTI, Marcus T.",
          reference: "BIOMOLECULES, v. 11, p. 1832, 2021.",
          doi: "http://dx.doi.org/10.3390/biom11121832"
        },
        {
          title: "Bioactive Essential Oils from Cuban Plants: An Inspiration to Drug Development.",
          authors: "MONZOTE, LIANET ; GARCÍA, JESÚS ; GONZÁLEZ, ROSALIA ; SCOTTI, Marcus Tullius ; SETZER, WILLIAM N.",
          reference: "PLANTS, v. 10, p. 2515, 2021.",
          doi: "http://dx.doi.org/10.3390/plants10112515"
        },
        {
          title: "Lupanes and friedelanes, the first chemical constituents of the aerial parts of Maytenus erythroxylon Reissek.",
          authors: "DE FIGUEIREDO, PEDRO T.R. ; SILVA, EMILLE W.R. ; CORDEIRO, LAÍSA V. ; BARROS, RENATA P.C. ; LIMA, EDELTRUDES ; SCOTTI, Marcus T. ; da Silva, Marcelo S. ; Tavares, Josean F. ; DE O. COSTA, VICENTE C.",
          reference: "Phytochemistry Letters, v. 45, p. 19-24, 2021.",
          doi: "http://dx.doi.org/10.1016/j.phytol.2021.07.004"
        },
        {
          title: "Machine Learning, Molecular Modeling, and QSAR Studies on Natural Products Against Alzheimer?s Disease.",
          authors: "DE MOURA, ÉRIKA PAIVA ; FERNANDES, NATAN DIAS ; MONTEIRO, ALEX FRANCE MESSIAS ; DE MEDEIROS, HERBERT IGOR RODRIGUES ; SCOTTI, Marcus Tullius ; Scotti, Luciana",
          reference: "CURRENT MEDICINAL CHEMISTRY, v. 28, p. 7808-7829, 2021.",
          doi: "http://dx.doi.org/10.2174/0929867328666210603104749"
        },
        {
          title: "Recent Studies on Neglected Drug Design.",
          authors: "DE SOUSA, NATÁLIA FERREIRA ; SCOTTI, LUCIANA ; RODRIGUES, GABRIELA CRISTINA SOARES ; DE MOURA, ÉRIKA PAIVA ; COSTA BARROS, RENATA PRISCILA BARROS ; SESSIONS, ZOE L. ; MURATOV, EUGENE N. ; SCOTTI, MARCUS TULLIUS",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 21, p. 1943-1974, 2021.",
          doi: "http://dx.doi.org/10.2174/1568026621666210920155939"
        },
        {
          title: "Indirect-Acting Pan-Antivirals vs. Respiratory Viruses: A Fresh Perspective on Computational Multi-Target Drug Discovery.",
          authors: "Kleandrova, Valeria V. ; SCOTTI, Marcus T. ; SPECK-PLANCHE, Alejandro",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 21, p. 2687-2693, 2021.",
          doi: "http://dx.doi.org/10.2174/1568026621666211012110819"
        },
        {
          title: "Recent Medicinal Chemistry Studies against Neglected Diseases.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 21, p. 1869-1870, 2021.",
          doi: "http://dx.doi.org/10.2174/156802662121211027093325"
        },
        {
          title: "PTML modeling for peptide discovery: in silico design of non-hemolytic peptides with antihypertensive activity.",
          authors: "Kleandrova, Valeria V. ; ROJAS-VARGAS, JULIO A. ; SCOTTI, Marcus T. ; SPECK-PLANCHE, Alejandro",
          reference: "Molecular Diversity, v. 26, p. 2523-2534, 2021.",
          doi: "http://dx.doi.org/10.1007/s11030-021-10350-z"
        },
        
        {
          title: "A higher flexibility at the SARS-CoV-2 main protease active site compared to SARS-CoV and its potentialities for new inhibitor virtual screening targeting multi-conformers.",
          authors: "ROCHA, RAFAEL E. O. ; CHAVES, ELTON J. F. ; FISCHER, PEDRO H. C. ; COSTA, LEON S. C. ; GRILLO, IGOR BARDEN ; DA CRUZ, LUIZ E. G. ; GUEDES, FABIANA C. ; DA SILVEIRA, CARLOS H. ; SCOTTI, Marcus T. ; CAMARGO, ALEX D. ; MACHADO, KARINA S. ; WERHLI, ADRIANO V. ; FERREIRA, RAFAELA S. ; ROCHA, GERD B. ; DE LIMA, LEONARDO H. F.",
          reference: "JOURNAL OF BIOMOLECULAR STRUCTURE & DYNAMICS, v. 40, p. 9214-9234, 2021.",
          doi: "http://dx.doi.org/10.1080/07391102.2021.1924271"
        },
        {
          title: "Protein modeling.",
          authors: "DE ARAÚJO, RODRIGO S. A. ; MENDONÇA, FRANCISCO J. B. ; SCOTTI, Marcus T. ; Scotti, Luciana",
          reference: "Physical Sciences Reviews, v. 2021, p. 20180161, 2021.",
          doi: "http://dx.doi.org/10.1515/psr-2018-0161"
        }
      ],
    },
    {
      year: 2020,
      list: [
        {
          title: "The Azoles in Pharmacochemistry: Perspectives on the Synthesis of New Compounds and Chemoinformatic Contributions.",
          authors: "de Oliveira Viana, Jéssika ; MONTEIRO, ALEX FRANCE MESSIAS ; FILHO, JOSÉ MARIA BARBOSA ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS",
          reference: "CURRENT PHARMACEUTICAL DESIGN, v. 25, p. 4702-4716, 2020.",
          doi: "http://dx.doi.org/10.2174/1381612825666191125090700"
        },
        {
          title: "Studies of ADMET Properties in Medicinal Chemistry - Part-II.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS TULLIUS",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 19, p. 2742-2742, 2020.",
          doi: "http://dx.doi.org/10.2174/156802661930200103091530"
        },
        {
          title: "Pharmacophore Modeling, Synthesis, Scaffold Hopping and Biological β- Hematin Inhibition Interaction Studies for Anti-malaria Compounds.",
          authors: "FAYYAZI, NEDA ; ESMAEILI, SOMAYEH ; TAHERI, SALMAN ; RIBEIRO, FREDERICO F. ; Scotti, Marcus T. ; Scotti, Luciana ; GHASEMI, JAHAN B. ; SAGHAEI, LOTFOLLAH ; FASSIHI, AFSHIN",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 19, p. 2743-2765, 2020.",
          doi: "http://dx.doi.org/10.2174/1568026619666191116160326"
        },
        {
          title: "In Silico Studies of Potentially Active 2-Amino-Thiophenic Derivatives Against HIV-1.",
          authors: "MONTEIRO, ALEX FRANCE MESSIAS ; SCOTTI, Marcus Tullius ; SCOTTI, L.",
          reference: "International Journal of Quantitative Structure-Property Relationships, v. 5, p. 100-119, 2020.",
          doi: "http://dx.doi.org/10.4018/ijqspr.2020040104"
        },
        {
          title: "Recent Theoretical Studies Concerning Important Tropical Infections.",
          authors: "SCOTTI, Marcus Tullius; MONTEIRO, ALEX FRANCE MESSIAS ; DE OLIVEIRA VIANA, Jéssika ; BEZERRA MENDONÇA JUNIOR, FRANCISCO JAIME ; Ishiki, Hamilton M. ; TCHOUBOUN, ERNESTINE NKWENGOUA ; DE ARAÚJO, RODRIGO SANTOS A. ; SCOTTI, L.",
          reference: "CURRENT MEDICINAL CHEMISTRY, v. 27, p. 795-834, 2020.",
          doi: "http://dx.doi.org/10.2174/0929867326666190711121418"
        },
        {
          title: "Neglected Diseases - New Compounds and Treatments.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
          reference: "CURRENT MEDICINAL CHEMISTRY, v. 27, p. 659-661, 2020.",
          doi: "http://dx.doi.org/10.2174/092986732705200316141940"
        }, // okay até aqui, artigo numero 144
        {
          title: "Development of Novel Galactosylated PLGA Nanoparticles for Hepatocyte Targeting Using Molecular Modelling.",
          authors: "RAPOSO, CLÁUDIA D. ; COSTA, RITA ; PETROVA, KRASIMIRA T. ; BRITO, CATARINA ; Scotti, Marcus T. ; CARDOSO, M. MARGARIDA",
          reference: "Polymers, v. 12, p. 94, 2020.",
          doi: "http://dx.doi.org/10.3390/polym12010094"
        }, // okay até aqui, artigo numero 145
        {
          title: "New Experimental and Computational Tools for Drug Discovery - Part-VIII.",
          authors: "Scotti, Marcus T.; MURATOV, EUGENE N. ; GONZÁLEZ-DÍAZ, HUMBERT",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 20, p. 277-279, 2020.",
          doi: "http://dx.doi.org/10.2174/156802662004200304125617"
        }, // okay até aqui, artigo numero 146
        {
          title: "Secondary Metabolites with Antioxidant Activities for the Putative Treatment of Amyotrophic Lateral Sclerosis (ALS): -Experimental Evidences-.",
          authors: "SILVA, JAMIRE M. ; NOBRE, MICHELANGELA S. C. ; ALBINO, SONALY L. ; LÓCIO, LUCAS L. ; NASCIMENTO, AGNIS P. S. ; Scotti, Luciana ; SCOTTI, Marcus Tullius ; OSHIRO-JUNIOR, JOÃO A. ; LIMA, MARIA C. A. ; MENDONCA JUNIOR, FJB ; MOURA, RICARDO O.",
          reference: "OXIDATIVE MEDICINE AND CELLULAR LONGEVITY (ONLINE), v. 2020, p. 1-22, 2020.",
          doi: "http://dx.doi.org/10.1155/2020/5642029"
        }, // okay até aqui, artigo numero 147
        {
          title: "Computer-Assisted Design of Thiophene-Indole Hybrids as Leishmanial Agents.",
          authors: "FÉLIX, MAYARA BARBALHO ; DE ARAÚJO, RODRIGO SANTOS AQUINO ; BARROS, RENATA PRISCILA COSTA ; DE SIMONE, CARLOS ALBERTO ; RODRIGUES, RAIZA RAIANNE LUZ ; DE LIMA NUNES, THAÍS AMANDA ; DA FRANCA RODRIGUES, KLINGER ANTONIO ; JUNIOR, FRANCISCO JAIME BEZERRA MENDONÇA ; MURATOV, EUGENE ; SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 20, p. 1700-1715, 2020. Citações:4",
          doi: "http://dx.doi.org/10.2174/1568026620666200616142120"
        }, // okay até aqui, artigo numero 148
        {
          title: "Lignans and Neolignans anti-tuberculosis identified by QSAR and Molecular Modeling.",
          authors: "DOS SANTOS MAIA, MAYARA ; DE SOUSA, NATÁLIA FERREIRA ; RODRIGUES, GABRIELA CRISTINA SOARES ; MONTEIRO, ALEX FRANCE MESSIAS ; SCOTTI, Marcus Tullius ; SCOTTI, L.",
          reference: "COMBINATORIAL CHEMISTRY & HIGH THROUGHPUT SCREENING, v. 23, p. 504-516, 2020.",
          doi: "http://dx.doi.org/10.2174/1386207323666200226094940"
        }, // okay até aqui, artigo numero 149
        {
          title: "Planejamento racional de um candidato a fármaco: estudos in silico, síntese e elucidação estrutural.",
          authors: "MEDEIROS, HERBERT IGOR RODRIGUES DE ; CAIANA, RODRIGO RIBEIRO ALVES ; FERNANDES, NATAN DIAS ; MEDEIROS JÚNIOR, FRANCISCO CESINO DE ; SCOTTI, Marcus Tullius ; SCOTTI, L. ; FREITAS, JULIANO CARLO RUFINO DE",
          reference: "RESEARCH, SOCIETY AND DEVELOPMENT, v. 9, p. e77391110605, 2020.",
          doi: "http://dx.doi.org/10.33448/rsd-v9i11.10605"
        }, // okay até aqui, artigo numero 150
        {
          title: "Quantitative Structure-Activity Relationship Modeling and Docking of Monoterpenes with Insecticidal Activity Against Snyder and.",
          authors: "SOARES RODRIGUES, GABRIELA CRISTINA ; DOS SANTOS MAIA, MAYARA ; MURATOV, EUGENE N. ; SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "JOURNAL OF AGRICULTURAL AND FOOD CHEMISTRY, v. 2020, p. acs.jafc.0c00272-280, 2020.",
          doi: "http://dx.doi.org/10.1021/acs.jafc.0c00272"
        },
        {
          title: "Recent Advancement in Computer-Aided Drug Design.",
          authors: "SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "CURRENT PHARMACEUTICAL DESIGN, v. 26, p. 1635-1636, 2020.",
          doi: "http://dx.doi.org/10.2174/138161282615200518092124"
        },
        {
          title: "Virtual Screening and the In Vitro Assessment of the Antileishmanial Activity of Lignans.",
          authors: "MAIA, MAYARA DOS SANTOS ; SILVA, JOANDA PAOLLA RAIMUNDO E ; NUNES, THAÍS AMANDA DE LIMA ; SOUSA, JULYANNE MARIA SARAIVA DE ; RODRIGUES, GABRIELA CRISTINA SOARES ; MONTEIRO, ALEX FRANCE MESSIAS ; TAVARES, JOSEAN FECHINE ; RODRIGUES, KLINGER ANTONIO DA FRANCA ; MENDONÇA-JUNIOR, FRANCISCO JAIME B. ; SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "MOLECULES, v. 25, p. 2281, 2020.",
          doi: "http://dx.doi.org/10.3390/molecules25102281"
        },
        {
          title: "Bioactive Compounds from the Aerial Parts of Evolvulus linarioides.",
          authors: "PEREIRA, LAIANE C. O. ; ABREU, LUCAS S. ; SILVA, JOANDA P. R. E ; MACHADO, FRANCISCA S. V. L. ; Queiroga, Cinthia S. ; DO ESPÍRITO-SANTO, RENAN F. ; AGNELO-SILVA, DIEGO F. DE ; VILLARREAL, CRISTIANE F. ; AGRA, MARIA DE F. ; SCOTTI, Marcus Tullius ; COSTA, VICENTE C. DE O. ; Tavares, Josean F. ; SILVA, M. S.",
          reference: "JOURNAL OF NATURAL PRODUCTS, v. 83, p. 1515-1523, 2020.",
          doi: "http://dx.doi.org/10.1021/acs.jnatprod.9b01189"
        },
        {
          title: "Dolichocarpols A-F, Unprecedented Macrocyclic Humulene-Type Sesquiterpenoids from Anaxagorea dolichocarpa.",
          authors: "SALES, KAIO ARAGÃO ; PINHEIRO, ANDERSON ANGEL VIEIRA ; DE ARAÚJO, DIEGO IGOR ALVES FERNANDES ; ABREU, LUCAS SILVA ; DE ANDRADE, RODRIGO SILVA ; de Fátima Agra, Maria ; SOBRAL, MARIANNA VIEIRA ; FERREIRA, RAFAEL CARLOS ; BRAZ-FILHO, RAIMUNDO ; SCOTTI, Marcus Tullius ; Tavares, Josean Fechine ; SILVA, M. S.",
          reference: "ACS Omega, v. 5, p. 13656-13663, 2020.",
          doi: "http://dx.doi.org/10.1021/acsomega.0c00690"
        },
        {
          title: "Computer-aided Drug Design Investigations for Benzothiazinone Derivatives Against Tuberculosis.",
          authors: "VIANA, JÉSSIKA O. ; Scotti, Marcus T. ; Scotti, Luciana",
          reference: "COMBINATORIAL CHEMISTRY & HIGH THROUGHPUT SCREENING, v. 23, p. 66-82, 2020.",
          doi: "http://dx.doi.org/10.2174/1386207323666200117102316"
        },
        {
          title: "Consensus Analyses in Molecular Docking Studies Applied to Medicinal Chemistry.",
          authors: "DOS SANTOS MAIA, MAYARA ; SOARES RODRIGUES, GABRIELA CRISTINA ; SILVA CAVALCANTI, ANDREZA BARBOSA ; SCOTTI, LUCIANA ; SCOTTI, Marcus Tullius",
          reference: "MINI-REVIEWS IN MEDICINAL CHEMISTRY, v. 20, p. 1322-1340, 2020.",
          doi: "http://dx.doi.org/10.2174/1568026620999200305144537"
        },
        {
          title: "Ligand- and structure-based virtual screening of Lamiaceae diterpenes with potential activity against a novel coronavirus (2019-nCoV).",
          authors: "RODRIGUES, GABRIELA CRISTINA SOARES ; DOS SANTOS MAIA, MAYARA ; DE MENEZES, RENATA PRISCILA BARROS ; CAVALCANTI, ANDREZA BARBOSA SILVA ; DE SOUSA, NATÁLIA FERREIRA ; DE MOURA, ÉRIKA PAIVA ; MONTEIRO, ALEX FRANCE MESSIAS ; SCOTTI, LUCIANA ; SCOTTI, Marcus Tullius",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 20, p. 2126-2145, 2020.",
          doi: "http://dx.doi.org/10.2174/1381612826666200203124330"
        },
        {
          title: "Annonaceae Family Alkaloids as Agents Against Leishmaniasis: A Review and Molecular Docking Evaluation.",
          authors: "LORENZO, VITOR PRATES ; SCOTTI, LUCIANA ; DA SILVA ALMEIDA, JACKSON ROBERTO GUEDES ; SCOTTI, MARCUS TULLIUS",
          reference: "CURRENT DRUG METABOLISM, v. 21, p. 482-492, 2020.",
          doi: "http://dx.doi.org/10.2174/1389557520666200204121129"
        },
        {
          title: "Advances in Nanoparticles as Anticancer Drug Delivery Vector: Need of this Century.",
          authors: "ALI, IMRAN ; MUKHTAR, SOFI D. ; ALI, HEYAM S. ; Scotti, Marcus T. ; Scotti, Luciana",
          reference: "CURRENT PHARMACEUTICAL DESIGN, v. 26, p. 1637-1649, 2020.",
          doi: "http://dx.doi.org/10.1016/j.jep.2020.112678"
        },
        {
          title: "Progress in Polymeric Nano-Medicines for Theranostic Cancer Treatment.",
          authors: "ALI, IMRAN ; ALSEHLI, MOSA ; SCOTTI, LUCIANA ; TULLIUS SCOTTI, MARCUS ; TSAI, SHANG-TING ; YU, RUEI-SIANG ; HSIEH, MING FA ; CHEN, JUNG-CHIH",
          reference: "Polymers, v. 12, p. 598, 2020.",
          doi: "http://dx.doi.org/10.3390/polym12030598"
        },
        {
          title: "Psychopharmacological effects of riparin III from Aniba riparia (Nees) Mez. (Lauraceae) supported by metabolic approach and multivariate data analysis.",
          authors: "GOLZIO DOS SANTOS, SÓCRATES ; FERNANDES GOMES, ISIS ; FERNANDES DE OLIVEIRA GOLZIO, ADRIANA MARIA ; LOPES SOUTO, AUGUSTO ; SCOTTI, Marcus Tullius ; FECHINE TAVARES, JOSEAN ; CHAVEZ GUTIERREZ, STANLEY JUAN ; NÓBREGA DE ALMEIDA, REINALDO ; BARBOSA-FILHO, JOSÉ MARIA ; Sobral da Silva, Marcelo",
          reference: "BMC Complementary Medicine and Therapies, v. 20, p. 149, 2020.",
          doi: "http://dx.doi.org/10.1186/s12906-020-02938-z"
        },
        {
          title: "Antinociceptive Activity of Chemical Components of Essential Oils That Involves Docking Studies: A Review.",
          authors: "ASSIS, DAVIDSON BARBOSA ; ARAGÃO NETO, HUMBERTO DE CARVALHO ; DA FONSÊCA, DIOGO VILAR ; DE ANDRADE, HUMBERTO HUGO NUNES ; BRAGA, RENAN MARINHO ; BADR, NADER ; MAIA, MAYARA DOS SANTOS ; CASTRO, RICARDO DIAS ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS ; DE ALMEIDA, REINALDO NÓBREGA",
          reference: "Frontiers in Pharmacology, v. 11, p. 777, 2020.",
          doi: "http://dx.doi.org/10.3389/fphar.2020.00777"
        },
        {
          title: "Pyrimidine Derivatives: QSAR Studies of Larvicidal Activity against Aedes aegypti.",
          authors: "MONTE, ZENAIDE ; NAVARRO, DANIELA ; AGUIAR, JÚLIO ; NASCIMENTO, JESSICA ; SCOTTI, MARCUS ; Scotti, Luciana ; BARROS, RENATA ; SANTOS, ALINE ; PEREIRA, VALÉRIA ; FALCÃO, EMERSON ; MELO, SEBASTIÃO",
          reference: "JOURNAL OF THE BRAZILIAN CHEMICAL SOCIETY, v. 31, p. 1531-1540, 2020.",
          doi: "http://dx.doi.org/10.21577/0103-5053.20200039"
        },
        {
          title: "Identification of New Targets and the Virtual Screening of Lignans against Alzheimer?s Disease.",
          authors: "DOS SANTOS MAIA, MAYARA ; RODRIGUES, GABRIELA CRISTINA SOARES ; DE SOUSA, NATÁLIA FERREIRA ; SCOTTI, Marcus Tullius ; Scotti, Luciana ; MENDONÇA-JUNIOR, FRANCISCO JAIME B.",
          reference: "Oxidative Medicine and Cellular Longevity, v. 2020, p. 1-19, 2020.",
          doi: "http://dx.doi.org/10.1155/2020/3098673"
        },
        {
          title: "Characterization of β-cyclodextrin/myrtenol complex and its protective effect against nociceptive behavior and cognitive impairment in a chronic musculoskeletal pain model.",
          authors: "HEIMFARTH, LUANA ; DOS ANJOS, KLÉCIA SANTOS ; DE CARVALHO, YASMIM MARIA BARBOSA GOMES ; DOS SANTOS, BRUNO LUCENA ; SERAFINI, MAIRIM RUSSO ; DE CARVALHO NETO, ANTÔNIO GUILHERME ; NUNES, PAULA SANTOS ; BESERRA FILHO, JOSÉ IVO ARAÚJO ; DA SILVA, SARA PEREIRA ; RIBEIRO, ALESSANDRA MUSSI ; BEZERRA, DANIEL PEREIRA ; MARRETO, RICARDO NEVES ; DE SOUZA SIQUEIRA QUINTANS, JULLYANA ; DE SOUZA ARAÚJO, ADRIANO ANTUNES ; MELO COUTINHO, HENRIQUE DOUGLAS ; Scotti, Marcus Tullius ; Scotti, Luciana ; QUINTANS-JÚNIOR, LUCINDO JOSÉ",
          reference: "CARBOHYDRATE POLYMERS, v. 244, p. 116448, 2020.",
          doi: "http://dx.doi.org/10.1016/j.carbpol.2020.116448"
        },
        {
          title: "Cell-based multi-target QSAR model for design of virtual versatile inhibitors of liver cancer cell lines.",
          authors: "KLEANDROVA, V.V. ; SCOTTI, M.T. ; SCOTTI, L. ; NAYARISSERI, A. ; Speck-Planche, A.",
          reference: "SAR AND QSAR IN ENVIRONMENTAL RESEARCH, v. 31, p. 1-22, 2020.",
          doi: "http://dx.doi.org/10.1080/1062936x.2020.1818617"
        },
        {
          title: "Virtual Screening of Secondary Metabolites of the Family Velloziaceae J. Agardh with Potential Antimicrobial Activity.",
          authors: "PINHEIRO, ANDERSON ; BARROS, RENATA ; DE ASSIS, EDILEUZA ; MAIA, MAYARA ; DE ARAÚJO, DIEGO ; SALES, KAIO ; SCOTTI, LUCIANA ; TAVARES, JOSEAN ; SCOTTI, MARCUS ; DA SILVA, MARCELO",
          reference: "JOURNAL OF THE BRAZILIAN CHEMICAL SOCIETY, v. 31, p. 2114-2119, 2020.",
          doi: "http://dx.doi.org/10.21577/0103-5053.20200112" // okay até aqui, artigo numero 172
        },
        {
          title: "Docking Prediction, Antifungal Activity, Anti-Biofilm Effects on Candida spp., and Toxicity against Human Cells of Cinnamaldehyde.",
          authors: "DA NÓBREGA ALVES, DANIELLE ; MONTEIRO, ALEX FRANCE MESSIAS ; ANDRADE, PATRÍCIA NÉRIS ; LAZARINI, JOSY GOLDONI ; ABÍLIO, GISELY MARIA FREIRE ; GUERRA, FELIPE QUEIROGA SARMENTO ; SCOTTI, Marcus Tullius ; SCOTTI, L. ; ROSALEN, PEDRO LUIZ ; CASTRO, RICARDO DIAS DE",
          reference: "MOLECULES, v. 25, p. 5969, 2020.",
          doi: "http://dx.doi.org/10.3390/molecules25245969"
        },
        {
          title: "Selection of antileishmanial sesquiterpene lactones from SistematX database using a combined ligand-/structure-based virtual screening approach.",
          authors: "HERRERA-ACEVEDO, CHONNY ; DOS SANTOS MAIA, MAYARA ; CAVALCANTI, ÉLIDA BATISTA VIEIRA SOUSA ; COY-BARRERA, ERICSSON ; SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "MOLECULAR DIVERSITY, v. 25, p. 2411-2427, 2020.",
          doi: "http://dx.doi.org/10.1007/s11030-020-10139-6"
        },
        {
          title: "Discovery of Alternative Chemotherapy Options for Leishmaniasis via Computational Studies of Asteraceae.",
          authors: "HERRERA-ACEVEDO, CHONNY ; PERDOMO-MADRIGAL, CAMILO ; MURATOV, EUGENE N. ; SCOTTI, LUCIANA ; SCOTTI, Marcus Tullius",
          reference: "CHEMMEDCHEM (INTERNET), v. 16, p. 1234-1245, 2020.",
          doi: "http://dx.doi.org/10.1002/cmdc.202000862"
        },
        {
          title: "Virtual screening of natural products database.",
          authors: "DE SOUSA LUIS, JOSÉ ALIXANDRE ; BARROS, RENATA PRISCILA COSTA ; DE SOUSA, NATÁLIA FERREIRA ; MURATOV, EUGENE ; SCOTTI, LUCIANA ; SCOTTI, Marcus Tullius",
          reference: "MINI-REVIEWS IN MEDICINAL CHEMISTRY, v. 20, p. 2655-2728, 2020.",
          doi: "http://dx.doi.org/10.2174/1389557520666200730161549"
        },
        {
          title: "RMD86, a thiophene derivative, promotes antinociceptive and antipyretic activities in mice.",
          authors: "DA CRUZ, RYLDENE MARQUES DUARTE ; BRAGA, RENAN MARINHO ; DE ANDRADE, HUMBERTO HUGO NUNES ; MONTEIRO, ÁLEFE BRITO ; LUNA, ISADORA SILVA ; DA CRUZ, RAYSSA MARQUES DUARTE ; SCOTTI, Marcus Tullius ; MENDONÇA-JUNIOR, FRANCISCO JAIME BEZERRA ; DE ALMEIDA, REINALDO NÓBREGA",
          reference: "HELIYON, v. 6, p. e05520, 2020.",
          doi: "http://dx.doi.org/10.1016/j.heliyon.2020.e05520"
        },
        {
          title: "Virtual screening and assessment of anticancer potential of selenium-based compounds against HL-60 and MCF7 cells.",
          authors: "FERREIRA DE QUEIROZ, ERICKA FERNANDA ; DE SOUSA LUIS, JOSÉ ALIXANDRE ; DE SOUSA DANTAS, DIEGO ; PEREIRA ARRUDA, LÚCIA CRISTINA ; CORDEIRO BENTO DA SILVA, ELLEN ; DE SOUSA E SILVA, JOÃO MANOEL ; DA SILVA SOUZA, HELIVALDO DIOGENES ; COSTA BARROS, RENATA PRISCILA ; DE MASCENA COSTA, LUCIANA AMARAL ; DE ATHAYDE FILHO, PETRÔNIO FIGUEIRAS ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS ; GOMES FILHO, MANOEL ADRIÃO",
          reference: "Future Medicinal Chemistry, v. 12, p. 2191-2207, 2020.",
          doi: "http://dx.doi.org/10.4155/fmc-2020-0110"
        },
        {
          title: "Orofacial antinociceptive activity and anchorage molecular mechanism in silico of geraniol.",
          authors: "COSTA, TEREZA KARLA VIEIRA LOPES DA ; BARROS, MARIANA SILVA ; BRAGA, RENAN MARRINHO ; VIANA, JÉSSIKA DE OLIVEIRA ; SOUSA, FREDERICO BARBOSA DE ; SCOTTI, L. ; SCOTTI, Marcus Tullius ; BATISTA, ANDRÉ ULISSES DANTAS ; ALMEIDA, REINALDO NÓBREGA DE ; CASTRO, RICARDO DIAS DE",
          reference: "BRAZILIAN ORAL RESEARCH, v. 34, p. 1-11, 2020.",
          doi: "http://dx.doi.org/10.1590/1807-3107bor-2020.vol34.0094" // okay até aqui, artigo numero 179
        }
      ],
    },
    {
      year: 2019,
      list: [
        {
          title: "Antiprotozoal investigation of 20 plant metabolites on Trypanosoma cruzi and Leishmania amazonensis amastigotes. Atalantoflavone alters the mitochondrial membrane potential.",
          authors: "LEMOS DA SILVA, LAYZON ANTONIO; HÖEHR DE MORAES, MILENE; SCOTTI, Marcus Tullius; SCOTTI, L.; DE JESUS SOUZA, RAFAELA; NANTCHOUANG OUETE, JUDITH L.; BIAVATTI, MAIQUE WEBER; STEINDEL, MARIO; SANDJO, LOUIS PERGAUD",
          reference: "PARASITOLOGY, v. 2019, p. 1-8, 2019.",
          doi: "http://dx.doi.org/10.1017/s0031182019000052"
        },
        {
          title: "Predictive Computational Tools for Assessment of Ecotoxicological Activity of Organic Micropollutants in Various Water Sources in Brazil.",
          authors: "DE'MORAIS'E'SILVA, LUANA; LORENZO, VITOR PRATES; LOPES, WILTON SILVA; SCOTTI, L.; SCOTTI, Marcus Tullius",
          reference: "Molecular Informatics, v. 38, p. 1-11, 2019.",
          doi: "http://dx.doi.org/10.1002/minf.201800156"
        },
        {
          title: "Active Essential Oils and Their Components in Use against Neglected Diseases and Arboviruses.",
          authors: "LUNA, EMANUELA COUTINHO; LUNA, ISADORA SILVA; SCOTTI, LUCIANA; MONTEIRO, ALEX FRANCE M.; SCOTTI, Marcus Tullius; DE MOURA, RICARDO OLÍMPIO; DE ARAÚJO, RODRIGO SANTOS AQUINO; MONTEIRO, KADJA LUANA CHAGAS; AQUINO, T. M.; RIBEIRO, FREDERICO FÁVARO; MENDONÇA, FRANCISCO JAIME BEZERRA",
          reference: "Oxidative Medicine and Cellular Longevity, v. 2019, p. 1-52, 2019.",
          doi: "http://dx.doi.org/10.1155/2019/6587150"
        },
        {
          title: "Antifungal Activity, Mode of Action, Docking Prediction and Anti-biofilm Effects of (+)-β-pinene Enantiomers against Candida spp..",
          authors: "DE MACÊDO ANDRADE, ANA CLÁUDIA; ROSALEN, PEDRO LUIZ; FREIRES, IRLAN ALMEIDA; SCOTTI, LUCIANA; SCOTTI, MARCUS TULIUS; AQUINO, SABRINA GARCIA; DE CASTRO, RICARDO DIAS",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 18, p. 2481-2490, 2019.",
          doi: "http://dx.doi.org/10.2174/1568026618666181115103104"
        },
        {
          title: "Hybrid Compounds in the Search for Alternative Chemotherapeutic Agents against Neglected Tropical Diseases.",
          authors: "HERRERA ACEVEDO, CHONNY; SCOTTI, LUCIANA; ALVES, MATEUS F.; DE F.F.M. DINIZ, MARGARETH; TULLIUS SCOTTI, MARCUS",
          reference: "LETTERS IN ORGANIC CHEMISTRY, v. 16, p. 81-92, 2019.",
          doi: "http://dx.doi.org/10.2174/1570178615666180402123057"
        },
        {
          title: "2-Allylphenol Reduces IL-1 β and TNF-α, Promoting Antinociception through Adenosinergic, Anti-Inflammatory, and Antioxidant Mechanisms.",
          authors: "ARAGÃO NETO, HUMBERTO DE CARVALHO; DA FONSÊCA, DIOGO VILAR; BRAGA, RENAN MARINHO; SCOTTI, Marcus Tullius; DO NASCIMENTO, TEREZINHA WEYNE ARAÚJO BORGES; ASSIS, DAVIDSON BARBOSA; RODRIGUES-MASCARENHAS, SANDRA; SILVA, LUIZ HENRIQUE AGRA CAVALCANTE; GALVÃO, JOSÉ GUILHERME FERREIRA MARQUES; ROCHA, HUGO ALEXANDRE OLIVEIRA; VIDAL, ARTHUR ANTUNES JACOME; FILHO, JOSÉ MARIA BARBOSA; DE ALMEIDA, REINALDO NÓBREGA",
          reference: "Oxidative Medicine and Cellular Longevity, v. 2019, p. 1-14, 2019.",
          doi: "http://dx.doi.org/10.1155/2019/1346878"
        },
        {
          title: "Larvicidal Compounds Extracted from Helicteres velutina K. Schum (Sterculiaceae) Evaluated against Aedes aegypti L..",
          authors: "FERNANDES, DIÉGINA A.; BARROS, RENATA P. C.; TELES, YANNA C. F.; OLIVEIRA, LOUISE H. G.; LIMA, JÉSSICA B.; Scotti, Marcus T.; NUNES, FABÍOLA C.; CONCEIÇÃO, ADILVA S.; VANDERLEI DE SOUZA, MARIA DE FÁTIMA",
          reference: "MOLECULES, v. 24, p. 2315, 2019.",
          doi: "http://dx.doi.org/10.3390/molecules24122315"
        },
        {
          title: "Multi-Target Drugs Against Metabolic Disorders.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
          reference: "Endocrine Metabolic & Immune Disorders-Drug Targets, v. 19, p. 389-390, 2019.",
          doi: "http://dx.doi.org/10.2174/187153031904190506102405"
        },
        {
          title: "Virtual Screening of Natural Products to Select Compounds with Potential Anticancer Activity.",
          authors: "CAVALCANTI, ÉLIDA B.V.S.; FÉLIX, MAYARA B.; SCOTTI, LUCIANA; SCOTTIA, MARCUS T.",
          reference: "Anti-Cancer Agents in Medicinal Chemistry, v. 19, p. 154-171, 2019.",
          doi: "http://dx.doi.org/10.2174/1871520618666181119110934"
        },
        {
          title: "Natural Bioactive Products with Antioxidant Properties Useful in Neurodegenerative Diseases.",
          authors: "MENDONÇA-JUNIOR, FRANCISCO J. B.; Scotti, Marcus T.; NAYARISSERI, ANURAJ; ZONDEGOUMBA, ERNESTINE N. T.; Scotti, Luciana",
          reference: "Oxidative Medicine and Cellular Longevity, v. 2019, p. 1-2, 2019.",
          doi: "http://dx.doi.org/10.1155/2019/7151780"
        },
        {
          title: "Combined structure- and ligand-based virtual screening aiding discovery of selenoglycolicamides as potential multitarget agents against Leishmania species.",
          authors: "DE SOUSA LUIS, JOSÉ ALIXANDRE; DA SILVA SOUZA, HELIVALDO DIÓGENES; LIRA, BRUNO FREITAS; DA SILVA ALVES, FRANCINARA; DE ATHAYDE-FILHO, PETRÔNIO FILGUEIRAS; DE SOUZA LIMA, TATJANA KEESEN; ROCHA, JULIANA CÂMARA; MENDONÇA JUNIOR, FRANCISCO JAIME BEZERRA; SCOTTI, LUCIANA; SCOTTI, MARCUS TULLIUS",
          reference: "JOURNAL OF MOLECULAR STRUCTURE, v. 1198, p. 126872, 2019.",
          doi: "http://dx.doi.org/10.1016/j.molstruc.2019.126872"
        },
        {
          title: "Computer-Aided Chemotaxonomy and Bioprospecting Study of Diterpenes of the Lamiaceae Family.",
          authors: "BARBOSA SILVA CAVALCANTI, ANDREZA; COSTA BARROS, RENATA PRISCILA; COSTA, VICENTE CARLOS DE OLIVEIRA; Sobral da Silva, Marcelo; FECHINE TAVARES, JOSEAN; SCOTTI, LUCIANA; SCOTTI, MARCUS TULLIUS",
          reference: "MOLECULES, v. 24, p. 3908, 2019.",
          doi: "http://dx.doi.org/10.3390/molecules24213908"
        },
        {
          title: "Design, synthesis and pharmacological evaluation of CVIB, a codrug of carvacrol and ibuprofen as a novel anti-inflammatory agent.",
          authors: "DE OLIVEIRA PEDROSA ROLIM, MICHELLE; DE ALMEIDA, ANDERSON RODRIGUES; DA ROCHA PITTA, MAIRA GALDINO; DE MELO RÊGO, MOACYR JESUS BARRETO; QUINTANS-JÚNIOR, LUCINDO JOSÉ; DE SOUZA SIQUEIRA QUINTANS, JULLYANA; HEIMFARTH, LUANA; SCOTTI, LUCIANA; SCOTTI, MARCUS TULLIUS; DA CRUZ, RYLDENE MARQUES DUARTE; DE ALMEIDA, REINALDO NÓBREGA",
          reference: "INTERNATIONAL IMMUNOPHARMACOLOGY, v. 76, p. 105856, 2019.",
          doi: "http://dx.doi.org/10.1016/j.intimp.2019.105856"
        },
        {
          title: "Tri- and Diterpenoids from Stillingia loranthacea as Inhibitors of Zika Virus Replication.",
          authors: "ABREU, LUCAS SILVA ; DO NASCIMENTO, YURI MANGUEIRA ; COSTA, RAFAEL DOS SANTOS ; GUEDES, MARIA LENISE SILVA ; SOUZA, BÁRBARA NAYANE ROSÁRIO FERNANDES ; PENA, LINDOMAR JOSÉ ; COSTA, VICENTE CARLOS DE OLIVEIRA ; SCOTTI, Marcus Tullius ; BRAZ-FILHO, RAIMUNDO ; BARBOSA-FILHO, JOSÉ MARIA ; DA SILVA, MARCELO SOBRAL ; VELOZO, EUDES DA SILVA ; Tavares, Josean Fechine",
          reference: "JOURNAL OF NATURAL PRODUCTS, v. 82, p. 2721-2730, 2019.",
          doi: "http://dx.doi.org/10.1021/acs.jnatprod.9b00251"
        },
        {
          title: "p-Cymene attenuates cancer pain via inhibitory pathways and modulation of calcium currents.",
          authors: "SANTOS, WAGNER B.R. ; MELO, MARLANGE A.O. ; ALVES, RAFAEL S. ; DE BRITO, RENAN G. ; RABELO, THALLITA K. ; PRADO, LINDAURA DA S. ; SILVA, VIRGINIA K. DOS S. ; BEZERRA, DANIEL P. ; DE MENEZES-FILHO, JOSÉ E.R. ; SOUZA, DIEGO S. ; DE VASCONCELOS, CARLA M.L. ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS ; LUCCA JÚNIOR, WALDECY DE ; QUINTANS-JÚNIOR, LUCINDO J. ; GUIMARÃES, ADRIANA G.",
          reference: "PHYTOMEDICINE, v. 61, p. 152836, 2019.",
          doi: "http://dx.doi.org/10.1016/j.phymed.2019.152836"
        },
        {
          title: "BET bromodomain inhibitors: fragment-based in silico design using multi-target QSAR models.",
          authors: "SPECK-PLANCHE, Alejandro ; Scotti, Marcus T.",
          reference: "MOLECULAR DIVERSITY, v. 23, p. 555-572, 2019.",
          doi: "http://dx.doi.org/10.1007/s11030-018-9890-8"
        },
        {
          title: "PERSPECTIVES IN MEDICINAL CHEMISTRY: Neglected Diseases - New Compounds and Treatments.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS TULLIUS",
          reference: "CURRENT MEDICINAL CHEMISTRY, v. 26, p. 4501-4503, 2019.",
          doi: "http://dx.doi.org/10.2174/092986732624190927115600"
        },
        {
          title: "Identification of Essential 2D and 3D Chemical Features for Discovery of the Novel Tubulin Polymerization Inhibitors.",
          authors: "AZIMI, FATEME ; GHASEMI, JAHAN B. ; SAGHAEI, LOTFOLLAH ; HASSANZADEH, FARSHID ; MAHDAVI, MOHAMMAD ; SADEGHI-ALIABADI, HOJJAT ; Scotti, Marcus T. ; Scotti, Luciana",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 19, p. 1092-1120, 2019.",
          doi: "http://dx.doi.org/10.2174/1568026619666190520083655"
        },
        {
          title: "Exploring Secondary Metabolites Database of Apocynaceae, Menispermaceae, and Annonaceae to Select Potential Anti-HCV Compounds.",
          authors: "BARROS, RENATA P.C. ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 19, p. 900-913, 2019.",
          doi: "http://dx.doi.org/10.2174/1568026619666190510094228"
        },
        {
          title: "New Experimental and Computational Tools for Drug Discovery. - Part-VII.",
          authors: "Scotti, Markus T.; MURATOV, EUGENE N. ; GONZÁLEZ-DÍAZ, HUMBERT",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 19, p. 898-899, 2019.",
          doi: "http://dx.doi.org/10.2174/156802661911190725100827"
        },
        {
          title: "Synthesis of new cyclic imides derived from safrole, structure- and ligand-based approaches to evaluate potential new multitarget agents against species of Leishmania.",
          authors: "DE SOUSA LUIS, JOSÉ ALIXANDRE ; DA SILVA COSTA, NORMANDO ALEXANDRE ; LUIS, CRISTIANE COSMO SILVA ; LIRA, BRUNO FREITAS ; ATHAYDE-FILHO, PETRÔNIO FILGUEIRAS ; DE SOUZA LIMA, TATJANA KEESEN ; DA CÂMARA ROCHA, JULIANA ; SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "Medicinal Chemistry, v. 15, p. 39-51, 2019.",
          doi: "http://dx.doi.org/10.2174/1573406415666190430144950"
        },
        {
          title: "Studies of ADMET Properties in Medicinal Chemistry - Part-I.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS TULLIUS",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 19, p. 2641-2642, 2019.",
          doi: "http://dx.doi.org/10.2174/156802661929191211093403"
        },
        {
          title: "Medicinal Chemistry Studies Applied to Protein Targets.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
          reference: "CURRENT PROTEIN & PEPTIDE SCIENCE, v. 20, p. 1132-1134, 2019.",
          doi: "http://dx.doi.org/10.2174/138920372012191114113702"
        },
        {
          title: "In Silico and Molecular Docking Studies That Address Viral (Std) Transmission Points.",
          authors: "MONTEIRO, ALEX FRANCE MESSIAS ; DE OLIVEIRA VIANA, JESSIKA ; MURATOV, ENGENE ; SCOTTI, Marcus Tullius ; Scotti, Luciana",
          reference: "CURRENT PROTEIN & PEPTIDE SCIENCE, v. 20, p. 1135-1150, 2019.",
          doi: "http://dx.doi.org/10.2174/1389203720666190311142747"
        },
        {
          title: "In Silico Studies For Bacterystic Evaluation Against Staphylococcus Aureus Of 2-Naftomic Acid Analogues.",
          authors: "MONTEIRO, ALEX FRANCE MESSIAS ; SCOTTI, Marcus Tullius ; SPECK-PLANCHE, Alejandro ; BARROS, RENATA PRISCILA COSTA ; Scotti, Luciana",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 19, p. 293-304, 2019.",
          doi: "http://dx.doi.org/10.2174/1568026619666191206111742"
        },
        {
          title: "Advances in Chiral Separations at Nano Level.",
          authors: "BASHEER, AL ARSH ; HUSSAIN, IQBAL ; SCOTTI, Marcus Tullius ; Scotti, Luciana ; ALI, IMRAN",
          reference: "Current Analytical Chemistry, v. 15, p. 351-368, 2019.",
          doi: "http://dx.doi.org/10.2174/1573407215666190131122413"
        }
      ],
    },
    {
      year: 2018,
      list: [
        {
          title: "In silico studies designed to select sesquiterpene lactones with potential antichagasic activity from an in-house Asteraceae database.",
          authors: "HERRERA-ACEVEDO, CHONNY ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS",
          reference: "ChemMedChem, v. 13, p. 634-645, 2018. Citações:31",
          doi: "http://dx.doi.org/10.1002/cmdc.201700743"
        },
        {
          title: "SistematX, an Online Web-Based Cheminformatics Tool for Data Management of Secondary Metabolites.",
          authors: "SCOTTI, MARCUS; HERRERA-ACEVEDO, CHONNY ; OLIVEIRA, TIAGO ; COSTA, RENAN ; SANTOS, SILAS ; RODRIGUES, RICARDO ; SCOTTI, Luciana ; DA-COSTA, FERNANDO",
          reference: "MOLECULES, v. 23, p. 103, 2018.",
          doi: "http://dx.doi.org/10.3390/molecules23010103"
        },
        {
          title: "Anthocyanins: Multi-Target Agents for Prevention and Therapy of Chronic Diseases.",
          authors: "PUTTA, SWATHI ; YARLA, NAGENDRA S. ; PELUSO, ILARIA ; TIWARI, DINESH K. ; REDDY, GORLA V. ; GIRI, PRIYANKA V. ; KUMAR, NARESH ; MALLA, RAMARAO ; RACHEL, VIJAYA ; BRAMHACHARI, P. VEERA ; REDDY D, RAMA S. ; BADE, RAMESH ; MANNARAPU, MASTAN ; BARRETO, GEORGE E. ; LU, DA-YONG ; TARASOV, VADIM V. ; CHUBAREV, VLADIMIR N. ; RIBEIRO, FREDERICO F. ; SCOTTI, LUCIANA ; SCOTTI, MARCUS T. ; et.al",
          reference: "CURRENT PHARMACEUTICAL DESIGN, v. 23, p. 6321-6346, 2018.",
          doi: "http://dx.doi.org/10.2174/1381612823666170519151801"
        },
        {
          title: "Natural Product Inhibitors of Topoisomerases: Review and Docking Study.",
          authors: "SCOTTI, LUCIANA; BEZERRA MENDONCA, FRANCISCO JAIME ; RIBEIRO, FREDERICO FAVARO ; TAVARES, JOSEAN FECHINE ; DA SILVA, MARCELO SOBRAL ; BARBOSA FILHO, JOSE MARIA ; SCOTTI, MARCUS TULLIUS",
          reference: "CURRENT PROTEIN & PEPTIDE SCIENCE, v. 19, p. 275-291, 2018.",
          doi: "http://dx.doi.org/10.2174/1389203718666170111114442"
        },
        {
          title: "Editorial: Natural Product Inhibitors of Enzymatic Targets in Anticancer Drug Discovery - Part I.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
          reference: "CURRENT PROTEIN & PEPTIDE SCIENCE, v. 19, p. 236-237, 2018. Citações:1",
          doi: "http://dx.doi.org/10.2174/138920371903180104105702"
        },
        {
          title: "Nanoemulsion Thermoreversible Pluronic F127-Based Hydrogel Containing Hyptis pectinata (Lamiaceae) Leaf Essential Oil Produced a Lasting Anti-hyperalgesic Effect in Chronic Noninflammatory Widespread Pain in Mice.",
          authors: "QUINTANS-JÚNIOR, LUCINDO J. ; BRITO, RENAN G. ; QUINTANS, JULLYANA S. S. ; SANTOS, PRISCILA L. ; CAMARGO, ZAINE T. ; BARRETO, PÉRICLES A. ; ARRIGONI-BLANK, MARIA F. ; LUCCA-JÚNIOR, WALDECY ; SCOTTI, LUCIANA ; SCOTTI, MARCUS T. ; KOLKER, SANDRA J. ; SLUKA, KATHLEEN A.",
          reference: "MOLECULAR NEUROBIOLOGY, v. 55, p. 1665-1675, 2018.",
          doi: "http://dx.doi.org/10.1007/s12035-017-0438-1"
        },
        {
          title: "Genetic Mechanisms of Antibiotic Resistance and the Role of Antibiotic Adjuvants.",
          authors: "PONTES, DANIELA SANTOS ; DE ARAUJO, RODRIGO SANTOS AQUINO ; DANTAS, NATALINA ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS ; DE MOURA, RICARDO OLIMPIO ; MENDONCA-JUNIOR, FRANCISCO JAIME BEZERRA",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 18, p. 42-74, 2018.",
          doi: "http://dx.doi.org/10.2174/1568026618666180206095224"
        },
        {
          title: "Molecular Docking Studies Applied to a Dataset of Cruzain Inhibitors.",
          authors: "DA SILVA-JUNIOR, EDEILDO FERREIRA ; BARCELLOS FRANCA, PAULO HENRIQUE ; RIBEIRO, FREDERICO FAVARO ; BEZERRA MENDONCA-JUNIOR, FRANCISCO JAIME ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS ; DE AQUINO, THIAGO MENDONCA ; DE ARAUJO-JUNIOR, JOAO XAVIER",
          reference: "Current Computer-Aided Drug Design, v. 14, p. 68-78, 2018.",
          doi: "http://dx.doi.org/10.2174/1573409913666170519112758"
        },
        {
          title: "Predictive ecotoxicity of MoA 1 of organic chemicals using in silico approaches.",
          authors: "DE MORAIS E SILVA, LUANA ; ALVES, MATEUS FEITOSA ; SCOTTI, LUCIANA ; LOPES, WILTON SILVA ; SCOTTI, MARCUS TULLIUS",
          reference: "ECOTOXICOLOGY AND ENVIRONMENTAL SAFETY, v. 153, p. 151-159, 2018.",
          doi: "http://dx.doi.org/10.1016/j.ecoenv.2018.01.054"
        },
        {
          title: "α-Terpineol reduces cancer pain via modulation of oxidative stress and inhibition of iNOS.",
          authors: "GOUVEIA, DANIELE NASCIMENTO ; COSTA, JANARA SANTOS ; OLIVEIRA, MARLANGE ALMEIDA ; RABELO, THALLITA KELLY ; SILVA, ANA MARA DE OLIVEIRA E ; CARVALHO, ADRIANA ANDRADE ; MIGUEL-DOS- SANTOS, RODRIGO ; LAUTON- SANTOS, SANDRA ; SCOTTI, LUCIANA ; SCOTTI, MARCUS TULLIUS ; SANTOS, MÁRCIO ROBERTO VIANA DOS ; QUINTANS-JÚNIOR, LUCINDO JOSÉ ; ALBUQUERQUE JUNIOR, RICARDO LUIZ CAVALCANTI DE ; GUIMARÃES, ADRIANA GIBARA",
          reference: "BIOMEDICINE & PHARMACOTHERAPY, v. 105, p. 652-661, 2018.",
          doi: "http://dx.doi.org/10.1016/j.biopha.2018.06.027"
        },
        {
          title: "Computer-aided Drug Design Applied to Parkinson Targets.",
          authors: "ISHIKI, HAMILTON M. ; FILHO, JOSE MARIA BARBOSA ; da Silva, Marcelo S. ; Scotti, Marcus T. ; Scotti, Luciana",
          reference: "Current Neuropharmacology, v. 16, p. 865-880, 2018.",
          doi: "http://dx.doi.org/10.2174/1570159x15666171128145423"
        },
        {
          title: "Docking of Natural Products against Neurodegenerative Diseases: General Concepts.",
          authors: "RIBEIRO, FREDERICO FAVARO ; MENDONCA, FRANCISCO JAIME BEZERRA ; GHASEMI, JAHAN B. ; ISHIKI, HAMILTON M ; SCOTTI, Marcus Tullius ; Scotti, Luciana",
          reference: "COMBINATORIAL CHEMISTRY & HIGH THROUGHPUT SCREENING, v. 21, p. 152-160, 2018.",
          doi: "http://dx.doi.org/10.2174/1386207321666180313130314"
        },
        {
          title: "Fragmentation pattern of amides by EI and HRESI: study of protonation sites using DFT-3LYP data.",
          authors: "FOKOUE, H. H. ; Marques, J. V. ; CORREIA, M. V. ; Yamaguchi, L. F. ; QU, X. ; Aires-de-Sousa, J. ; SCOTTI, M. T. ; Lopes, N. P. ; Kato, M. J.",
          reference: "RSC Advances, v. 8, p. 21407-21413, 2018.",
          doi: "http://dx.doi.org/10.1039/c7ra00408g"
        },
        {
          title: "Editorial: In Silico Methodologies Applied to Drug Discovery.",
          authors: "SCOTTI, LUCIANA; GHASEMI, JAHAN ; SCOTTI, MARCUS T.",
          reference: "COMBINATORIAL CHEMISTRY & HIGH THROUGHPUT SCREENING, v. 21, p. 150-151, 2018.",
          doi: "http://dx.doi.org/10.2174/138620732103180423125817"
        },
        {
          title: "Editorial: In Silico Studies in Drug Research Against Neurodegenerative Diseases.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
          reference: "Current Neuropharmacology, v. 16, p. 647-648, 2018.",
          doi: "http://dx.doi.org/10.2174/1570159x1606180608103840"
        },
        {
          title: "Multi-Target Antitubercular Drugs.",
          authors: "DE OLIVEIRA VIANA, JESSIKA ; ISHIKI, HAMILTON MITSUGU ; SCOTTI, Marcus Tullius ; Scotti, Luciana",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 18, p. 750-758, 2018.",
          doi: "http://dx.doi.org/10.2174/1568026618666180528124414"
        },
        {
          title: "New Therapeutic Targets and Drugs for the Treatment of Asthma.",
          authors: "ALVES, MATEUS FEITOSA ; DA FONSECA, DIOGO VILAR ; DE MELO, SILVIA ADELAIDE LINHARES ; SCOTTI, Marcus Tullius ; Scotti, Luciana ; DOS SANTOS, SOCRATES GOLZIO ; DE FATIMA FORMIGA MELO DINIZ, MARGARETH",
          reference: "MINI-REVIEWS IN MEDICINAL CHEMISTRY, v. 18, p. 684-696, 2018.",
          doi: "http://dx.doi.org/10.2174/1389557517666170927145011"
        },
        {
          title: "New thiophene-acridine compounds: Synthesis, antileishmanial activity, DNA binding, chemometric, and molecular docking studies.",
          authors: "DE LIMA SERAFIM, VANESSA ; FÉLIX, MAYARA BARBALHO ; FRADE SILVA, DAIANA KARLA ; RODRIGUES, KLINGER ANTÔNIO DA FRANCA ; ANDRADE, PATRÍCIA NÉRIS ; DE ALMEIDA, SINARA MÔNICA VITALINO ; DE ALBUQUERQUE DOS SANTOS, SANDERSSONILO ; DE OLIVEIRA, JAMERSON FERREIRA ; DE LIMA, MARIA DO CARMO ALVES ; MENDONÇA-JUNIOR, FRANCISCO JAIME BEZERRA ; SCOTTI, Marcus Tullius ; DE OLIVEIRA, MÁRCIA ROSA ; DE MOURA, RICARDO OLÍMPIO",
          reference: "Chemical Biology & Drug Design, v. 91, p. 1141-1155, 2018.",
          doi: "http://dx.doi.org/10.1111/cbdd.13176"
        },
        {
          title: "Perspectives on Infectious Diseases: Progress and Therapeutics.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 18, p. 748-749, 2018.",
          doi: "http://dx.doi.org/10.2174/156802661809180723122350"
        },
        {
          title: "Virtual Screening Studies for Discovery of Novel Inhibitors of Inflammatory Process Targets.",
          authors: "SCOTTI, Marcus Tullius; ALVES, MATEUS FEITOSA ; HERRERA-ACEVEDO, CHONNY ALEXANDER ; Scotti, Luciana",
          reference: "CURRENT PHARMACEUTICAL DESIGN, v. 24, p. 1617-1638, 2018.",
          doi: "http://dx.doi.org/10.2174/1381612824666180403122410"
        },
        {
          title: "Zornioside, a dihydrochalcone C -glycoside, and other compounds from Zornia brasiliensis.",
          authors: "NASCIMENTO, YURI M. ; ABREU, LUCAS S. ; LIMA, RAMON L. ; SILVA, ANNE DAYSE S. ; COSTA, VICENTE CARLOS O. ; MELO, JOSÉ IRANILDO M. ; Scotti, Marcus Tulius ; SOBRAL, MARIANNA V. ; ARAUJO, SILVANY S. ; FILHO, MANOEL ADRIÃO G. ; SILVA, MARCELO S. ; Tavares, Josean F.",
          reference: "Revista Brasileira de Farmacognosia-Brazilian Journal of Pharmacognosy, v. 28, p. 192-197, 2018.",
          doi: "http://dx.doi.org/10.1016/j.bjp.2018.02.003"
        },
        {
          title: "Alcoholic monoterpenes found in essential oil of aromatic spices reduce allergic inflammation by the modulation of inflammatory cytokines.",
          authors: "PINA, LÍCIA T. S. ; FERRO, JAMYLLE N. S. ; RABELO, THALLITA K. ; OLIVEIRA, MARLANGE A. ; SCOTTI, L. ; SCOTTI, Marcus Tullius ; WALKER, CRISTIANI ISABEL BANDERO ; BARRETO, EMILIANO O. ; QUINTANS JÚNIOR, LUCINDO J. ; GUIMARÃES, ADRIANA G.",
          reference: "NATURAL PRODUCT RESEARCH, v. 2018, p. 1-5, 2018.",
          doi: "http://dx.doi.org/10.1080/14786419.2018.1434634"
        },
        {
          title: "Drug discovery and computational strategies in the multitarget drugs era.",
          authors: "VIANA, JÉSSIKA DE OLIVEIRA ; FÉLIX, MAYARA BARBALHO ; MAIA, MAYARA DOS SANTOS ; SERAFIM, VANESSA DE LIMA ; SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "BRAZILIAN JOURNAL OF PHARMACEUTICAL SCIENCES (ONLINE), v. 54, p. 129-157, 2018.",
          doi: "http://dx.doi.org/10.1590/s2175-97902018000001010"
        },
        {
          title: "Chemical constituents from Paliavana tenuiflora Mansf. (Gesneriaceae).",
          authors: "SALES, KAIO ARAGÃO ; FERREIRA DA SILVA, EVANDRO ; RAMALHO DE FIGUEIREDO, PEDRO THIAGO ; CARLOS DE O. COSTA, VICENTE ; SCOTTI, Marcus Tullius ; de Fátima Agra, Maria ; Tavares, Josean Fechine ; SILVA, M. S.",
          reference: "BIOCHEMICAL SYSTEMATICS AND ECOLOGY, v. 80, p. 76-80, 2018.",
          doi: "http://dx.doi.org/10.1016/j.bse.2018.07.002"
        },
        {
          title: "Computational Studies Applied to Anti-inflammatory Drug Discovery: A Review.",
          authors: "SCOTTI, LUCIANA; ISHIKI, HAMILTON M. ; RIBEIRO, FREDERICO F. ; SANTOS, RODRIGO ; DE OLIVEIRA, REJANE BARBOSA ; Oliveira, Tiago Branquinho ; ALVES, MATEUS FEITOSA ; FILHO, JOSE MARIA BARBOSA ; SCOTTI, MARCUS TULLIUS",
          reference: "CURRENT ORGANIC CHEMISTRY, v. 22, p. 1673-1689, 2018.",
          doi: "http://dx.doi.org/10.2174/1385272822666180906122934"
        },
        {
          title: "Inflammatory Diseases - New Compounds and Treatments.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
          reference: "CURRENT ORGANIC CHEMISTRY, v. 22, p. 1661-1662, 2018.",
          doi: "http://dx.doi.org/10.2174/138527282217181015113559"
        },
        {
          title: "Dengue Virus Inhibition Targets: A Review and Docking Study.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS TULLIUS ; Yarla, Nagendra Sastry ; MONTEIRO, ALEX FRANCE MESSIAS ; DE OLIVEIRA VIANA, JESSIKA ; DANTZGER, DERLI RANIERI COSTA ; ISHIKI, HAMILTON MITSUGU",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 18, p. 1522-1530, 2018.",
          doi: "http://dx.doi.org/10.2174/1568026618666181025111605"
        },
        {
          title: "Recent Advancement against Neglected Diseases.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS TULLIUS ; Yarla, Nagendra Sastry",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 18, p. 1520-1521, 2018.",
          doi: "http://dx.doi.org/10.2174/156802661818181119142905"
        },
        {
          title: "Computational Studies Applied to Flavonoids against Alzheimer's and Parkinson's Diseases.",
          authors: "MONTEIRO, ALEX FRANCE M. ; VIANA, JÉSSIKA DE O. ; NAYARISSERI, ANURAJ ; ZONDEGOUMBA, ERNESTINE N. ; MENDONÇA JUNIOR, FRANCISCO JAIME B. ; SCOTTI, Marcus Tullius ; Scotti, Luciana",
          reference: "Oxidative Medicine and Cellular Longevity, v. 2018, p. 1-21, 2018.",
          doi: "http://dx.doi.org/10.1155/2018/7912765"
        },
        {
          title: "Virtual screening of secondary metabolites of the genus Solanum with potential antimicrobial activity.",
          authors: "BARROS, RENATA PRISCILA COSTA ; CUNHA, EMIDIO VASCONCELOS LEITÃO DA ; CATÃO, RAÏSSA MAYER RAMALHO ; SCOTTI, LUCIANA ; SOUZA, MARIA SALLETT ROCHA ; BRÁS, AMANDA AMONA QUEIROZ ; SCOTTI, MARCUS TULLIUS",
          reference: "Revista Brasileira de Farmacognosia-Brazilian Journal of Pharmacognosy, v. 28, p. 686-691, 2018.",
          doi: "http://dx.doi.org/10.1016/j.bjp.2018.08.003"
        },
        {
          title: "Editorial; Natural Product Inhibitors of Enzymatic Targets in Anticancer Drug Discovery - Part II.",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T.",
          reference: "CURRENT PROTEIN & PEPTIDE SCIENCE, v. 19, p. 342-342, 2018.",
          doi: "http://dx.doi.org/10.2174/138920371904180213111017"
        },
        {
          title: "Computational Studies in Drug Design against Cancer.",
          authors: "DE, BAISHAKHI ; BHANDARI, KOUSHIK ; Mendonça, Francisco J. B. ; SCOTTI, Marcus Tullius ; Scotti, Luciana",
          reference: "Anti-Cancer Agents in Medicinal Chemistry, v. 18, p. 587-591, 2018.",
          doi: "http://dx.doi.org/10.2174/1871520618666180911125700"
        },
        {
          title: "Multi-Target Drugs Against Metabolic Disorders.",
          authors: "SCOTTI, LUCIANA; MONTEIRO, ALEX FRANCE MESSIAS ; DE OLIVEIRA VIANA, JESSIKA ; MENDONCA, FRANCISCO JAIME BEZERRA ; ISHIKI, HAMILTON M. ; TCHOUBOUN, ERNESTINE NKWENGOUA ; SANTOS, RODRIGO ; SCOTTI, MARCUS TULLIUS",
          reference: "Endocrine Metabolic & Immune Disorders-Drug Targets, v. 19, p. 402-418, 2018.",
          doi: "http://dx.doi.org/10.2174/1871530319666181217123357"
        },
        {
          title: "Biochemical Mechanisms and Therapeutic Strategies in Gastrointestinal and Metabolic Disorders.",
          authors: "GUNDAMARAJU, ROHIT ; VEMURI, RAVICHANDRA ; ERI, RAJARAMAN ; SCOTTI, LUICIANA ; SCOTTI, MARCUS",
          reference: "CURRENT PHARMACEUTICAL DESIGN, v. 24, p. 3153-3154, 2018.",
          doi: "http://dx.doi.org/10.2174/138161282427181126124808"
        },
        {
          title: "Computational and Metabolic Studies on a Set of N-Myristoyltransferase Inhibitors Against Trypanosoma Brucei.",
          authors: "SCOTTI, L. ; Hamilton M. Ishiki ; MENDONCA JUNIOR, F. J. B. ; FAVARO, F. ; SASTRYYARLA, N. ; SILVA, MS ; BARBOSA-FILHO, J. M. ; SCOTTI, Marcus Tullius",
          reference: "INTERNATIONAL JOURNAL OF QUANTITATIVE STRUCTURE-PROPERTY RELATIONSHIPS, v. 3, p. 80-94, 2018.",
          doi: "http://dx.doi.org/10.4018/ijqspr.2018070106"
        }
      ],
    },
    {
      year: 2017,
      list: [
        {
          title: "Improvement of Solubility and Antifungal Activity of a New Aminothiophene Derivative by Complexation with 2-Hydroxypropyl-β-cyclodextrin.",
          authors: "ELEAMEN, GIOVANNA R. A. ; COSTA, SILVANA C. DA ; Lima-Neto, Reginaldo G. ; Neves, Rejane P. ; ROLIM, LARISSA A. ; ROLIM-NETO, PEDRO J. ; MOURA, RICARDO O. ; AQUINO, THIAGO M. DE ; BENTO, EDSON S. ; SCOTTI, Marcus Tullius ; MENDONCA JUNIOR, FJB ; MENDONÇA, ELISANGELA A. M. ; OLIVEIRA, ELQUIO E.",
          reference: "Journal of the Brazilian Chemical Society (Impresso), v. 28, p. 116-128, 2017.",
          doi: "http://dx.doi.org/10.5935/0103-5053.20160153"
        },
        {
          title: "Computer-Aided Drug Design Using Sesquiterpene Lactones as Sources of New Structures with Potential Activity against Infectious Neglected Diseases.",
          authors: "HERRERA ACEVEDO, CHONNY ; SCOTTI, Luciana ; FEITOSA ALVES, MATEUS ; FORMIGA MELO DINIZ, MARGARETH ; SCOTTI, MARCUS",
          reference: "Molecules (Basel. Online), v. 22, p. 79, 2017.",
          doi: "http://dx.doi.org/10.3390/molecules22010079"
        },
        {
          title: "EDITORIAL (Thematic Issue : Hybrid Compounds as Multitarget Agents in Medicinal Chemistry - Part I).",
          authors: "SCOTTI, Luciana ; MENDONCA-JUNIOR, FRANCISCO ; SCOTTI, MARCUS",
          reference: "Current Topics in Medicinal Chemistry (Print), v. 17, p. 843-844, 2017.",
          doi: "http://dx.doi.org/10.2174/156802661708170126200430"
        },
        {
          title: "Editorial: Multi-Target in Computer-Aided Drug Design Studies.",
          authors: "SCOTTI, Luciana ; SCOTTI, MARCUS",
          reference: "Current Drug Targets (Print), v. 18, p. 498-499, 2017.",
          doi: "http://dx.doi.org/10.2174/138945011805170224223532"
        },
        {
          title: "Polyphenols rich Passiflora leschenaultii leaves modulating Farnesoid X Receptor and Pregnane X Receptor against paracetamol-induced hepatotoxicity in rats.",
          authors: "SHANMUGAM, SARAVANAN ; SIVARAJ, DHIVYA ; DOS SANTOS LIMA, BRUNO ; DOS PASSOS MENEZES, PAULA ; DE CARVALHO, YASMIM MARIA BARBOSA GOMES ; DE SOUZA ARAÚJO, ADRIANO ANTUNES ; NARAIN, NARENDRA ; SERAFINI, MAIRIM RUSSO ; QUINTANS JÚNIOR, LUCINDO JOSÉ ; SCOTTI, Luciana ; Scotti, Marcus Tulius ; PARIMELAZHAGAN, THANGARAJ",
          reference: "Biomedicine & Pharmacotherapy, v. 88, p. 1114-1121, 2017.",
          doi: "http://dx.doi.org/10.1016/j.biopha.2017.01.156"
        },
        {
          title: "Docking Studies for Multi-Target Drugs.",
          authors: "SCOTTI, LUCIANA ; MENDONCA JUNIOR, FRANCISCO ; ISHIKI, HAMILTON ; RIBEIRO, FREDERICO ; SINGLA, RAJEEV ; BARBOSA-FILHO, J.M. ; SILVA, MARCELO ; SCOTTI, Marcus Tullius",
          reference: "CURRENT DRUG TARGETS, v. 18, p. 592-604, 2017.",
          doi: "http://dx.doi.org/10.2174/1389450116666150825111818"
        },
        {
          title: "Hybrid Compounds as Direct Multitarget Ligands: A Review.",
          authors: "OLIVEIRA PEDROSA, MICHELLE ; DUARTE DA CRUZ, RAYSSA ; OLIVEIRA VIANA, JESSIKA ; DE MOURA, RICARDO ; ISHIKI, HAMILTON ; BARBOSA-FILHO, J.M. ; DINIZ, MARGARETH ; SCOTTI, Marcus Tullius ; SCOTTI, LUCIANA ; BEZERRA MENDONCA, FRANCISCO",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 17, p. 1044-1079, 2017. ",
          doi: "http://dx.doi.org/10.2174/1568026616666160927160620"
        },
        {
          title: "Editorial (Thematic Issue: Hybrid Compounds as Multitarget Agents in Medicinal Chemistry - Part II).",
          authors: "Scotti, Luciana ; MENDONÇA-JUNIOR, FRANCISCO ; SCOTTI, MARCUS",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 17, p. 957-958, 2017.",
          doi: "http://dx.doi.org/10.2174/156802661709170213205211"
        },
        {
          title: "Phenolics metabolism provides a tool for screening drought tolerant Eucalyptus grandis hybrids.",
          authors: "DIAS, CLARICE ; PICOLLI, E. A. T. ; SOUZA, G. A. ; FARAG, M. A. ; SCOTTI, Marcus Tullius ; M, B. F. J. ; SILVA, M. S. ; TAVARES, J. F.",
          reference: "AUST J CROP SCI, v. 11, p. 1016-1025, 2017.",
          doi: "http://dx.doi.org/10.21475/ajcs.17.11.08.pne511"
        },
        {
          title: "Metabolomics as a Functional Tool in Screening Gastro Intestinal Diseases: Where are we in High Throughput Screening?.",
          authors: "GUNDAMARAJU, ROHIT ; VEMURI, RAVICHANDRA ; ERI, RAJARAMAN ; ISHIKI, HAMILTON M. ; COY-BARRERA, ERICSSON ; YARLA, NAGENDRA SASTRY ; DOS SANTOS, SÓCRATES GOLZIO ; ALVES, MATEUS FEITOSA ; BARBOSA FILHO, JOSÉ MARIA ; DINIZ, MARGARETH F. F. M. ; SCOTTI, MARCUS T. ; SCOTTI, Luciana",
          reference: "COMBINATORIAL CHEMISTRY & HIGH THROUGHPUT SCREENING, v. 20, p. 247-254, 2017. Citações:5|5",
          doi: "http://dx.doi.org/10.2174/1386207319666161220122903"
        },
        {
          title: "Editorial (Thematic Issue: Identification of Lead Compounds Using Metabolomic Analysis in Drug Discovery).",
          authors: "SCOTTI, LUCIANA; SCOTTI, MARCUS T. ; COY-BARRERA, ERICSSON",
          reference: "COMBINATORIAL CHEMISTRY & HIGH THROUGHPUT SCREENING, v. 20, p. 184-185, 2017.",
          doi: "http://dx.doi.org/10.2174/138620732003170607162843"
        },
        {
          title: "Flavonoids as Multi-Target Compounds in Drug Discovery.",
          authors: "SCOTTI, L. ; ISHIKI, H. ; MENDONCA, F.J.B. ; CRUZ, R.M.D. ; TAVARES, J.F. ; DINIZ, M.F.F.M. ; FILHO, J.M. BARBOSA ; SCOTTI, M.T.",
          reference: "MINI-REVIEWS IN ORGANIC CHEMISTRY, v. 14, p. 333-341, 2017. Citações:2|3",
          doi: "http://dx.doi.org/10.2174/1570193x14666170518112248"
        },
        {
          title: "Editorial: Polypharmacology of Natural Products.",
          authors: "SCOTTI, LUCIANA; JAIME BEZERRA MENDONÇA JUNIOR, FRANCISCO ; SCOTTI, MARCUS T.",
          reference: "MINI-REVIEWS IN ORGANIC CHEMISTRY, v. 14, p. 255-256, 2017.",
          doi: "http://dx.doi.org/10.2174/1570193x1404170822155702"
        },
        {
          title: "Secondary Metabolites from Cissampelos, A Possible Source for New Leads with Anti-Inflammatory Activity.",
          authors: "ALVES, MATEUS F. ; Scotti, Marcus T. ; SCOTTI, Luciana ; MENDONÇA, FRANCISCO JAIME BEZERRA ; FILHO, JOSÉ M. B. ; DE MELO, SÍLVIA A. L. ; DOS SANTOS, SÓCRATES G. ; DE F.F.M. DINIZ, MARGARETH",
          reference: "CURRENT MEDICINAL CHEMISTRY, v. 24, p. 1629-1644, 2017. Citações:7|9",
          doi: "http://dx.doi.org/10.2174/0929867323666161227123411"
        },
        {
          title: "Editorial: Research and Selection of Multitarget Compounds in Medicinal Chemistry.",
          authors: "SCOTTI, LUCIANA; JAIME BEZERRA MENDONÇA, FRANCISCO ; SCOTTI, MARCUS T.",
          reference: "CURRENT MEDICINAL CHEMISTRY, v. 24, p. 1627-1628, 2017. Citações:5|5",
          doi: "http://dx.doi.org/10.2174/092986732416170704114736"
        },
        {
          title: "Momordicacharantia: A New Strategic Vision to Improve the Therapy of Endoplasmic Reticulum Stress.",
          authors: "CHONG, WAI CHIN ; GUNDAMARAJU, ROHIT ; VEMURI, RAVICHANDRA ; Scotti, Marcus T. ; SCOTTI, Luciana",
          reference: "CURRENT PHARMACEUTICAL DESIGN, v. 23, p. 2333-2343, 2017. Citações:5|8",
          doi: "http://dx.doi.org/10.2174/1381612823666170124141104"
        },
        {
          title: "Editorial: Theoretical Studies of the Metabolism in Drug Discovery.",
          authors: "SCOTTI, MARCUS T.; SCOTTI, Luciana",
          reference: "CURRENT DRUG METABOLISM, v. 18, p. 498-499, 2017. Citações:2|1",
          doi: "http://dx.doi.org/10.2174/138920021806170721113611"
        },
        {
          title: "Dynamic Simulation, Docking and DFT Studies Applied to a Set of Anti-Acetylcholinesterase Inhibitors in the enzyme β-Secretase (BACE-1): An Important Therapeutic Target in Alzheimer's Disease.",
          authors: "SILVA-JÚNIOR, EDEILDO ; FRANÇA, PAULO ; QUINTAS-JÚNIOR, LUCINDO ; MENDONÇA-JUNIOR, FRANCISCO ; SCOTTI, LUCIANA ; SCOTTI, MARCUS ; DE AQUINO, THIAGO ; ARAÚJO-JÚNIOR, JOÃO",
          reference: "Current Computer-Aided Drug Design, v. 13, p. 1-1, 2017. Citações:21|19",
          doi: "http://dx.doi.org/10.2174/1573409913666170406150905"
        },
        {
          title: "Anti-hyperalgesic effect of Lippia grata leaf essential oil complexed with β-cyclodextrin in a chronic musculoskeletal pain animal model: Complemented with a molecular docking and antioxidant screening.",
          authors: "SIQUEIRA-LIMA, POLLYANA S. ; BRITO, RENAN G. ; ARAÚJO-FILHO, HEITOR G. ; SANTOS, PRISCILA L. ; LUCCHESI, ANGÉLICA ; ARAÚJO, ADRIANO A.S. ; MENEZES, PAULA P. ; SCOTTI, LUCIANA ; SCOTTI, MARCUS T. ; MENEZES, IRWIN R.A. ; COUTINHO, HENRIQUE D.M. ; ZENGIN, GOKHAN ; AKTUMSEK, ABDURRAHMAN ; ANTONIOLLI, ANGELO R. ; QUINTANS-JÚNIOR, LUCINDO J. ; QUINTANS, JULLYANA S.S.",
          reference: "BIOMEDICINE & PHARMACOTHERAPY, v. 91, p. 739-747, 2017. Citações:26|26",
          doi: "http://dx.doi.org/10.1016/j.biopha.2017.05.009"
        },
        {
          title: "Docking, characterization and investigation of β-cyclodextrin complexed with farnesol, an acyclic sesquiterpene alcohol, produces orofacial antinociceptive profile in experimental protocols.",
          authors: "SILVA, JULIANE CABRAL ; DE MORAES ALCANTARA, LIDIANNE FÁBIA ; DIAS SOARES, JULIANA MIKAELLY ; E SILVA, MARIANA GAMA ; DE LAVOR, ÉRICA MARTINS ; ANDRADE, VALLÉRIA MATOS ; DOS PASSOS MENEZES, PAULA ; DE SOUZA ARAÚJO, ADRIANO ANTUNES ; LEITE, LAURA HÉVILA INOCÊNCIO ; DE MENEZES, IRWIN ROSE ALENCAR ; SCOTTI, LUCIANA ; SCOTTI, MARCUS T. ; OLIVEIRA, RITA C.M. ; QUINTANS, JULLYANA S.S. ; SILVA ALMEIDA, JACKSON ROBERTO GUEDES ; QUINTANS-JÚNIOR, LUCINDO JOSÉ",
          reference: "PROCESS BIOCHEMISTRY, v. 62, p. 193-204, 2017.",
          doi: "http://dx.doi.org/10.1016/j.procbio.2017.07.022"
        },
        {
          title: "Diabetes mellitus and male aging: Pharmacotherapeutics and clinical implications.",
          authors: "PUTTA, SWATHI ; PELUSO, ILARIA ; YARLA, NAGENDRA SASTRY ; KILARI, ESWAR KUMAR ; BISHAYEE, ANUPAM ; LU, DA-YONG ; BARRETO, GEORGE E. ; ASHRAF, GHULAM MD ; SCOTTI, LUCIANA ; SCOTTI, MARCUS T. ; et al.",
          reference: "CURRENT PHARMACEUTICAL DESIGN, v. 23, p. 4475-4483, 2017. Citações:11|10",
          doi: "http://dx.doi.org/10.2174/1381612823666170823103830"
        },
        {
          title: "Computational Chemistry Study of Natural Alkaloids and Homemade Databank to Predict Inhibitory Potential Against Key Enzymes in Neurodegenerative Diseases.",
          authors: "LORENZO, VITOR PRATES ; ALVES, MATEUS FEITOSA ; SCOTTI, LUCIANA ; DOS SANTOS, SOCRATES GOLZIO ; DE FATIMA FORMIGA MELO DINIZ, MARGARETH ; SCOTTI, MARCUS TULLIUS",
          reference: "CURRENT TOPICS IN MEDICINAL CHEMISTRY, v. 17, p. 2926-2934, 2017. Citações:8|7",
          doi: "http://dx.doi.org/10.2174/1568026617666170821150538"
        },
        {
          title: "Characterization of leaf extracts of Schinus terebinthifolius raddi by GC-MS and chemometric analysis.",
          authors: "SOARES, LUIZA. L. ; CARNEIRO, FABÍOLAB ; LOPES, PABLOQ ; RAMALHO, RICARDOC ; SCOTTI, MARCUST ; SANTOS, SÓCRATESG",
          reference: "Pharmacognosy Magazine, v. 13, p. 672-675, 2017. Citações:7|7",
          doi: "http://dx.doi.org/10.4103/pm.pm_555_16"
        },
        {
          title: "A Química de Produtos Naturais do Brasil no Século XXI.",
          authors: "BORGES, WARLEY DE SOUSA ; BERLINCK, ROBERTO G. S. ; Scotti, Marcus T. ; VIEIRA, PAULO CEZAR",
          reference: "QUÍMICA NOVA (ONLINE), v. 40, p. 706-710, 2017. Citações:16",
          doi: "http://dx.doi.org/10.21577/0100-4042.20170070"
        },
        {
          title: "Anxiolytic Effect of Citrus aurantium L. in Crack Users.",
          authors: "CHAVES NETO, GABRIEL ; BRAGA, JOÃO EUCLIDES FERNANDES ; ALVES, MATEUS FEITOSA ; DE MORAIS PORDEUS, LIANA CLÉBIA ; SANTOS, SÓCRATES GOLZIO DOS ; SCOTTI, Marcus Tullius ; ALMEIDA, REINALDO N. ; DINIZ, MARGARETH DE FÁTIMA FORMIGA MELO",
          reference: "EVIDENCE-BASED COMPLEMENTARY AND ALTERNATIVE MEDICINE (ONLINE), v. 2017, p. 1-8, 2017. Citações:12|19",
          doi: "http://dx.doi.org/10.1155/2017/7217619"
        },
        {
          title: "Electrochemical monitoring of ROS generation by anticancer agents: the case of chartreusin.",
          authors: "DOMÉNECH-CARBÓ, ANTONIO ; CEBRIÁN-TORREJÓN, GERARDO ; MONTOYA, NOEMÍ ; UEBERSCHAAR, NICO ; SCOTTI, Marcus Tullius ; BENFODDA, ZOHRA ; HERTWECK, CHRISTIAN",
          reference: "RSC Advances, v. 7, p. 45200-45210, 2017. Citações:9|8",
          doi: "http://dx.doi.org/10.1039/C7RA08238J"
        },
        {
          title: "Chemical Composition, Antifungal and Antioxidant Activities of Hedyosmum brasiliense Mart. ex Miq. (Chloranthaceae) Essential Oils.",
          authors: "MURAKAMI, CYNTHIA ; CORDEIRO, INÊS ; SCOTTI, MARCUS ; MORENO, PAULO ; YOUNG, MARIA",
          reference: "Medicines, v. 4, p. 55, 2017.",
          doi: "http://dx.doi.org/10.3390/medicines4030055"
        },
        {
          title: "Preventive and Therapeutic potentials of Anthocyanins in diabetes and associated complications.",
          authors: "PUTTA, SWATHI ; YARLA, NAGENDRA SASTRY ; KUMAR, ESWAR K. ; LAKKAPPA, DHANANJAYA BHADRAPURA ; KAMAL, MOHAMMAD A. ; SCOTTI, LUCIANA ; SCOTTI, MARCUS T. ; et al.",
          reference: "CURRENT MEDICINAL CHEMISTRY, v. 25, p. 5347-5371, 2017. Citações:43|49",
          doi: "http://dx.doi.org/10.2174/0929867325666171206101945"
        },
        {
          title: "Toxicological evaluation in silico and in vivo of secondary metabolites of Cissampelos sympodialis in Mus musculus mice following inhalation.",
          authors: "ALVES, MATEUS FEITOSA ; FERREIRA, LARISSA ADILIS MARIA PAIVA ; GADELHA, FRANCISCO ALLYSSON ASSIS FERREIRA ; FERREIRA, LAÉRCIA KARLA DIEGA PAIVA ; FELIX, MAYARA BARBALHO ; SCOTTI, Marcus Tullius ; Scotti, Luciana ; DE OLIVEIRA, KARDILÂNDIA MENDES ; DOS SANTOS, SÓCRATES GOLZIO ; DINIZ, Margareth de Fátima Formiga Melo",
          reference: "NATURAL PRODUCTS RESEARCH, v. 36, p. 1-7, 2017. Citações:3|2",
          doi: "http://dx.doi.org/10.1080/14786419.2017.1410805"
        },
        {
          title: "Molecular Modeling and Physicochemical Properties of Supramolecular Complexes of Limonene with α- and β-Cyclodextrins.",
          authors: "DOS PASSOS MENEZES, PAULA ; DOS SANTOS, POLLIANA BARBOSA PEREIRA ; DÓRIA, GRACE ANNE AZEVEDO ; DE SOUSA, BRUNA MARIA HIPÓLITO ; SERAFINI, MAIRIM RUSSO ; NUNES, PAULA SANTOS ; QUINTANS-JÚNIOR, LUCINDO JOSÉ ; DE MATOS, IARA LISBOA ; ALVES, PÉRICLES BARRETO ; BEZERRA, DANIEL PEREIRA ; et al.",
          reference: "AAPS PharmSciTech, v. 18, p. 49-57, 2017. Citações:29|30",
          doi: "http://dx.doi.org/10.1208/s12249-016-0516-0"
        }
      ],
    },
    {
      year: 2016,
      list: [
        {
          title: "Multi-Target Drugs for Neglected Diseases.",
          authors: "SCOTTI, Luciana ; MENDONCA JUNIOR, FJB ; Moura. R. O. ; ISHIKI, Hamilton Mitsugo ; RIBEIRO, F. F. ; SILVA, M.S. ; BARBOSA FILHO, JOSÉ MARIA ; SCOTTI, Marcus Tullius",
          reference: "Current Pharmaceutical Design (Print), v. 22, p. 3135-3163, 2016. Citações:18|19",
          doi: "http://dx.doi.org/10.2174/1381612822666160224142552"
        },
        {
          title: "Editorial (Thematic Issue: Polypharmacology in Drug Discovery).",
          authors: "Scotti, Luciana ; SCOTTI, Marcus Tullius",
          reference: "Current Pharmaceutical Design (Print), v. 22, p. 3071-3072, 2016.",
          doi: "http://dx.doi.org/10.2174/1381612822999160405113658"
        },
        {
          title: "Structure- and ligand-based approaches to evaluate aporphynic alkaloids from Annonaceae as multi-target agent against Leishmania donovani.",
          authors: "LORENZO, VITOR PRATES ; LUCIO, A. S. S. C. ; SCOTTI, Luciana ; Tavares, J. F. ; BARBOSA FILHO, J. M. ; CLEMENTE, T. K. S. L. ; ROCHA, J. C. ; SCOTTI, Marcus Tullius",
          reference: "Current Pharmaceutical Design (Print), v. 22, p. 1-1, 2016. Citações:31|29",
          doi: "http://dx.doi.org/10.2174/1381612822666160513144853"
        },
        {
          title: "Editorial (Thematic Issue: Enzymatic Studies in Medicinal Chemistry of Neglected Diseases).",
          authors: "Scotti, Luciana ; SCOTTI, MARCUS",
          reference: "Current Protein and Peptide Science, v. 17, p. 210-212, 2016.",
          doi: "http://dx.doi.org/10.2174/138920371703160310165331"
        },
        {
          title: "Enzymatic Targets in Trypanosoma brucei.",
          authors: "Scotti, Luciana ; J.B. MENDONÇA, FRANCISCO ; S. DA SILVA, MARCELO ; T. SCOTTI, MARCUS",
          reference: "Current Protein and Peptide Science, v. 17, p. 243-259, 2016. Citações:15|15",
          doi: "http://dx.doi.org/10.2174/1389203717999160226173754"
        },
        {
          title: "Editorial (Thematic Issue: Medicinal Chemistry Applied to Natural Products in Neglected Drug Discovery).",
          authors: "SCOTTI, L. ; SCOTTI, Marcus Tullius ; MENDONCA JUNIOR, FJB",
          reference: "Combinatorial Chemistry & High Throughput Screening, v. 19, p. 514-515, 2016.",
          doi: "http://dx.doi.org/10.2174/138620731907160712181908"
        },
        {
          title: "Variability in essential oil composition produced by micropropagated (in vitro), acclimated (ex vitro) and in-field plants of Ocimum basilicum (Lamiaceae).",
          authors: "AMARAL-BAROLI, ADRIANA ; LAGO, JOÃO HENRIQUE G. ; DE ALMEIDA, CRISTINA V. ; DE ALMEIDA, MARCÍLIO ; SCOTTI, Marcus Tullius ; LEONE, GABRIELA F. ; SOARES, MARISI G. ; CAVALARI, ALINE A. ; SARTORELLI, PATRICIA",
          reference: "Industrial Crops and Products (Print), v. 86, p. 180-185, 2016. Citações:12|12",
          doi: "http://dx.doi.org/10.1016/j.indcrop.2016.03.048"
        },
        {
          title: "Docking and physico-chemical properties of α- and β-cyclodextrin complex containing isopulegol: a comparative study.",
          authors: "DOS PASSOS MENEZES, PAULA ; DÓRIA, GRACE ANNE AZEVEDO ; DE SOUZA ARAÚJO, ADRIANO ANTUNES ; SOUSA, BRUNA MARIA HIPÓLITO ; QUINTANS-JÚNIOR, LUCINDO JOSÉ ; LIMA, RAFAELY NASCIMENTO ; ALVES, PÉRICLES BARRETO ; CARVALHO, FLÁVIO MACHADO SOUZA ; BEZERRA, DANIEL PEREIRA ; MENDONÇA-JÚNIOR, FRANCISCO JAIME BEZERRA ; SCOTTI, Luciana ; SCOTTI, Marcus Tullius ; DA SILVA, GABRIEL FRANCISCO ; DE AQUINO, THIAGO MENDONÇA ; SABINO, ADILSON RODRIGUES ; DO EGITO, ERYVALDO SOCRATES TABOSA ; SERAFINI, MAIRIM RUSSO",
          reference: "Journal of Inclusion Phenomena and Macrocyclic Chemistry (Online), v. 85, p. 341-354, 2016. Citações:15|16",
          doi: "http://dx.doi.org/10.1007/s10847-016-0633-0"
        },
        {
          title: "Recent Advancement in Natural Hyaluronidase Inhibitors.",
          authors: "SCOTTI, Luciana ; SINGLA, RAJEEV ; ISHIKI, Hamilton ; MENDONCA, FRANCISCO ; DA SILVA, MARCELO ; BARBOSA FILHO, JOSÉ ; SCOTTI, Marcus",
          reference: "Current Topics in Medicinal Chemistry (Print), v. 16, p. 2525-2531, 2016. Citações:19|22",
          doi: "http://dx.doi.org/10.2174/1568026616666160414123857"
        },
        {
          title: "α-Terpineol, a monoterpene alcohol, complexed with β-cyclodextrin exerts antihyperalgesic effect in animal model for fibromyalgia aided with docking study.",
          authors: "OLIVEIRA, MAKSON G.B. ; BRITO, RENAN G. ; SANTOS, PRISCILA L. ; ARAÚJO-FILHO, HEITOR G. ; QUINTANS, JULLYANA S.S. ; MENEZES, PAULA P. ; SERAFINI, MAIRIM R. ; CARVALHO, YASMIM M.B.G. ; SILVA, JULIANE C. ; ALMEIDA, JACKSON R.G.S. ; SCOTTI, Luciana ; Scotti, Marcus T. ; SHANMUGAM, SARAVANAN ; THANGARAJ, PARIMELAZHAGAN ; ARAÚJO, ADRIANO A.S. ; QUINTANS-JÚNIOR, LUCINDO J.",
          reference: "Chemico-Biological Interactions (Print), v. 254, p. 54-62, 2016. Citações:54|55",
          doi: "http://dx.doi.org/10.1016/j.cbi.2016.05.029"
        },
        {
          title: "Theoretical Study of Phosphoethanolamine: A Synthetic Anticancer Agent with Broad Antitumor Activity.",
          authors: "LORENZO, VITOR PRATES ; FILHO, JOSÉ MARIA BARBOSA ; SCOTTI, Luciana ; SCOTTI, Marcus Tullius",
          reference: "Journal of Chemistry, v. 2016, p. 1-8, 2016. Citações:1|1",
          doi: "http://dx.doi.org/10.1155/2016/4068641"
        },
        {
          title: "Characterization and Antihypertensive Effect of the Complex of (-)-β- pinene in β-cyclodextrin.",
          authors: "MOREIRA, ITALO ; MENEZES, PAULA ; SERAFINI, MAIRIM ; ARAÚJO, ADRIANO ; QUINTANS-JÚNIOR, LUCINDO ; BONJARDIM, LEONARDO ; FILHO, VALTER ; JÚNIOR, DANIEL ; SANTOS, SANDRA ; JÚNIOR, WALDECY ; SCOTTI, Luciana ; SCOTTI, MARCUS ; SANTOS, MÁRCIO",
          reference: "Current Pharmaceutical Biotechnology (Print), v. 17, p. 837-845, 2016. Citações:17|18",
          doi: "http://dx.doi.org/10.2174/1389201017666160425115724"
        },
        {
          title: "Natural Products as a Source for antileishmanial and antitrypanosomal Agents.",
          authors: "SCOTTI, MARCUS; SCOTTI, Luciana ; ISHIKI, Hamilton ; RIBEIRO, FREDERICO ; DA CRUZ, RAYSSA ; DE OLIVEIRA, MICHELLE ; MENDONÇA JUNIOR, FRANCISCO",
          reference: "Combinatorial Chemistry & High Throughput Screening, v. 19, p. 1-1, 2016. Citações:25",
          doi: "http://dx.doi.org/10.2174/1386207319666160506123921"
        },
        {
          title: "Modulation of Drug Resistance in with Coumarin Derivatives.",
          authors: "DE ARAÚJO, RODRIGO SANTOS AQUINO ; BARBOSA-FILHO, JOSÉ MARIA ; SCOTTI, Marcus Tullius ; SCOTTI, Luciana ; CRUZ, RYLDENE MARQUES DUARTE DA ; FALCÃO-SILVA, VIVYANNE DOS SANTOS ; SIQUEIRA-JÚNIOR, JOSÉ PINTO DE ; MENDONÇA-JUNIOR, FRANCISCO JAIME BEZERRA",
          reference: "Scientifica, v. 2016, p. 1-6, 2016. Citações:13|32",
          doi: "http://dx.doi.org/10.1155/2016/6894758"
        },
        {
          title: "Variable-selection approaches to generate QSAR models for a set of antichagasic semicarbazones and analogues.",
          authors: "SCOTTI, Marcus Tullius; SCOTTI, Luciana ; ISHIKI, HAMILTON MITSUGU ; PERON, LETICIA M. ; DE REZENDE, LEANDRO ; DO AMARAL, ANTONIA TAVARES",
          reference: "Chemometrics and Intelligent Laboratory Systems (Print), v. 154, p. 137-149, 2016. Citações:32|34",
          doi: "http://dx.doi.org/10.1016/j.chemolab.2016.03.023"
        },
        {
          title: "Kinetic and physical-chemical study of the inclusion complex of β-cyclodextrin containing carvacrol.",
          authors: "MENEZES, PAULA DOS PASSOS ; SERAFINI, MAIRIM RUSSO ; CARVALHO, YASMIM MARIA BARBOSA GOMES DE ; SOARES SANTANA, DAYANNE VALÉRIA ; LIMA, BRUNO SANTOS ; QUINTANS-JÚNIOR, LUCINDO JOSÉ ; MARRETO, RICARDO NEVES ; AQUINO, THIAGO MENDONÇA DE ; SABINO, ADILSON RODRIGUES ; SCOTTI, Luciana ; SCOTTI, Marcus Tullius ; GRANGEIRO-JÚNIOR, SEVERINO ; SOUZA ARAÚJO, ADRIANO ANTUNES DE",
          reference: "Journal of Molecular Structure (Print), p. 323-330, 2016. Citações:34|31",
          doi: "http://dx.doi.org/10.1016/j.molstruc.2016.06.062"
        },
        {
          title: "Antileishmanial Activity of new Thiophene-indole Hybrids: Design, Synthesis, Biological and Cytotoxic Evaluation, and Chemometric Studies.",
          authors: "FÉLIX, MAYARA B. ; DE SOUZA, EDSON R. ; DE LIMA, MARIA DO C.A. ; FRADE, DAIANA KARLA G. ; SERAFIM, VANESSA DE L. ; RODRIGUES, KLINGER ANTONIO DA F. ; NÉRIS, PATRÍCIA LIMA DO N. ; RIBEIRO, FREDERICO F. ; SCOTTI, Luciana ; Scotti, Marcus T. ; DE AQUINO, THIAGO M. ; MENDONÇA-JUNIOR, FRANCISCO JAIME B. ; DE OLIVEIRA, MÁRCIA R.",
          reference: "Bioorganic & Medicinal Chemistry (Print), v. 24, p. 3972-3977, 2016. Citações:43|48",
          doi: "http://dx.doi.org/10.1016/j.bmc.2016.04.057"
        },
        {
          title: "Editorial (Thematic Issue: Natural Leads in Drug Discovery against Metabolic Disorders and their Related Infectious Diseases).",
          authors: "SCOTTI, Luciana ; SINGLA, RAJEEV ; SCOTTI, MARCUS",
          reference: "Current Topics in Medicinal Chemistry (Print), v. 16, p. 2523-2524, 2016. Citações:2|2",
          doi: "http://dx.doi.org/10.2174/1568026616999160510121418"
        },
        {
          title: "Brazoxide A, a New Tirucallane Triterpene from subsp. Kaastra.",
          authors: "MADEIRO, SARA A. L. ; COSTA, VICENTE CARLOS O. ; DUARTE, SUSYANNE L. F. ; CUNHA, CAROLINE P. DA ; Scotti, Marcus T. ; AGRA, MARIA DE FÁTIMA ; BRAZ-FILHO, RAIMUNDO ; SILVA, MARCELO S. DA ; TAVARES, JOSEAN F.",
          reference: "Revista Virtual de Química, v. 8, p. 196-203, 2016.",
          doi: "http://dx.doi.org/10.5935/1984-6835.20160013"
        },
        {
          title: "Design, synthesis, molecular docking and biological evaluation of thiophen-2-iminothiazolidine derivatives for use against Trypanosoma cruzi.",
          authors: "SILVA-JÚNIOR, E.F. ; SILVA, E.P.S. ; FRANÇA, P.H.B. ; SILVA, J.P.N. ; BARRETO, E.O. ; SILVA, E.B. ; FERREIRA, R.S. ; GATTO, C.C. ; MOREIRA, D.R.M. ; SIQUEIRA-NETO, J.L. ; MENDONÇA-JÚNIOR, F.J.B. ; LIMA, M.C.A. ; BORTOLUZZI, J.H. ; SCOTTI, M.T. ; SCOTTI, L. ; MENEGHETTI, M.R. ; AQUINO, T.M. ; ARAÚJO-JÚNIOR, J.X.",
          reference: "Bioorganic & Medicinal Chemistry (Print), v. 24, p. 4228-4240, 2016. Citações:43|44",
          doi: "http://dx.doi.org/10.1016/j.bmc.2016.07.013"
        },
        {
          title: "Perspectives in Medicinal Chemistry.",
          authors: "MIKHAILOV, SERGEY ; SCOTTI, Luciana ; SINGLA, RAJEEV ; SCOTTI, MARCUS",
          reference: "Current Topics in Medicinal Chemistry (Print), v. 16, p. 2725-2726, 2016. Citações:6|6",
          doi: "http://dx.doi.org/10.2174/156802661625160816180839"
        },
        {
          title: "Synthesis, Antifungal Evaluation and In Silico Study of N-(4-Halobenzyl)amides.",
          authors: "MONTES, RICARDO ; PEREZ, ANA ; MEDEIROS, CÁSSIO ; ARAÚJO, MARIANNA ; LIMA, EDELTRUDES ; SCOTTI, MARCUS ; SOUSA, DAMIÃO",
          reference: "MOLECULES, v. 21, p. 1716, 2016. Citações:12|12",
          doi: "http://dx.doi.org/10.3390/molecules21121716"
        }
      ]
    },
    {
      year: 2015,
      list: [
        {
          title: "Computational and Investigative Study of Flavonoids Active Against Trypanosoma cruzi and Leishmania spp.",
          authors: "RIBEIRO, F. F. ; MENDONCA JUNIOR, FJB ; SILVA, M. S. ; SCOTTI, Marcus Tullius ; SCOTTI, L.",
          reference: "Natural Product Communications, v. 10, p. 917-920, 2015. Citações:20",
          doi: "http://dx.doi.org/10.2174/138955751503150312115541"
        },
        {
          title: "Editorial (Thematic Issue: Medicinal Chemistry Studies of Neglected Diseases).",
          authors: "SCOTTI, L. ; SCOTTI, Marcus Tullius",
          reference: "Mini-Reviews in Medical Chemistry, v. 15, p. 180-181, 2015.",
          doi: "http://dx.doi.org/10.2174/138955751503150312141854"
        },
        {
          title: "In-silico Analyses of Natural Products on Leishmania Enzyme Targets.",
          authors: "SCOTTI, L. ; ISHIKI, H. ; MENDONCA, F.J.B. ; SILVA, M.S. ; SCOTTI, M.T.",
          reference: "Mini-Reviews in Medical Chemistry, v. 15, p. 253-269, 2015.",
          doi: "http://dx.doi.org/10.2174/1389557515666150219125030"
        },
        {
          title: "Benzo- and Thienobenzo- Diazepines: Multi-target Drugs for CNS Disorders.",
          authors: "SCOTTI, L. ; ISHIKI, H. ; MENDONCA, F.J.B. ; SILVA, M.S. ; SCOTTI, M.T.",
          reference: "Mini-Reviews in Medical Chemistry, v. 15, p. 253-269, 2015.",
          doi: "http://dx.doi.org/10.2174/1389557515666150219125030"
        },
        {
          title: "Benzo- and Thienobenzo- Diazepines: Multi-target Drugs for CNS Disorders.",
          authors: "JUNIOR, F.J.B. ; SCOTTI, L. ; ISHIKI, H. ; BOTELHO, S.P.S. ; SILVA, M.S. ; SCOTTI, M.T.",
          reference: "Mini-Reviews in Medical Chemistry, v. 15, p. 630-647, 2015. Citações:35|36",
          doi: "http://dx.doi.org/10.2174/1568026615666150610143510"
        },
  
        {
          title: "Computer Aided Drug Design Studies in the Discovery of Secondary Metabolites Targeted Against Age-Related Neurodegenerative Diseases.",
          authors: "SCOTTI, Luciana ; SCOTTI, Marcus Tullius",
          reference: "Current Topics in Medicinal Chemistry (Print), v. 15, p. 2239-2252, 2015. Citações:29|31",
          doi: "http://dx.doi.org/10.2174/1386207318666150803141219"
        },
  
        {
          title: "Artificial Neural Network Methods Applied to Drug Discovery for Neglected Diseases.",
          authors: "Scotti, Luciana ; ISHIKI, Hamilton ; JAIME BEZERRA MENDONÇA JUNIOR, FRANCISCO ; SILVA, M. S. ; SCOTTI, Marcus Tullius",
          reference: "Combinatorial Chemistry & High Throughput Screening, v. 18, p. 819-829, 2015. Citações:10|11",
          doi: "http://dx.doi.org/10.2174/138620731808150904121214"
        },
  
        {
          title: "Editorial (Thematic Issue: Chemometrics in Drug Discovery).",
          authors: "SCOTTI, MARCUS; Scotti, Luciana",
          reference: "Combinatorial Chemistry & High Throughput Screening, v. 18, p. 702-703, 2015. Citações:4|5",
          doi: "http://dx.doi.org/10.1016/j.ejmech.2015.10.011"
        },
  
        {
          title: "2-Amino-thiophene derivatives present antileishmanial activity mediated by apoptosis and immunomodulation in vitro.",
          authors: "RODRIGUES, KLINGER ANTONIO DA FRANCA ; DIAS, CÍNTHIA NÓBREGA DE SOUSA ; NÉRIS, PATRÍCIA LIMA DO NASCIMENTO ; ROCHA, JULIANA DA CÂMARA ; SCOTTI, Marcus Tullius ; SCOTTI, L. ; MASCARENHAS, SANDRA RODRIGUES ; VERAS, ROBSON CAVALCANTE ; MEDEIROS, ISAC ALMEIDA DE ; KEESEN, TATJANA DE SOUZA LIMA ; OLIVEIRA, TIAGO BENTO DE ; LIMA, MARIA DO CARMO ALVES DE ; BALLIANO, TATIANE LUCIANO ; AQUINO, THIAGO MENDONÇA DE ; MOURA, RICARDO OLÍMPIO DE ; MENDONÇA JUNIOR, FRANCISCO JAIME BEZERRA ; OLIVEIRA, MÁRCIA ROSA DE",
          reference: "European Journal of Medicinal Chemistry, v. 106, p. 1-14, 2015. Citações:64|66",
          doi: "http://dx.doi.org/10.1016/j.molstruc.2015.08.042"
        },
  
        {
          title: "Experimental and theorical study of possible correlation between the electrochemistry of canthin-6-one and the anti-proliferative activity against human cancer stem cells.",
          authors: "CEBRIÁN-TORREJÓN, G. ; DOMÉNECH-CARBÓ, A. ; SCOTTI, M.T. ; FOURNET, A. ; FIGADÈRE, B. ; POUPON, E.",
          reference: "Journal of Molecular Structure (Print), v. 1102, p. 242-246, 2015. Citações:12|13",
          doi: "http://dx.doi.org/10.2174/1574893610666151008011042"
        },
  
        {
          title: "Virtual Screening of Alkaloids from Apocynaceae with Potential Antitrypanosomal Activity.",
          authors: "SCOTTI, MARCUS; SPECK-PLANCHE, Alejandro ; TAVARES, JOSEAN ; DA SILVA, MARCELO ; D. S. CORDEIRO, M. ; Scotti, Luciana",
          reference: "Current Bioinformatics (Print), v. 10, p. 509-519, 2015. Citações:15|12",
          doi: "http://dx.doi.org/10.1016/j.bjp.2015.08.005"
        },
  
        {
          title: "Combined structure- and ligand-based virtual screening to evaluate caulerpin analogs with potential inhibitory activity against monoamine oxidase B.",
           authors: "LORENZO, VITOR PRATES ; BARBOSA FILHO, JOSÉ MARIA ; Scotti, Luciana ; SCOTTI, Marcus Tullius",
          reference: "Revista Brasileira de Farmacognosia (Impresso), v. 25, p. 5205-5216, 2015.",
          doi: "http://dx.doi.org/10.3390/molecules19045205"
        }
      ]
    },
    {
      year: 2014,
      list: [
        {
          title: "A Benzoic Acid Derivative and Flavokawains from Piper species as Schistosomiasis Vector Controls.",
          authors: "RAPADO, LUDMILA ; FREITAS, GIOVANA ; POLPO, ADRIANO ; ROJAS-CARDOZO, MARITZA ; RINCÓN, JAVIER ; SCOTTI, MARCUS ; KATO, MASSUO ; NAKANO, ELIANA ; YAMAGUCHI, LYDIA",
          reference: "Molecules (Basel. Online), v. 19, p. 5205-5218, 2014.",
          doi: "http://dx.doi.org/10.3390/molecules19055761"
        },
        {
          title: "Antiparasitic Activity of Natural and Semi-Synthetic Tirucallane Triterpenoids from Schinus terebinthifolius (Anacardiaceae): Structure/Activity Relationships.",
          authors: "MORAIS, THIAGO ; DA COSTA-SILVA, THAIS ; TEMPONE, ANDRE ; BORBOREMA, SAMANTA ; SCOTTI, MARCUS ; DE SOUSA, RAQUEL ; ARAUJO, ANA ; DE OLIVEIRA, ALBERTO ; DE MORAIS, SÉRGIO ; SARTORELLI, PATRICIA ; LAGO, JOÃO",
          reference: "Molecules (Basel. Online), v. 19, p. 5761-5776, 2014.",
          doi: "http://dx.doi.org/10.2174/15734064113099990005"
        },
        {
          title: "Chemometric Studies on Potential Larvicidal Compounds Against Aedes Aegypti.",
          authors: "SCOTTI, Luciana ; SCOTTI, MARCUS ; SILVA, VIVIANE ; SANTOS, SANDRA ; CAVALCANTI, SÓCRATES ; JUNIOR, FRANCISCO",
          reference: "Medicinal Chemistry (Hilversum), v. 10, p. 201-210, 2014.",
          doi: "http://dx.doi.org/10.2478/acph-2014-0016"
        },
        {
          title: "Synthesis and preliminary ex vivo evaluation of the spasmolytic activity of 1,3-thiazolium- and 1,3,4-thiadiazolium-5-methylthio- and 5-thioacetate derivatives.",
          authors: "LUIS, JOSÉ A. S. ; AQUINO, THIAGO M. DE ; LIRA, BRUNO F. ; FILHO, PETRÔNIO F. A. ; Scotti, Marcus T. ; Scotti, Luciana ; MOURA, RICARDO O. DE ; JUNIOR, FRANCISCO J. B. MENDONÇA",
          reference: "Acta Pharmaceutica, v. 64, p. 233-245, 2014.",
          doi: "http://dx.doi.org/10.2478/acph-2014-0016"
        },
        {
          title: "Evidence for the involvement of descending pain-inhibitory mechanisms in the attenuation of cancer pain by carvacrol aided through a docking study.",
          authors: "GUIMARÃES, ADRIANA G. ; Scotti, Luciana ; SCOTTI, Marcus Tullius ; MENDONÇA JÚNIOR, FRANCISCO J.B. ; MELO, NAYARA S.R. ; ALVES, RAFAEL S. ; DE LUCCA JÚNIOR, WALDECY ; BEZERRA, DANIEL P. ; GELAIN, DANIEL P. ; QUINTANS JÚNIOR, LUCINDO J.",
          reference: "Life Sciences (1973), v. 116, p. 8-15, 2014.",
          doi: "http://dx.doi.org/10.1016/j.lfs.2014.08.020"
        }
      ]
    },
    {
      year: 2013,
      list: [
        {
          title: "Synthesis, Structure-Activity Relationships (SAR) and in Silico Studies of Coumarin Derivatives with Antifungal Activity.",
          authors: "DE ARAÚJO, RODRIGO ; GUERRA, FELIPE ; DE O. LIMA, EDELTRUDES ; DE SIMONE, CARLOS ; TAVARES, JOSEAN ; Scotti, Luciana ; SCOTTI, MARCUS ; DE AQUINO, THIAGO ; DE MOURA, RICARDO ; MENDONÇA, FRANCISCO ; BARBOSA-FILHO, JOSÉ",
          reference: "International Journal of Molecular Sciences (Online), v. 14, p. 1293-1309, 2013. Citações:47",
          doi: "http://dx.doi.org/10.3390/ijms14011293"
        },
        {
          title: "Schistosomiasis Control Using Piplartine against Biomphalaria glabrata at Different Developmental Stages.",
          authors: "RAPADO, LUDMILA NAKAMURA ; PINHEIRO, ALESSANDRO DE SÁ ; LOPES, PRISCILA ORECHIO DE MORAES VICTOR ; FOKOUE, HAROLD HILARION ; SCOTTI, Marcus Tullius ; MARQUES, JOAQUIM VOGT ; OHLWEILER, FERNANDA PIRES ; BORRELY, SUELI IVONE ; PEREIRA, CARLOS ALBERTO DE BRAGANÇA ; KATO, MASSUO JORGE ; NAKANO, ELIANA ; YAMAGUCHI, LYDIA FUMIKO",
          reference: "PLoS Neglected Tropical Diseases (Online), v. 7, p. e2251, 2013. Citações:29",
          doi: "http://dx.doi.org/10.1371/journal.pntd.0002251"
        },
        {
          title: "3D-QSAR Methodologies and Molecular Modeling in Bioinformatics for the Search of Novel Anti-HIV Therapies: Rational Design of Entry Inhibitors.",
          authors: "SPECK-PLANCHE, Alejandro ; KLEANDROVA, VALERIA ; SCOTTI, MARCUS ; CORDEIRO, M.",
          reference: "Current Bioinformatics (Print), v. 8, p. 452-464, 2013. Citações:19",
          doi: "http://dx.doi.org/10.2174/1574893611308040007"
        },
        {
          title: "Docking and PLS Studies on a Set of Thiophenes RNA Polymerase Inhibitors Against Staphylococcus aureus.",
          authors: "SCOTTI, Luciana ; LIMA, EDELTRUDES ; DA SILVA, MARCELO ; ISHIKI, Hamilton ; OLIVEIRA LIMA, IGARA ; OLIVEIRA PEREIRA, FILLIPE ; MENDONÇA JUNIOR, FRANCISCO ; SCOTTI, MARCUS",
          reference: "Current Topics in Medicinal Chemistry (Print), v. 14, p. 64-80, 2013. Citações:13",
          doi: "http://dx.doi.org/10.2174/1568026613666131113151347"
        },
        {
          title: "SAR, QSAR and Docking of Anticancer Flavonoids and Variants: A Review.",
          authors: "Scotti, Luciana ; JAIME BEZERRA MENDONCA JUNIOR, FRANCISCO ; RODRIGO MAGALHAES MOREIRA, DIOGO ; Sobral da Silva, Marcelo ; R. PITTA, IVAN ; Tullius Scotti, Marcus",
          reference: "Current Topics in Medicinal Chemistry (Print), v. 12, p. 2785-2809, 2013. Citações:59",
          doi: "http://dx.doi.org/10.2174/1568026611212240007"
        },
        {
          title: "Editorial (Thematic Issue: Nosocomial Infections: An Increasing Challenge to Medicinal Chemistry).",
          authors: "SCOTTI, MARCUS; CORDEIRO, M. N. ; SPECK-PLANCHE, Alejandro",
          reference: "Current Topics in Medicinal Chemistry (Print), v. 14, p. 2-3, 2013. Citações:1",
          doi: "http://dx.doi.org/10.2174/1568026613666131111101521"
        },
        {
          title: "Editorial (Thematic Issue: Current Tendencies in Antimicrobial Research: Medicinal Chemistry of Antibacterial Agents and Advances in the Use of Computational Methodologies).",
          authors: "SCOTTI, MARCUS; CORDEIRO, M. N. ; SPECK-PLANCHE, Alejandro",
          reference: "Current Topics in Medicinal Chemistry (Print), v. 13, p. 3011-3012, 2013.",
          doi: "http://dx.doi.org/10.2174/15680266113136660216"
        },
        {
          title: "Biochemical Changes Evidenced in Alzheimer's Disease: A Mini-Review.",
          authors: "Scotti, Luciana ; JAIME BEZERRA MENDONÇA JUNIOR, FRANCISCO ; SILVA, M. S. ; R. PITTA, IVAN ; SCOTTI, Marcus Tullius",
          reference: "Letters in Drug Design & Discovery, v. 11, p. 240-248, 2013.",
          doi: "http://dx.doi.org/10.2174/15701808113109990063"
        }
      ]
    },
    {
      year: 2012,
      list: [
        {
          title: "Self-organizing maps as a good tool for classification of subfamily Astereoideae.",
          authors: "Mauro Vicentini Correia ; SCOTTI, Luciana ; FOKOUE, H. H. ; FERREIRA, Marcelo J P ; SCOTTI, Marcus Tullius ; ALVARENGA, Sandra A V ; RODRIGUES, Gilberto V ; EMERENCIANO, Vicente de Paulo",
          reference: "Journal of Medicinal Plant Research, v. 6, p. 1207-1218, 2012.",
          doi: "http://dx.doi.org/10.5897/JMPR11.942"
        },
        {
          title: "Comparative Computational Studies of 3,4-Dihydro-2,6-diaryl-4-oxo-pyrimidine-5-carbonitrile Derivatives as Potential Antinociceptive Agents.",
          authors: "Anjos, Janaína V. dos ; Srivastava, Rajendra M. ; Costa-Silva, João H. ; SCOTTI, Luciana ; Scotti, Marcus T. ; Wanderley, Almir G. ; Leite, Elisa Soares ; Melo, Sebastião J. de ; Junior, Francisco J. B. Mendonça",
          reference: "Molecules (Basel. Online), v. 17, p. 809-819, 2012. Citações:19",
          doi: "http://dx.doi.org/10.3390/molecules17010809"
        },
        {
          title: "Experimental Methodologies and Evaluations of Computer-Aided Drug Design Methodologies Applied to a Series of 2-Aminothiophene Derivatives with Antifungal Activities.",
          authors: "SCOTTI, Luciana ; Tullius Scotti, Marcus ; de Oliveira Lima, Edeltrudes ; Sobral da Silva, Marcelo ; do Carmo Alves de Lima, Maria ; da Rocha Pitta, Ivan ; Olímpio de Moura, Ricardo ; Gonzaga Batista de Oliveira, Jaismary ; Duarte da Cruz, Rayssa Marques ; Bezerra Mendonça, Francisco Jaime",
          reference: "Molecules (Basel. Online), v. 17, p. 2298-2315, 2012. Citações:30",
          doi: "http://dx.doi.org/10.3390/molecules17032298"
        },
        {
          title: "Fragment-based approach for the in silico discovery of multi-target insecticides.",
          authors: "SPECK-PLANCHE, Alejandro ; Kleandrova, Valeria V. ; Scotti, Marcus T.",
          reference: "Chemometrics and Intelligent Laboratory Systems (Print), v. 111, p. 39-45, 2012. Citações:47",
          doi: "http://dx.doi.org/10.1016/j.chemolab.2011.11.010"
        },
        {
          title: "Caco-2 cells cytotoxicity of nifuroxazide derivatives with potential activity against Methicillin-resistant Staphylococcus aureus (MRSA).",
          authors: "Fernandes, Mariane B. ; Gonçalves, José E. ; Scotti, Marcus T. ; de Oliveira, Alex A. ; Tavares, Leoberto C. ; Storpirtis, Sílvia",
          reference: "Toxicology in Vitro, v. 26, p. 535-540, 2012. Citações:16",
          doi: "http://dx.doi.org/10.1016/j.tiv.2012.01.018"
        },
        {
          title: "Self-Organizing Maps of Molecular Descriptors for Sesquiterpene Lactones and Their Application to the Chemotaxonomy of the Asteraceae Family.",
          authors: "Scotti, Marcus T.; Emerenciano, Vicente ; Ferreira, Marcelo J. P. ; SCOTTI, Luciana ; STEFANI, Ricardo ; da Silva, Marcelo S. ; Junior, Francisco Jaime B. Mendonça",
          reference: "Molecules (Basel. Online), v. 17, p. 4684-4702, 2012. Citações:31",
          doi: "http://dx.doi.org/10.3390/molecules17044684"
        },
        {
          title: "The Potential of Secondary Metabolites from Plants as Drugs or Leads Against Protozoan Neglected Diseases - Part II.",
          authors: "Schmidt, J. ; Khalid S. A. ; Romanha, A. J. ; de Almeida Alves, T. M. ; Biavatti, M. W. ; Brun, R. ; da Costa, F. B. ; Lisboa de Castro, S. ; Ferreira, V. F. ; de Lacerda M.V.G. ; LAGO, João H. G ; Leon, L. L. ; Lopes, N. P. ; das Neves Amorim, R. C. ; Niehues, M. ; Ogungbe, I. V. ; Pohlit, A. M. ; SCOTTI, Marcus Tullius ; Setzer, W. N. ; Soeiro, M. N. C. ; et.al",
          reference: "Current Medicinal Chemistry, v. 19, p. 2176-2228, 2012. Citações:172",
          doi: "http://dx.doi.org/10.2174/092986712800229087"
        },
        {
          title: "The Potential of Secondary Metabolites from Plants as Drugs or Leads Against Protozoan Neglected Diseases - Part I.",
          authors: "Schmidt, J ; Khalid S. A. ; Romanha, A. J. ; de Almeida Alves, T. M. ; Biavatti, M. W. ; Brun, R. ; da Costa, F. B. ; Lisboa de Castro, S. ; Ferreira, V. F. ; de Lacerda M.V.G. ; LAGO, João H. G ; Leon, L. ; Lopes, N. P. ; das Neves Amorim, R. C. ; Niehues, M. ; Ogungbe, I. V. ; Pohlit, A. M. ; SCOTTI, Marcus Tullius ; Setzer, W. N. ; Soeiro, M. N. C. ; et.al",
          reference: "Current Medicinal Chemistry, v. 19, p. 2128-2175, 2012. Citações:171",
          doi: "http://dx.doi.org/10.2174/092986712800229023"
        },
        {
          title: "Chemotaxonomy of three genera of the Annonaceae family using self-organizing maps and 13C NMR data of diterpenes.",
          authors: "Scotti, Luciana ; Tavares, J. F. ; da Silva, Marcelo S. ; FALCÃO, E. ; Morais, L. ; SOARES, G. C. S. ; SCOTTI, Marcus Tullius",
          reference: "Química Nova (Impresso), v. 35, p. 2245-2250, 2012.",
          doi: "http://dx.doi.org/10.1590/S0100-40422012001100008"
        }
      ]
    },
    {
      year: 2011,
      list: [
        {
          title: "Volsurf Descriptors to Analyse Anti-HCV and Cytotoxic Activities of Sesquiterpene Lactones from Asteraceae Family.",
          authors: "Ballerini Fernandes, Mariane ; Rossini, Michelle ; STEFANI, Ricardo ; Tavares, Leoberto ; de Paulo Emerenciano, Vicente ; SCOTTI, Luciana ; Sobral da Silva, Marcelo ; Tullius Scotti, Marcus",
          reference: "Letters in Drug Design & Discovery, v. 8, p. 44-58, 2011.",
          doi: "http://dx.doi.org/10.2174/157018011793663868"
        },
        {
          title: "Self-organizing maps and VolSurf approach to predict aldose reductase inhibition by flavonoid compounds.",
          authors: "SCOTTI, Luciana ; Fernandes, Mariane B. ; Muramatsu, Eric ; Pasqualoto, Kerly F. M. ; Emereciano, Vicente de P. ; Tavares, Leoberto C. ; Silva, Marcelo Sobral da ; Scotti, Marcus T.",
          reference: "Revista Brasileira de Farmacognosia (Impresso), v. 21, p. 170-180, 2011.",
          doi: "http://dx.doi.org/10.1590/S0102-695X2011005000028"
        }
      ]
    },
    {
      year: 2010,
      list: [
        {
          title: "Designing novel antitrypanosomal agents from a mixed graph-theoretical substructural approach.",
          authors: "Planche, Alejandro Speck ; Scotti, Marcus Tulius ; EMERENCIANO, Vicente de Paulo ; López, América García ; Pérez, Enrique Molina ; Uriarte, Eugenio",
          reference: "Journal of Computational Chemistry, v. 31, p. 882-894, 2010.",
          doi: "http://dx.doi.org/10.1002/jcc.21374"
        },
        {
          title: "Anti-leishmanial and anti-trypanosomal activities of 1,4-dihydropyridines: In vitro evaluation and structure–activity relationship study.",
          authors: "Reimão, Juliana Q. ; Scotti, Marcus T. ; Tempone, André G.",
          reference: "Bioorganic & Medicinal Chemistry (Print), v. 18, p. 8044-8053, 2010.",
          doi: "http://dx.doi.org/10.1016/j.bmc.2010.09.015"
        },
        {
          title: "Current Pharmaceutical Design of Antituberculosis Drugs: Future Perspectives.",
          authors: "SPECK-PLANCHE, Alejandro ; SCOTTI, Marcus Tullius ; EMERENCIANO, Vicente de Paulo",
          reference: "Current Pharmaceutical Design (Print), v. 16, p. 2656-2665, 2010.",
          doi: "http://dx.doi.org/10.2174/138161210792389289"
        },
        {
          title: "Chemometric Studies on Natural Products as Potential Inhibitors of the NADH Oxidase from Trypanosoma cruzi Using the VolSurf Approach.",
          authors: "SCOTTI, Luciana ; FERREIRA, Elizabeth Igne ; Silva, Marcelo Sobral da ; SCOTTI, Marcus Tullius",
          reference: "Molecules (Basel. Online), v. 15, p. 7363-7377, 2010.",
          doi: "http://dx.doi.org/10.3390/molecules15107363"
        }
      ]
    },
    {
      year: 2009,
      list: [
        {
          title: "Design of novel antituberculosis compounds using graph-theoretical and substructural approaches.",
          authors: "Planche, Alejandro Speck ; Scotti, Marcus Tulius ; López, América García ; Paulo Emerenciano, Vicente ; Pérez, Enrique Molina ; Uriarte, Eugenio",
          reference: "Molecular Diversity, v. 13, p. 445-458, 2009.",
          doi: "http://dx.doi.org/10.1007/s11030-009-9129-9"
        }
      ]
    },
    {
      year: 2008,
      list: [
        {
          title: "Use of self-organizing maps and molecular descriptors to predict the cytotoxic activity of sesquiterpene lactones.",
          authors: "FERNANDES, M ; SCOTTI, M ; FERREIRA, M ; EMERENCIANO, V",
          reference: "European Journal of Medicinal Chemistry, v. 43, p. 2197-2205, 2008.",
          doi: "http://dx.doi.org/10.1016/j.ejmech.2008.01.003"
        }
      ]
    },
    {
      year: 2007,
      list: [
        {
          title: "Quantitative structure activity relationship of sesquiterpene lactones with cytotoxic activity.",
          authors: "SCOTTI, Marcus Tullius; FERNANDES, Mariane B ; FERREIRA, Marcelo J P ; EMERENCIANO, Vicente de Paulo",
          reference: "Bioorganic & Medicinal Chemistry, Estados Unidos, v. 15, n.8, p. 2927-2934, 2007. Citações:99|101",
          doi: "http://dx.doi.org/10.1016/j.bmc.2007.02.005"
        },
        {
          title: "Quantitative elucidation of the structure–bitterness relationship of cynaropicrin and grosheimin derivatives.",
          authors: "SCOTTI, Luciana ; SCOTTI, Marcus Tullius ; ISHIKI, Hamilton Mitsugo ; FERREIRA, Marcelo J P ; EMERENCIANO, Vicente de Paulo ; MENEZES, Carla Maria de ; FERREIRA, Elizabeth Igne",
          reference: "Food Chemistry, v. 115, p. 77-83, 2007.",
          doi: "http://dx.doi.org/10.1016/j.foodchem.2007.03.038"
        },
        {
          title: "Modelagem molecular aplicada ao desenvolvimento de moléculas com atividade antioxidante visando ao uso cosmético.",
          authors: "Scotti, Luciana ; SCOTTI, Marcus Tullius ; CARDOSO, C.L. ; Pauletti, Patrícia ; Castro-Gamboa, Ian ; BOLZANI, Vanderlan da Silva ; Velasco, Maria Valéria Robles ; Menezes, Carla Maria de Souza ; Ferreira, Elizabeth Igne",
          reference: "RBCF. Revista Brasileira de Ciências Farmacêuticas (Cessou em 2008. Cont. ISSN 1984-8250 Brazilian Journal of Pharmaceutical Sciences), v. 43, p. 153, 2007.",
          doi: "http://dx.doi.org/10.1590/s1516-93322007000200002"
        }
      ]
    },
    {
      year: 2006,
      list: [
        {
          title: "Automatic identification of terpenoid skeletons by feed-forward neural networks.",
          authors: "EMERENCIANO, Vicente de Paulo ; ALVARENGA, Sandra A V ; SCOTTI, Marcus Tullius ; FERREIRA, Marcelo J P ; STEFANI, Ricardo ; NUZILLARD, Jean Marc",
          reference: "Analytica Chimica Acta (Print), v. 579, n.2, p. 217-226, 2006.",
          doi: "http://dx.doi.org/10.1016/j.aca.2006.07.023"
        }
      ]
    }
  ];
